import { computed as Q, provide as Zt, resolveComponent as Ft, createElementBlock as re, openBlock as ue, Fragment as Bt, createCommentVNode as ge, createElementVNode as H, mergeProps as Qn, unref as M, createVNode as me, toDisplayString as Qe, normalizeStyle as Z, renderSlot as Zn, createTextVNode as Jn, inject as tt, normalizeClass as fe, renderList as Ur, h as Kn } from "vue";
function je(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Xn(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function u() {
      return this instanceof u ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(u) {
    var i = Object.getOwnPropertyDescriptor(e, u);
    Object.defineProperty(r, u, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[u];
      }
    });
  }), r;
}
var Mt = { exports: {} }, ei = Mt.exports, Zr;
function Je() {
  return Zr || (Zr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(ei, function() {
      var r = 1e3, u = 6e4, i = 36e5, c = "millisecond", a = "second", l = "minute", d = "hour", o = "day", f = "week", p = "month", n = "quarter", s = "year", m = "date", b = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, v = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(L) {
        var E = ["th", "st", "nd", "rd"], C = L % 100;
        return "[" + L + (E[(C - 20) % 10] || E[C] || E[0]) + "]";
      } }, x = function(L, E, C) {
        var R = String(L);
        return !R || R.length >= E ? L : "" + Array(E + 1 - R.length).join(C) + L;
      }, _ = { s: x, z: function(L) {
        var E = -L.utcOffset(), C = Math.abs(E), R = Math.floor(C / 60), q = C % 60;
        return (E <= 0 ? "+" : "-") + x(R, 2, "0") + ":" + x(q, 2, "0");
      }, m: function L(E, C) {
        if (E.date() < C.date()) return -L(C, E);
        var R = 12 * (C.year() - E.year()) + (C.month() - E.month()), q = E.clone().add(R, p), F = C - q < 0, z = E.clone().add(R + (F ? -1 : 1), p);
        return +(-(R + (C - q) / (F ? q - z : z - q)) || 0);
      }, a: function(L) {
        return L < 0 ? Math.ceil(L) || 0 : Math.floor(L);
      }, p: function(L) {
        return { M: p, y: s, w: f, d: o, D: m, h: d, m: l, s: a, ms: c, Q: n }[L] || String(L || "").toLowerCase().replace(/s$/, "");
      }, u: function(L) {
        return L === void 0;
      } }, y = "en", w = {};
      w[y] = v;
      var S = "$isDayjsObject", k = function(L) {
        return L instanceof A || !(!L || !L[S]);
      }, $ = function L(E, C, R) {
        var q;
        if (!E) return y;
        if (typeof E == "string") {
          var F = E.toLowerCase();
          w[F] && (q = F), C && (w[F] = C, q = F);
          var z = E.split("-");
          if (!q && z.length > 1) return L(z[0]);
        } else {
          var O = E.name;
          w[O] = E, q = O;
        }
        return !R && q && (y = q), q || !R && y;
      }, D = function(L, E) {
        if (k(L)) return L.clone();
        var C = typeof E == "object" ? E : {};
        return C.date = L, C.args = arguments, new A(C);
      }, T = _;
      T.l = $, T.i = k, T.w = function(L, E) {
        return D(L, { locale: E.$L, utc: E.$u, x: E.$x, $offset: E.$offset });
      };
      var A = function() {
        function L(C) {
          this.$L = $(C.locale, null, !0), this.parse(C), this.$x = this.$x || C.x || {}, this[S] = !0;
        }
        var E = L.prototype;
        return E.parse = function(C) {
          this.$d = function(R) {
            var q = R.date, F = R.utc;
            if (q === null) return /* @__PURE__ */ new Date(NaN);
            if (T.u(q)) return /* @__PURE__ */ new Date();
            if (q instanceof Date) return new Date(q);
            if (typeof q == "string" && !/Z$/i.test(q)) {
              var z = q.match(g);
              if (z) {
                var O = z[2] - 1 || 0, N = (z[7] || "0").substring(0, 3);
                return F ? new Date(Date.UTC(z[1], O, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, N)) : new Date(z[1], O, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, N);
              }
            }
            return new Date(q);
          }(C), this.init();
        }, E.init = function() {
          var C = this.$d;
          this.$y = C.getFullYear(), this.$M = C.getMonth(), this.$D = C.getDate(), this.$W = C.getDay(), this.$H = C.getHours(), this.$m = C.getMinutes(), this.$s = C.getSeconds(), this.$ms = C.getMilliseconds();
        }, E.$utils = function() {
          return T;
        }, E.isValid = function() {
          return this.$d.toString() !== b;
        }, E.isSame = function(C, R) {
          var q = D(C);
          return this.startOf(R) <= q && q <= this.endOf(R);
        }, E.isAfter = function(C, R) {
          return D(C) < this.startOf(R);
        }, E.isBefore = function(C, R) {
          return this.endOf(R) < D(C);
        }, E.$g = function(C, R, q) {
          return T.u(C) ? this[R] : this.set(q, C);
        }, E.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, E.valueOf = function() {
          return this.$d.getTime();
        }, E.startOf = function(C, R) {
          var q = this, F = !!T.u(R) || R, z = T.p(C), O = function(be, oe) {
            var I = T.w(q.$u ? Date.UTC(q.$y, oe, be) : new Date(q.$y, oe, be), q);
            return F ? I : I.endOf(o);
          }, N = function(be, oe) {
            return T.w(q.toDate()[be].apply(q.toDate("s"), (F ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(oe)), q);
          }, U = this.$W, V = this.$M, W = this.$D, ne = "set" + (this.$u ? "UTC" : "");
          switch (z) {
            case s:
              return F ? O(1, 0) : O(31, 11);
            case p:
              return F ? O(1, V) : O(0, V + 1);
            case f:
              var se = this.$locale().weekStart || 0, de = (U < se ? U + 7 : U) - se;
              return O(F ? W - de : W + (6 - de), V);
            case o:
            case m:
              return N(ne + "Hours", 0);
            case d:
              return N(ne + "Minutes", 1);
            case l:
              return N(ne + "Seconds", 2);
            case a:
              return N(ne + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, E.endOf = function(C) {
          return this.startOf(C, !1);
        }, E.$set = function(C, R) {
          var q, F = T.p(C), z = "set" + (this.$u ? "UTC" : ""), O = (q = {}, q[o] = z + "Date", q[m] = z + "Date", q[p] = z + "Month", q[s] = z + "FullYear", q[d] = z + "Hours", q[l] = z + "Minutes", q[a] = z + "Seconds", q[c] = z + "Milliseconds", q)[F], N = F === o ? this.$D + (R - this.$W) : R;
          if (F === p || F === s) {
            var U = this.clone().set(m, 1);
            U.$d[O](N), U.init(), this.$d = U.set(m, Math.min(this.$D, U.daysInMonth())).$d;
          } else O && this.$d[O](N);
          return this.init(), this;
        }, E.set = function(C, R) {
          return this.clone().$set(C, R);
        }, E.get = function(C) {
          return this[T.p(C)]();
        }, E.add = function(C, R) {
          var q, F = this;
          C = Number(C);
          var z = T.p(R), O = function(V) {
            var W = D(F);
            return T.w(W.date(W.date() + Math.round(V * C)), F);
          };
          if (z === p) return this.set(p, this.$M + C);
          if (z === s) return this.set(s, this.$y + C);
          if (z === o) return O(1);
          if (z === f) return O(7);
          var N = (q = {}, q[l] = u, q[d] = i, q[a] = r, q)[z] || 1, U = this.$d.getTime() + C * N;
          return T.w(U, this);
        }, E.subtract = function(C, R) {
          return this.add(-1 * C, R);
        }, E.format = function(C) {
          var R = this, q = this.$locale();
          if (!this.isValid()) return q.invalidDate || b;
          var F = C || "YYYY-MM-DDTHH:mm:ssZ", z = T.z(this), O = this.$H, N = this.$m, U = this.$M, V = q.weekdays, W = q.months, ne = q.meridiem, se = function(oe, I, B, j) {
            return oe && (oe[I] || oe(R, F)) || B[I].slice(0, j);
          }, de = function(oe) {
            return T.s(O % 12 || 12, oe, "0");
          }, be = ne || function(oe, I, B) {
            var j = oe < 12 ? "AM" : "PM";
            return B ? j.toLowerCase() : j;
          };
          return F.replace(h, function(oe, I) {
            return I || function(B) {
              switch (B) {
                case "YY":
                  return String(R.$y).slice(-2);
                case "YYYY":
                  return T.s(R.$y, 4, "0");
                case "M":
                  return U + 1;
                case "MM":
                  return T.s(U + 1, 2, "0");
                case "MMM":
                  return se(q.monthsShort, U, W, 3);
                case "MMMM":
                  return se(W, U);
                case "D":
                  return R.$D;
                case "DD":
                  return T.s(R.$D, 2, "0");
                case "d":
                  return String(R.$W);
                case "dd":
                  return se(q.weekdaysMin, R.$W, V, 2);
                case "ddd":
                  return se(q.weekdaysShort, R.$W, V, 3);
                case "dddd":
                  return V[R.$W];
                case "H":
                  return String(O);
                case "HH":
                  return T.s(O, 2, "0");
                case "h":
                  return de(1);
                case "hh":
                  return de(2);
                case "a":
                  return be(O, N, !0);
                case "A":
                  return be(O, N, !1);
                case "m":
                  return String(N);
                case "mm":
                  return T.s(N, 2, "0");
                case "s":
                  return String(R.$s);
                case "ss":
                  return T.s(R.$s, 2, "0");
                case "SSS":
                  return T.s(R.$ms, 3, "0");
                case "Z":
                  return z;
              }
              return null;
            }(oe) || z.replace(":", "");
          });
        }, E.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, E.diff = function(C, R, q) {
          var F, z = this, O = T.p(R), N = D(C), U = (N.utcOffset() - this.utcOffset()) * u, V = this - N, W = function() {
            return T.m(z, N);
          };
          switch (O) {
            case s:
              F = W() / 12;
              break;
            case p:
              F = W();
              break;
            case n:
              F = W() / 3;
              break;
            case f:
              F = (V - U) / 6048e5;
              break;
            case o:
              F = (V - U) / 864e5;
              break;
            case d:
              F = V / i;
              break;
            case l:
              F = V / u;
              break;
            case a:
              F = V / r;
              break;
            default:
              F = V;
          }
          return q ? F : T.a(F);
        }, E.daysInMonth = function() {
          return this.endOf(p).$D;
        }, E.$locale = function() {
          return w[this.$L];
        }, E.locale = function(C, R) {
          if (!C) return this.$L;
          var q = this.clone(), F = $(C, R, !0);
          return F && (q.$L = F), q;
        }, E.clone = function() {
          return T.w(this.$d, this);
        }, E.toDate = function() {
          return new Date(this.valueOf());
        }, E.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, E.toISOString = function() {
          return this.$d.toISOString();
        }, E.toString = function() {
          return this.$d.toUTCString();
        }, L;
      }(), P = A.prototype;
      return D.prototype = P, [["$ms", c], ["$s", a], ["$m", l], ["$H", d], ["$W", o], ["$M", p], ["$y", s], ["$D", m]].forEach(function(L) {
        P[L[1]] = function(E) {
          return this.$g(E, L[0], L[1]);
        };
      }), D.extend = function(L, E) {
        return L.$i || (L(E, A, D), L.$i = !0), D;
      }, D.locale = $, D.isDayjs = k, D.unix = function(L) {
        return D(1e3 * L);
      }, D.en = w[y], D.Ls = w, D.p = {}, D;
    });
  }(Mt)), Mt.exports;
}
var ti = Je();
const Ke = /* @__PURE__ */ je(ti);
var kt = { exports: {} }, ri = kt.exports, Jr;
function ui() {
  return Jr || (Jr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(ri, function() {
      var r = "minute", u = /[+-]\d\d(?::?\d\d)?/g, i = /([+-]|\d\d)/g;
      return function(c, a, l) {
        var d = a.prototype;
        l.utc = function(b) {
          var g = { date: b, utc: !0, args: arguments };
          return new a(g);
        }, d.utc = function(b) {
          var g = l(this.toDate(), { locale: this.$L, utc: !0 });
          return b ? g.add(this.utcOffset(), r) : g;
        }, d.local = function() {
          return l(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var o = d.parse;
        d.parse = function(b) {
          b.utc && (this.$u = !0), this.$utils().u(b.$offset) || (this.$offset = b.$offset), o.call(this, b);
        };
        var f = d.init;
        d.init = function() {
          if (this.$u) {
            var b = this.$d;
            this.$y = b.getUTCFullYear(), this.$M = b.getUTCMonth(), this.$D = b.getUTCDate(), this.$W = b.getUTCDay(), this.$H = b.getUTCHours(), this.$m = b.getUTCMinutes(), this.$s = b.getUTCSeconds(), this.$ms = b.getUTCMilliseconds();
          } else f.call(this);
        };
        var p = d.utcOffset;
        d.utcOffset = function(b, g) {
          var h = this.$utils().u;
          if (h(b)) return this.$u ? 0 : h(this.$offset) ? p.call(this) : this.$offset;
          if (typeof b == "string" && (b = function(y) {
            y === void 0 && (y = "");
            var w = y.match(u);
            if (!w) return null;
            var S = ("" + w[0]).match(i) || ["-", 0, 0], k = S[0], $ = 60 * +S[1] + +S[2];
            return $ === 0 ? 0 : k === "+" ? $ : -$;
          }(b), b === null)) return this;
          var v = Math.abs(b) <= 16 ? 60 * b : b, x = this;
          if (g) return x.$offset = v, x.$u = b === 0, x;
          if (b !== 0) {
            var _ = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (x = this.local().add(v + _, r)).$offset = v, x.$x.$localOffset = _;
          } else x = this.utc();
          return x;
        };
        var n = d.format;
        d.format = function(b) {
          var g = b || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return n.call(this, g);
        }, d.valueOf = function() {
          var b = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * b;
        }, d.isUTC = function() {
          return !!this.$u;
        }, d.toISOString = function() {
          return this.toDate().toISOString();
        }, d.toString = function() {
          return this.toDate().toUTCString();
        };
        var s = d.toDate;
        d.toDate = function(b) {
          return b === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : s.call(this);
        };
        var m = d.diff;
        d.diff = function(b, g, h) {
          if (b && this.$u === b.$u) return m.call(this, b, g, h);
          var v = this.local(), x = l(b).local();
          return m.call(v, x, g, h);
        };
      };
    });
  }(kt)), kt.exports;
}
var ni = ui();
const ii = /* @__PURE__ */ je(ni);
var Tt = { exports: {} }, ai = Tt.exports, Kr;
function si() {
  return Kr || (Kr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(ai, function() {
      var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, u = {};
      return function(i, c, a) {
        var l, d = function(n, s, m) {
          m === void 0 && (m = {});
          var b = new Date(n), g = function(h, v) {
            v === void 0 && (v = {});
            var x = v.timeZoneName || "short", _ = h + "|" + x, y = u[_];
            return y || (y = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: h, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: x }), u[_] = y), y;
          }(s, m);
          return g.formatToParts(b);
        }, o = function(n, s) {
          for (var m = d(n, s), b = [], g = 0; g < m.length; g += 1) {
            var h = m[g], v = h.type, x = h.value, _ = r[v];
            _ >= 0 && (b[_] = parseInt(x, 10));
          }
          var y = b[3], w = y === 24 ? 0 : y, S = b[0] + "-" + b[1] + "-" + b[2] + " " + w + ":" + b[4] + ":" + b[5] + ":000", k = +n;
          return (a.utc(S).valueOf() - (k -= k % 1e3)) / 6e4;
        }, f = c.prototype;
        f.tz = function(n, s) {
          n === void 0 && (n = l);
          var m, b = this.utcOffset(), g = this.toDate(), h = g.toLocaleString("en-US", { timeZone: n }), v = Math.round((g - new Date(h)) / 1e3 / 60), x = 15 * -Math.round(g.getTimezoneOffset() / 15) - v;
          if (!Number(x)) m = this.utcOffset(0, s);
          else if (m = a(h, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(x, !0), s) {
            var _ = m.utcOffset();
            m = m.add(b - _, "minute");
          }
          return m.$x.$timezone = n, m;
        }, f.offsetName = function(n) {
          var s = this.$x.$timezone || a.tz.guess(), m = d(this.valueOf(), s, { timeZoneName: n }).find(function(b) {
            return b.type.toLowerCase() === "timezonename";
          });
          return m && m.value;
        };
        var p = f.startOf;
        f.startOf = function(n, s) {
          if (!this.$x || !this.$x.$timezone) return p.call(this, n, s);
          var m = a(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return p.call(m, n, s).tz(this.$x.$timezone, !0);
        }, a.tz = function(n, s, m) {
          var b = m && s, g = m || s || l, h = o(+a(), g);
          if (typeof n != "string") return a(n).tz(g);
          var v = function(w, S, k) {
            var $ = w - 60 * S * 1e3, D = o($, k);
            if (S === D) return [$, S];
            var T = o($ -= 60 * (D - S) * 1e3, k);
            return D === T ? [$, D] : [w - 60 * Math.min(D, T) * 1e3, Math.max(D, T)];
          }(a.utc(n, b).valueOf(), h, g), x = v[0], _ = v[1], y = a(x).utcOffset(_);
          return y.$x.$timezone = g, y;
        }, a.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, a.tz.setDefault = function(n) {
          l = n;
        };
      };
    });
  }(Tt)), Tt.exports;
}
var oi = si();
const ci = /* @__PURE__ */ je(oi);
var Et = { exports: {} }, li = Et.exports, Xr;
function fi() {
  return Xr || (Xr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(li, function() {
      return function(r, u) {
        var i = u.prototype, c = i.format;
        i.format = function(a) {
          var l = this, d = this.$locale();
          if (!this.isValid()) return c.bind(this)(a);
          var o = this.$utils(), f = (a || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(p) {
            switch (p) {
              case "Q":
                return Math.ceil((l.$M + 1) / 3);
              case "Do":
                return d.ordinal(l.$D);
              case "gggg":
                return l.weekYear();
              case "GGGG":
                return l.isoWeekYear();
              case "wo":
                return d.ordinal(l.week(), "W");
              case "w":
              case "ww":
                return o.s(l.week(), p === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return o.s(l.isoWeek(), p === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return o.s(String(l.$H === 0 ? 24 : l.$H), p === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(l.$d.getTime() / 1e3);
              case "x":
                return l.$d.getTime();
              case "z":
                return "[" + l.offsetName() + "]";
              case "zzz":
                return "[" + l.offsetName("long") + "]";
              default:
                return p;
            }
          });
          return c.bind(this)(f);
        };
      };
    });
  }(Et)), Et.exports;
}
var di = fi();
const hi = /* @__PURE__ */ je(di);
var At = { exports: {} }, pi = At.exports, eu;
function mi() {
  return eu || (eu = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(pi, function() {
      var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
      return function(u, i, c) {
        var a = i.prototype, l = a.format;
        c.en.formats = r, a.format = function(d) {
          d === void 0 && (d = "YYYY-MM-DDTHH:mm:ssZ");
          var o = this.$locale().formats, f = function(p, n) {
            return p.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(s, m, b) {
              var g = b && b.toUpperCase();
              return m || n[b] || r[b] || n[g].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(h, v, x) {
                return v || x.slice(1);
              });
            });
          }(d, o === void 0 ? {} : o);
          return l.call(this, f);
        };
      };
    });
  }(At)), At.exports;
}
var bi = mi();
const gi = /* @__PURE__ */ je(bi);
var $t = { exports: {} }, yi = $t.exports, tu;
function vi() {
  return tu || (tu = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(yi, function() {
      var r, u, i = 1e3, c = 6e4, a = 36e5, l = 864e5, d = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, o = 31536e6, f = 2628e6, p = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, n = { years: o, months: f, days: l, hours: a, minutes: c, seconds: i, milliseconds: 1, weeks: 6048e5 }, s = function(w) {
        return w instanceof _;
      }, m = function(w, S, k) {
        return new _(w, k, S.$l);
      }, b = function(w) {
        return u.p(w) + "s";
      }, g = function(w) {
        return w < 0;
      }, h = function(w) {
        return g(w) ? Math.ceil(w) : Math.floor(w);
      }, v = function(w) {
        return Math.abs(w);
      }, x = function(w, S) {
        return w ? g(w) ? { negative: !0, format: "" + v(w) + S } : { negative: !1, format: "" + w + S } : { negative: !1, format: "" };
      }, _ = function() {
        function w(k, $, D) {
          var T = this;
          if (this.$d = {}, this.$l = D, k === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), $) return m(k * n[b($)], this);
          if (typeof k == "number") return this.$ms = k, this.parseFromMilliseconds(), this;
          if (typeof k == "object") return Object.keys(k).forEach(function(L) {
            T.$d[b(L)] = k[L];
          }), this.calMilliseconds(), this;
          if (typeof k == "string") {
            var A = k.match(p);
            if (A) {
              var P = A.slice(2).map(function(L) {
                return L != null ? Number(L) : 0;
              });
              return this.$d.years = P[0], this.$d.months = P[1], this.$d.weeks = P[2], this.$d.days = P[3], this.$d.hours = P[4], this.$d.minutes = P[5], this.$d.seconds = P[6], this.calMilliseconds(), this;
            }
          }
          return this;
        }
        var S = w.prototype;
        return S.calMilliseconds = function() {
          var k = this;
          this.$ms = Object.keys(this.$d).reduce(function($, D) {
            return $ + (k.$d[D] || 0) * n[D];
          }, 0);
        }, S.parseFromMilliseconds = function() {
          var k = this.$ms;
          this.$d.years = h(k / o), k %= o, this.$d.months = h(k / f), k %= f, this.$d.days = h(k / l), k %= l, this.$d.hours = h(k / a), k %= a, this.$d.minutes = h(k / c), k %= c, this.$d.seconds = h(k / i), k %= i, this.$d.milliseconds = k;
        }, S.toISOString = function() {
          var k = x(this.$d.years, "Y"), $ = x(this.$d.months, "M"), D = +this.$d.days || 0;
          this.$d.weeks && (D += 7 * this.$d.weeks);
          var T = x(D, "D"), A = x(this.$d.hours, "H"), P = x(this.$d.minutes, "M"), L = this.$d.seconds || 0;
          this.$d.milliseconds && (L += this.$d.milliseconds / 1e3, L = Math.round(1e3 * L) / 1e3);
          var E = x(L, "S"), C = k.negative || $.negative || T.negative || A.negative || P.negative || E.negative, R = A.format || P.format || E.format ? "T" : "", q = (C ? "-" : "") + "P" + k.format + $.format + T.format + R + A.format + P.format + E.format;
          return q === "P" || q === "-P" ? "P0D" : q;
        }, S.toJSON = function() {
          return this.toISOString();
        }, S.format = function(k) {
          var $ = k || "YYYY-MM-DDTHH:mm:ss", D = { Y: this.$d.years, YY: u.s(this.$d.years, 2, "0"), YYYY: u.s(this.$d.years, 4, "0"), M: this.$d.months, MM: u.s(this.$d.months, 2, "0"), D: this.$d.days, DD: u.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: u.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: u.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: u.s(this.$d.seconds, 2, "0"), SSS: u.s(this.$d.milliseconds, 3, "0") };
          return $.replace(d, function(T, A) {
            return A || String(D[T]);
          });
        }, S.as = function(k) {
          return this.$ms / n[b(k)];
        }, S.get = function(k) {
          var $ = this.$ms, D = b(k);
          return D === "milliseconds" ? $ %= 1e3 : $ = D === "weeks" ? h($ / n[D]) : this.$d[D], $ || 0;
        }, S.add = function(k, $, D) {
          var T;
          return T = $ ? k * n[b($)] : s(k) ? k.$ms : m(k, this).$ms, m(this.$ms + T * (D ? -1 : 1), this);
        }, S.subtract = function(k, $) {
          return this.add(k, $, !0);
        }, S.locale = function(k) {
          var $ = this.clone();
          return $.$l = k, $;
        }, S.clone = function() {
          return m(this.$ms, this);
        }, S.humanize = function(k) {
          return r().add(this.$ms, "ms").locale(this.$l).fromNow(!k);
        }, S.valueOf = function() {
          return this.asMilliseconds();
        }, S.milliseconds = function() {
          return this.get("milliseconds");
        }, S.asMilliseconds = function() {
          return this.as("milliseconds");
        }, S.seconds = function() {
          return this.get("seconds");
        }, S.asSeconds = function() {
          return this.as("seconds");
        }, S.minutes = function() {
          return this.get("minutes");
        }, S.asMinutes = function() {
          return this.as("minutes");
        }, S.hours = function() {
          return this.get("hours");
        }, S.asHours = function() {
          return this.as("hours");
        }, S.days = function() {
          return this.get("days");
        }, S.asDays = function() {
          return this.as("days");
        }, S.weeks = function() {
          return this.get("weeks");
        }, S.asWeeks = function() {
          return this.as("weeks");
        }, S.months = function() {
          return this.get("months");
        }, S.asMonths = function() {
          return this.as("months");
        }, S.years = function() {
          return this.get("years");
        }, S.asYears = function() {
          return this.as("years");
        }, w;
      }(), y = function(w, S, k) {
        return w.add(S.years() * k, "y").add(S.months() * k, "M").add(S.days() * k, "d").add(S.hours() * k, "h").add(S.minutes() * k, "m").add(S.seconds() * k, "s").add(S.milliseconds() * k, "ms");
      };
      return function(w, S, k) {
        r = k, u = k().$utils(), k.duration = function(T, A) {
          var P = k.locale();
          return m(T, { $l: P }, A);
        }, k.isDuration = s;
        var $ = S.prototype.add, D = S.prototype.subtract;
        S.prototype.add = function(T, A) {
          return s(T) ? y(this, T, 1) : $.bind(this)(T, A);
        }, S.prototype.subtract = function(T, A) {
          return s(T) ? y(this, T, -1) : D.bind(this)(T, A);
        };
      };
    });
  }($t)), $t.exports;
}
var xi = vi();
const wi = /* @__PURE__ */ je(xi);
var Dt = { exports: {} }, _i = Dt.exports, ru;
function Si() {
  return ru || (ru = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(_i, function() {
      return function(r, u) {
        u.prototype.isSameOrAfter = function(i, c) {
          return this.isSame(i, c) || this.isAfter(i, c);
        };
      };
    });
  }(Dt)), Dt.exports;
}
var Mi = Si();
const ki = /* @__PURE__ */ je(Mi);
var Ot = { exports: {} }, Ti = Ot.exports, uu;
function Ei() {
  return uu || (uu = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(Ti, function() {
      return function(r, u) {
        u.prototype.isSameOrBefore = function(i, c) {
          return this.isSame(i, c) || this.isBefore(i, c);
        };
      };
    });
  }(Ot)), Ot.exports;
}
var Ai = Ei();
const $i = /* @__PURE__ */ je(Ai);
var Lt = { exports: {} }, Di = Lt.exports, nu;
function Oi() {
  return nu || (nu = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(Di, function() {
      var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, u = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, i = /\d/, c = /\d\d/, a = /\d\d?/, l = /\d*[^-_:/,()\s\d]+/, d = {}, o = function(g) {
        return (g = +g) + (g > 68 ? 1900 : 2e3);
      }, f = function(g) {
        return function(h) {
          this[g] = +h;
        };
      }, p = [/[+-]\d\d:?(\d\d)?|Z/, function(g) {
        (this.zone || (this.zone = {})).offset = function(h) {
          if (!h || h === "Z") return 0;
          var v = h.match(/([+-]|\d\d)/g), x = 60 * v[1] + (+v[2] || 0);
          return x === 0 ? 0 : v[0] === "+" ? -x : x;
        }(g);
      }], n = function(g) {
        var h = d[g];
        return h && (h.indexOf ? h : h.s.concat(h.f));
      }, s = function(g, h) {
        var v, x = d.meridiem;
        if (x) {
          for (var _ = 1; _ <= 24; _ += 1) if (g.indexOf(x(_, 0, h)) > -1) {
            v = _ > 12;
            break;
          }
        } else v = g === (h ? "pm" : "PM");
        return v;
      }, m = { A: [l, function(g) {
        this.afternoon = s(g, !1);
      }], a: [l, function(g) {
        this.afternoon = s(g, !0);
      }], Q: [i, function(g) {
        this.month = 3 * (g - 1) + 1;
      }], S: [i, function(g) {
        this.milliseconds = 100 * +g;
      }], SS: [c, function(g) {
        this.milliseconds = 10 * +g;
      }], SSS: [/\d{3}/, function(g) {
        this.milliseconds = +g;
      }], s: [a, f("seconds")], ss: [a, f("seconds")], m: [a, f("minutes")], mm: [a, f("minutes")], H: [a, f("hours")], h: [a, f("hours")], HH: [a, f("hours")], hh: [a, f("hours")], D: [a, f("day")], DD: [c, f("day")], Do: [l, function(g) {
        var h = d.ordinal, v = g.match(/\d+/);
        if (this.day = v[0], h) for (var x = 1; x <= 31; x += 1) h(x).replace(/\[|\]/g, "") === g && (this.day = x);
      }], w: [a, f("week")], ww: [c, f("week")], M: [a, f("month")], MM: [c, f("month")], MMM: [l, function(g) {
        var h = n("months"), v = (n("monthsShort") || h.map(function(x) {
          return x.slice(0, 3);
        })).indexOf(g) + 1;
        if (v < 1) throw new Error();
        this.month = v % 12 || v;
      }], MMMM: [l, function(g) {
        var h = n("months").indexOf(g) + 1;
        if (h < 1) throw new Error();
        this.month = h % 12 || h;
      }], Y: [/[+-]?\d+/, f("year")], YY: [c, function(g) {
        this.year = o(g);
      }], YYYY: [/\d{4}/, f("year")], Z: p, ZZ: p };
      function b(g) {
        var h, v;
        h = g, v = d && d.formats;
        for (var x = (g = h.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(D, T, A) {
          var P = A && A.toUpperCase();
          return T || v[A] || r[A] || v[P].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(L, E, C) {
            return E || C.slice(1);
          });
        })).match(u), _ = x.length, y = 0; y < _; y += 1) {
          var w = x[y], S = m[w], k = S && S[0], $ = S && S[1];
          x[y] = $ ? { regex: k, parser: $ } : w.replace(/^\[|\]$/g, "");
        }
        return function(D) {
          for (var T = {}, A = 0, P = 0; A < _; A += 1) {
            var L = x[A];
            if (typeof L == "string") P += L.length;
            else {
              var E = L.regex, C = L.parser, R = D.slice(P), q = E.exec(R)[0];
              C.call(T, q), D = D.replace(q, "");
            }
          }
          return function(F) {
            var z = F.afternoon;
            if (z !== void 0) {
              var O = F.hours;
              z ? O < 12 && (F.hours += 12) : O === 12 && (F.hours = 0), delete F.afternoon;
            }
          }(T), T;
        };
      }
      return function(g, h, v) {
        v.p.customParseFormat = !0, g && g.parseTwoDigitYear && (o = g.parseTwoDigitYear);
        var x = h.prototype, _ = x.parse;
        x.parse = function(y) {
          var w = y.date, S = y.utc, k = y.args;
          this.$u = S;
          var $ = k[1];
          if (typeof $ == "string") {
            var D = k[2] === !0, T = k[3] === !0, A = D || T, P = k[2];
            T && (P = k[2]), d = this.$locale(), !D && P && (d = v.Ls[P]), this.$d = function(R, q, F, z) {
              try {
                if (["x", "X"].indexOf(q) > -1) return new Date((q === "X" ? 1e3 : 1) * R);
                var O = b(q)(R), N = O.year, U = O.month, V = O.day, W = O.hours, ne = O.minutes, se = O.seconds, de = O.milliseconds, be = O.zone, oe = O.week, I = /* @__PURE__ */ new Date(), B = V || (N || U ? 1 : I.getDate()), j = N || I.getFullYear(), G = 0;
                N && !U || (G = U > 0 ? U - 1 : I.getMonth());
                var ce, le = W || 0, Ie = ne || 0, Ne = se || 0, X = de || 0;
                return be ? new Date(Date.UTC(j, G, B, le, Ie, Ne, X + 60 * be.offset * 1e3)) : F ? new Date(Date.UTC(j, G, B, le, Ie, Ne, X)) : (ce = new Date(j, G, B, le, Ie, Ne, X), oe && (ce = z(ce).week(oe).toDate()), ce);
              } catch {
                return /* @__PURE__ */ new Date("");
              }
            }(w, $, S, v), this.init(), P && P !== !0 && (this.$L = this.locale(P).$L), A && w != this.format($) && (this.$d = /* @__PURE__ */ new Date("")), d = {};
          } else if ($ instanceof Array) for (var L = $.length, E = 1; E <= L; E += 1) {
            k[1] = $[E - 1];
            var C = v.apply(this, k);
            if (C.isValid()) {
              this.$d = C.$d, this.$L = C.$L, this.init();
              break;
            }
            E === L && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else _.call(this, y);
        };
      };
    });
  }(Lt)), Lt.exports;
}
var Li = Oi();
const Ci = /* @__PURE__ */ je(Li);
var Ct = { exports: {} }, Ii = Ct.exports, iu;
function Ni() {
  return iu || (iu = 1, function(e, t) {
    (function(r, u) {
      e.exports = u(Je());
    })(Ii, function(r) {
      function u(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var i = u(r), c = { name: "en-gb", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), weekStart: 1, yearStart: 4, relativeTime: { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd, D MMMM YYYY HH:mm" }, ordinal: function(a) {
        var l = ["th", "st", "nd", "rd"], d = a % 100;
        return "[" + a + (l[(d - 20) % 10] || l[d] || l[0]) + "]";
      } };
      return i.default.locale(c, null, !0), c;
    });
  }(Ct)), Ct.exports;
}
Ni();
var It = { exports: {} }, Pi = It.exports, au;
function qi() {
  return au || (au = 1, function(e, t) {
    (function(r, u) {
      e.exports = u(Je());
    })(Pi, function(r) {
      function u(d) {
        return d && typeof d == "object" && "default" in d ? d : { default: d };
      }
      var i = u(r);
      function c(d) {
        return d > 1 && d < 5 && ~~(d / 10) != 1;
      }
      function a(d, o, f, p) {
        var n = d + " ";
        switch (f) {
          case "s":
            return o || p ? "pár sekund" : "pár sekundami";
          case "m":
            return o ? "minuta" : p ? "minutu" : "minutou";
          case "mm":
            return o || p ? n + (c(d) ? "minuty" : "minut") : n + "minutami";
          case "h":
            return o ? "hodina" : p ? "hodinu" : "hodinou";
          case "hh":
            return o || p ? n + (c(d) ? "hodiny" : "hodin") : n + "hodinami";
          case "d":
            return o || p ? "den" : "dnem";
          case "dd":
            return o || p ? n + (c(d) ? "dny" : "dní") : n + "dny";
          case "M":
            return o || p ? "měsíc" : "měsícem";
          case "MM":
            return o || p ? n + (c(d) ? "měsíce" : "měsíců") : n + "měsíci";
          case "y":
            return o || p ? "rok" : "rokem";
          case "yy":
            return o || p ? n + (c(d) ? "roky" : "let") : n + "lety";
        }
      }
      var l = { name: "cs", weekdays: "neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"), weekdaysShort: "ne_po_út_st_čt_pá_so".split("_"), weekdaysMin: "ne_po_út_st_čt_pá_so".split("_"), months: "leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"), monthsShort: "led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_"), weekStart: 1, yearStart: 4, ordinal: function(d) {
        return d + ".";
      }, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY H:mm", LLLL: "dddd D. MMMM YYYY H:mm", l: "D. M. YYYY" }, relativeTime: { future: "za %s", past: "před %s", s: a, m: a, mm: a, h: a, hh: a, d: a, dd: a, M: a, MM: a, y: a, yy: a } };
      return i.default.locale(l, null, !0), l;
    });
  }(It)), It.exports;
}
qi();
var Nt = { exports: {} }, Ui = Nt.exports, su;
function Hi() {
  return su || (su = 1, function(e, t) {
    (function(r, u) {
      e.exports = u(Je());
    })(Ui, function(r) {
      function u(d) {
        return d && typeof d == "object" && "default" in d ? d : { default: d };
      }
      var i = u(r);
      function c(d) {
        return d > 1 && d < 5 && ~~(d / 10) != 1;
      }
      function a(d, o, f, p) {
        var n = d + " ";
        switch (f) {
          case "s":
            return o || p ? "pár sekúnd" : "pár sekundami";
          case "m":
            return o ? "minúta" : p ? "minútu" : "minútou";
          case "mm":
            return o || p ? n + (c(d) ? "minúty" : "minút") : n + "minútami";
          case "h":
            return o ? "hodina" : p ? "hodinu" : "hodinou";
          case "hh":
            return o || p ? n + (c(d) ? "hodiny" : "hodín") : n + "hodinami";
          case "d":
            return o || p ? "deň" : "dňom";
          case "dd":
            return o || p ? n + (c(d) ? "dni" : "dní") : n + "dňami";
          case "M":
            return o || p ? "mesiac" : "mesiacom";
          case "MM":
            return o || p ? n + (c(d) ? "mesiace" : "mesiacov") : n + "mesiacmi";
          case "y":
            return o || p ? "rok" : "rokom";
          case "yy":
            return o || p ? n + (c(d) ? "roky" : "rokov") : n + "rokmi";
        }
      }
      var l = { name: "sk", weekdays: "nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"), weekdaysShort: "ne_po_ut_st_št_pi_so".split("_"), weekdaysMin: "ne_po_ut_st_št_pi_so".split("_"), months: "január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"), monthsShort: "jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_"), weekStart: 1, yearStart: 4, ordinal: function(d) {
        return d + ".";
      }, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY H:mm", LLLL: "dddd D. MMMM YYYY H:mm", l: "D. M. YYYY" }, relativeTime: { future: "za %s", past: "pred %s", s: a, m: a, mm: a, h: a, hh: a, d: a, dd: a, M: a, MM: a, y: a, yy: a } };
      return i.default.locale(l, null, !0), l;
    });
  }(Nt)), Nt.exports;
}
Hi();
var Pt = { exports: {} }, Ri = Pt.exports, ou;
function ji() {
  return ou || (ou = 1, function(e, t) {
    (function(r, u) {
      e.exports = u(Je());
    })(Ri, function(r) {
      function u(n) {
        return n && typeof n == "object" && "default" in n ? n : { default: n };
      }
      var i = u(r);
      function c(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 != 1;
      }
      function a(n, s, m) {
        var b = n + " ";
        switch (m) {
          case "m":
            return s ? "minuta" : "minutę";
          case "mm":
            return b + (c(n) ? "minuty" : "minut");
          case "h":
            return s ? "godzina" : "godzinę";
          case "hh":
            return b + (c(n) ? "godziny" : "godzin");
          case "MM":
            return b + (c(n) ? "miesiące" : "miesięcy");
          case "yy":
            return b + (c(n) ? "lata" : "lat");
        }
      }
      var l = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"), d = "styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"), o = /D MMMM/, f = function(n, s) {
        return o.test(s) ? l[n.month()] : d[n.month()];
      };
      f.s = d, f.f = l;
      var p = { name: "pl", weekdays: "niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"), weekdaysShort: "ndz_pon_wt_śr_czw_pt_sob".split("_"), weekdaysMin: "Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"), months: f, monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"), ordinal: function(n) {
        return n + ".";
      }, weekStart: 1, yearStart: 4, relativeTime: { future: "za %s", past: "%s temu", s: "kilka sekund", m: a, mm: a, h: a, hh: a, d: "1 dzień", dd: "%d dni", M: "miesiąc", MM: a, y: "rok", yy: a }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd, D MMMM YYYY HH:mm" } };
      return i.default.locale(p, null, !0), p;
    });
  }(Pt)), Pt.exports;
}
ji();
var qt = { exports: {} }, Fi = qt.exports, cu;
function zi() {
  return cu || (cu = 1, function(e, t) {
    (function(r, u) {
      e.exports = u(Je());
    })(Fi, function(r) {
      function u(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var i = u(r), c = { name: "hu", weekdays: "vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"), weekdaysShort: "vas_hét_kedd_sze_csüt_pén_szo".split("_"), weekdaysMin: "v_h_k_sze_cs_p_szo".split("_"), months: "január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"), monthsShort: "jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec".split("_"), ordinal: function(a) {
        return a + ".";
      }, weekStart: 1, relativeTime: { future: "%s múlva", past: "%s", s: function(a, l, d, o) {
        return "néhány másodperc" + (o || l ? "" : "e");
      }, m: function(a, l, d, o) {
        return "egy perc" + (o || l ? "" : "e");
      }, mm: function(a, l, d, o) {
        return a + " perc" + (o || l ? "" : "e");
      }, h: function(a, l, d, o) {
        return "egy " + (o || l ? "óra" : "órája");
      }, hh: function(a, l, d, o) {
        return a + " " + (o || l ? "óra" : "órája");
      }, d: function(a, l, d, o) {
        return "egy " + (o || l ? "nap" : "napja");
      }, dd: function(a, l, d, o) {
        return a + " " + (o || l ? "nap" : "napja");
      }, M: function(a, l, d, o) {
        return "egy " + (o || l ? "hónap" : "hónapja");
      }, MM: function(a, l, d, o) {
        return a + " " + (o || l ? "hónap" : "hónapja");
      }, y: function(a, l, d, o) {
        return "egy " + (o || l ? "év" : "éve");
      }, yy: function(a, l, d, o) {
        return a + " " + (o || l ? "év" : "éve");
      } }, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "YYYY.MM.DD.", LL: "YYYY. MMMM D.", LLL: "YYYY. MMMM D. H:mm", LLLL: "YYYY. MMMM D., dddd H:mm" } };
      return i.default.locale(c, null, !0), c;
    });
  }(qt)), qt.exports;
}
zi();
var Ut = { exports: {} }, Bi = Ut.exports, lu;
function Yi() {
  return lu || (lu = 1, function(e, t) {
    (function(r, u) {
      e.exports = u(Je());
    })(Bi, function(r) {
      function u(d) {
        return d && typeof d == "object" && "default" in d ? d : { default: d };
      }
      var i = u(r), c = { s: "ein paar Sekunden", m: ["eine Minute", "einer Minute"], mm: "%d Minuten", h: ["eine Stunde", "einer Stunde"], hh: "%d Stunden", d: ["ein Tag", "einem Tag"], dd: ["%d Tage", "%d Tagen"], M: ["ein Monat", "einem Monat"], MM: ["%d Monate", "%d Monaten"], y: ["ein Jahr", "einem Jahr"], yy: ["%d Jahre", "%d Jahren"] };
      function a(d, o, f) {
        var p = c[f];
        return Array.isArray(p) && (p = p[o ? 0 : 1]), p.replace("%d", d);
      }
      var l = { name: "de", weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"), weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"), weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"), months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"), monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"), ordinal: function(d) {
        return d + ".";
      }, weekStart: 1, yearStart: 4, formats: { LTS: "HH:mm:ss", LT: "HH:mm", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY HH:mm", LLLL: "dddd, D. MMMM YYYY HH:mm" }, relativeTime: { future: "in %s", past: "vor %s", s: a, m: a, mm: a, h: a, hh: a, d: a, dd: a, M: a, MM: a, y: a, yy: a } };
      return i.default.locale(l, null, !0), l;
    });
  }(Ut)), Ut.exports;
}
Yi();
var Ht = { exports: {} }, Vi = Ht.exports, fu;
function Gi() {
  return fu || (fu = 1, function(e, t) {
    (function(r, u) {
      e.exports = u(Je());
    })(Vi, function(r) {
      function u(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var i = u(r), c = { name: "es", monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"), weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"), weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"), months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"), weekStart: 1, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY H:mm", LLLL: "dddd, D [de] MMMM [de] YYYY H:mm" }, relativeTime: { future: "en %s", past: "hace %s", s: "unos segundos", m: "un minuto", mm: "%d minutos", h: "una hora", hh: "%d horas", d: "un día", dd: "%d días", M: "un mes", MM: "%d meses", y: "un año", yy: "%d años" }, ordinal: function(a) {
        return a + "º";
      } };
      return i.default.locale(c, null, !0), c;
    });
  }(Ht)), Ht.exports;
}
Gi();
var Rt = { exports: {} }, Wi = Rt.exports, du;
function Qi() {
  return du || (du = 1, function(e, t) {
    (function(r, u) {
      e.exports = u(Je());
    })(Wi, function(r) {
      function u(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var i = u(r), c = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(a) {
        return "" + a + (a === 1 ? "er" : "");
      } };
      return i.default.locale(c, null, !0), c;
    });
  }(Rt)), Rt.exports;
}
Qi();
var Ee = {}, Ae = {}, Jt = {}, $e = {}, bt = {}, hu;
function Zi() {
  return hu || (hu = 1, Object.defineProperty(bt, "__esModule", { value: !0 }), bt.default = new Uint16Array(
    // prettier-ignore
    'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(e) {
      return e.charCodeAt(0);
    })
  )), bt;
}
var gt = {}, pu;
function Ji() {
  return pu || (pu = 1, Object.defineProperty(gt, "__esModule", { value: !0 }), gt.default = new Uint16Array(
    // prettier-ignore
    "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(e) {
      return e.charCodeAt(0);
    })
  )), gt;
}
var Kt = {}, mu;
function bu() {
  return mu || (mu = 1, function(e) {
    var t;
    Object.defineProperty(e, "__esModule", { value: !0 }), e.replaceCodePoint = e.fromCodePoint = void 0;
    var r = /* @__PURE__ */ new Map([
      [0, 65533],
      // C1 Unicode control character reference replacements
      [128, 8364],
      [130, 8218],
      [131, 402],
      [132, 8222],
      [133, 8230],
      [134, 8224],
      [135, 8225],
      [136, 710],
      [137, 8240],
      [138, 352],
      [139, 8249],
      [140, 338],
      [142, 381],
      [145, 8216],
      [146, 8217],
      [147, 8220],
      [148, 8221],
      [149, 8226],
      [150, 8211],
      [151, 8212],
      [152, 732],
      [153, 8482],
      [154, 353],
      [155, 8250],
      [156, 339],
      [158, 382],
      [159, 376]
    ]);
    e.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
    (t = String.fromCodePoint) !== null && t !== void 0 ? t : function(c) {
      var a = "";
      return c > 65535 && (c -= 65536, a += String.fromCharCode(c >>> 10 & 1023 | 55296), c = 56320 | c & 1023), a += String.fromCharCode(c), a;
    };
    function u(c) {
      var a;
      return c >= 55296 && c <= 57343 || c > 1114111 ? 65533 : (a = r.get(c)) !== null && a !== void 0 ? a : c;
    }
    e.replaceCodePoint = u;
    function i(c) {
      return (0, e.fromCodePoint)(u(c));
    }
    e.default = i;
  }(Kt)), Kt;
}
var gu;
function zt() {
  return gu || (gu = 1, function(e) {
    var t = $e && $e.__createBinding || (Object.create ? function(T, A, P, L) {
      L === void 0 && (L = P);
      var E = Object.getOwnPropertyDescriptor(A, P);
      (!E || ("get" in E ? !A.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
        return A[P];
      } }), Object.defineProperty(T, L, E);
    } : function(T, A, P, L) {
      L === void 0 && (L = P), T[L] = A[P];
    }), r = $e && $e.__setModuleDefault || (Object.create ? function(T, A) {
      Object.defineProperty(T, "default", { enumerable: !0, value: A });
    } : function(T, A) {
      T.default = A;
    }), u = $e && $e.__importStar || function(T) {
      if (T && T.__esModule) return T;
      var A = {};
      if (T != null) for (var P in T) P !== "default" && Object.prototype.hasOwnProperty.call(T, P) && t(A, T, P);
      return r(A, T), A;
    }, i = $e && $e.__importDefault || function(T) {
      return T && T.__esModule ? T : { default: T };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXML = e.decodeHTMLStrict = e.decodeHTMLAttribute = e.decodeHTML = e.determineBranch = e.EntityDecoder = e.DecodingMode = e.BinTrieFlags = e.fromCodePoint = e.replaceCodePoint = e.decodeCodePoint = e.xmlDecodeTree = e.htmlDecodeTree = void 0;
    var c = i(/* @__PURE__ */ Zi());
    e.htmlDecodeTree = c.default;
    var a = i(/* @__PURE__ */ Ji());
    e.xmlDecodeTree = a.default;
    var l = u(/* @__PURE__ */ bu());
    e.decodeCodePoint = l.default;
    var d = /* @__PURE__ */ bu();
    Object.defineProperty(e, "replaceCodePoint", { enumerable: !0, get: function() {
      return d.replaceCodePoint;
    } }), Object.defineProperty(e, "fromCodePoint", { enumerable: !0, get: function() {
      return d.fromCodePoint;
    } });
    var o;
    (function(T) {
      T[T.NUM = 35] = "NUM", T[T.SEMI = 59] = "SEMI", T[T.EQUALS = 61] = "EQUALS", T[T.ZERO = 48] = "ZERO", T[T.NINE = 57] = "NINE", T[T.LOWER_A = 97] = "LOWER_A", T[T.LOWER_F = 102] = "LOWER_F", T[T.LOWER_X = 120] = "LOWER_X", T[T.LOWER_Z = 122] = "LOWER_Z", T[T.UPPER_A = 65] = "UPPER_A", T[T.UPPER_F = 70] = "UPPER_F", T[T.UPPER_Z = 90] = "UPPER_Z";
    })(o || (o = {}));
    var f = 32, p;
    (function(T) {
      T[T.VALUE_LENGTH = 49152] = "VALUE_LENGTH", T[T.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", T[T.JUMP_TABLE = 127] = "JUMP_TABLE";
    })(p = e.BinTrieFlags || (e.BinTrieFlags = {}));
    function n(T) {
      return T >= o.ZERO && T <= o.NINE;
    }
    function s(T) {
      return T >= o.UPPER_A && T <= o.UPPER_F || T >= o.LOWER_A && T <= o.LOWER_F;
    }
    function m(T) {
      return T >= o.UPPER_A && T <= o.UPPER_Z || T >= o.LOWER_A && T <= o.LOWER_Z || n(T);
    }
    function b(T) {
      return T === o.EQUALS || m(T);
    }
    var g;
    (function(T) {
      T[T.EntityStart = 0] = "EntityStart", T[T.NumericStart = 1] = "NumericStart", T[T.NumericDecimal = 2] = "NumericDecimal", T[T.NumericHex = 3] = "NumericHex", T[T.NamedEntity = 4] = "NamedEntity";
    })(g || (g = {}));
    var h;
    (function(T) {
      T[T.Legacy = 0] = "Legacy", T[T.Strict = 1] = "Strict", T[T.Attribute = 2] = "Attribute";
    })(h = e.DecodingMode || (e.DecodingMode = {}));
    var v = (
      /** @class */
      function() {
        function T(A, P, L) {
          this.decodeTree = A, this.emitCodePoint = P, this.errors = L, this.state = g.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = h.Strict;
        }
        return T.prototype.startEntity = function(A) {
          this.decodeMode = A, this.state = g.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
        }, T.prototype.write = function(A, P) {
          switch (this.state) {
            case g.EntityStart:
              return A.charCodeAt(P) === o.NUM ? (this.state = g.NumericStart, this.consumed += 1, this.stateNumericStart(A, P + 1)) : (this.state = g.NamedEntity, this.stateNamedEntity(A, P));
            case g.NumericStart:
              return this.stateNumericStart(A, P);
            case g.NumericDecimal:
              return this.stateNumericDecimal(A, P);
            case g.NumericHex:
              return this.stateNumericHex(A, P);
            case g.NamedEntity:
              return this.stateNamedEntity(A, P);
          }
        }, T.prototype.stateNumericStart = function(A, P) {
          return P >= A.length ? -1 : (A.charCodeAt(P) | f) === o.LOWER_X ? (this.state = g.NumericHex, this.consumed += 1, this.stateNumericHex(A, P + 1)) : (this.state = g.NumericDecimal, this.stateNumericDecimal(A, P));
        }, T.prototype.addToNumericResult = function(A, P, L, E) {
          if (P !== L) {
            var C = L - P;
            this.result = this.result * Math.pow(E, C) + parseInt(A.substr(P, C), E), this.consumed += C;
          }
        }, T.prototype.stateNumericHex = function(A, P) {
          for (var L = P; P < A.length; ) {
            var E = A.charCodeAt(P);
            if (n(E) || s(E))
              P += 1;
            else
              return this.addToNumericResult(A, L, P, 16), this.emitNumericEntity(E, 3);
          }
          return this.addToNumericResult(A, L, P, 16), -1;
        }, T.prototype.stateNumericDecimal = function(A, P) {
          for (var L = P; P < A.length; ) {
            var E = A.charCodeAt(P);
            if (n(E))
              P += 1;
            else
              return this.addToNumericResult(A, L, P, 10), this.emitNumericEntity(E, 2);
          }
          return this.addToNumericResult(A, L, P, 10), -1;
        }, T.prototype.emitNumericEntity = function(A, P) {
          var L;
          if (this.consumed <= P)
            return (L = this.errors) === null || L === void 0 || L.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          if (A === o.SEMI)
            this.consumed += 1;
          else if (this.decodeMode === h.Strict)
            return 0;
          return this.emitCodePoint((0, l.replaceCodePoint)(this.result), this.consumed), this.errors && (A !== o.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
        }, T.prototype.stateNamedEntity = function(A, P) {
          for (var L = this.decodeTree, E = L[this.treeIndex], C = (E & p.VALUE_LENGTH) >> 14; P < A.length; P++, this.excess++) {
            var R = A.charCodeAt(P);
            if (this.treeIndex = _(L, E, this.treeIndex + Math.max(1, C), R), this.treeIndex < 0)
              return this.result === 0 || // If we are parsing an attribute
              this.decodeMode === h.Attribute && // We shouldn't have consumed any characters after the entity,
              (C === 0 || // And there should be no invalid characters.
              b(R)) ? 0 : this.emitNotTerminatedNamedEntity();
            if (E = L[this.treeIndex], C = (E & p.VALUE_LENGTH) >> 14, C !== 0) {
              if (R === o.SEMI)
                return this.emitNamedEntityData(this.treeIndex, C, this.consumed + this.excess);
              this.decodeMode !== h.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
            }
          }
          return -1;
        }, T.prototype.emitNotTerminatedNamedEntity = function() {
          var A, P = this, L = P.result, E = P.decodeTree, C = (E[L] & p.VALUE_LENGTH) >> 14;
          return this.emitNamedEntityData(L, C, this.consumed), (A = this.errors) === null || A === void 0 || A.missingSemicolonAfterCharacterReference(), this.consumed;
        }, T.prototype.emitNamedEntityData = function(A, P, L) {
          var E = this.decodeTree;
          return this.emitCodePoint(P === 1 ? E[A] & ~p.VALUE_LENGTH : E[A + 1], L), P === 3 && this.emitCodePoint(E[A + 2], L), L;
        }, T.prototype.end = function() {
          var A;
          switch (this.state) {
            case g.NamedEntity:
              return this.result !== 0 && (this.decodeMode !== h.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case g.NumericDecimal:
              return this.emitNumericEntity(0, 2);
            case g.NumericHex:
              return this.emitNumericEntity(0, 3);
            case g.NumericStart:
              return (A = this.errors) === null || A === void 0 || A.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            case g.EntityStart:
              return 0;
          }
        }, T;
      }()
    );
    e.EntityDecoder = v;
    function x(T) {
      var A = "", P = new v(T, function(L) {
        return A += (0, l.fromCodePoint)(L);
      });
      return function(E, C) {
        for (var R = 0, q = 0; (q = E.indexOf("&", q)) >= 0; ) {
          A += E.slice(R, q), P.startEntity(C);
          var F = P.write(
            E,
            // Skip the "&"
            q + 1
          );
          if (F < 0) {
            R = q + P.end();
            break;
          }
          R = q + F, q = F === 0 ? R + 1 : R;
        }
        var z = A + E.slice(R);
        return A = "", z;
      };
    }
    function _(T, A, P, L) {
      var E = (A & p.BRANCH_LENGTH) >> 7, C = A & p.JUMP_TABLE;
      if (E === 0)
        return C !== 0 && L === C ? P : -1;
      if (C) {
        var R = L - C;
        return R < 0 || R >= E ? -1 : T[P + R] - 1;
      }
      for (var q = P, F = q + E - 1; q <= F; ) {
        var z = q + F >>> 1, O = T[z];
        if (O < L)
          q = z + 1;
        else if (O > L)
          F = z - 1;
        else
          return T[z + E];
      }
      return -1;
    }
    e.determineBranch = _;
    var y = x(c.default), w = x(a.default);
    function S(T, A) {
      return A === void 0 && (A = h.Legacy), y(T, A);
    }
    e.decodeHTML = S;
    function k(T) {
      return y(T, h.Attribute);
    }
    e.decodeHTMLAttribute = k;
    function $(T) {
      return y(T, h.Strict);
    }
    e.decodeHTMLStrict = $;
    function D(T) {
      return w(T, h.Strict);
    }
    e.decodeXML = D;
  }($e)), $e;
}
var yu;
function Sn() {
  return yu || (yu = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.QuoteType = void 0;
    var t = /* @__PURE__ */ zt(), r;
    (function(n) {
      n[n.Tab = 9] = "Tab", n[n.NewLine = 10] = "NewLine", n[n.FormFeed = 12] = "FormFeed", n[n.CarriageReturn = 13] = "CarriageReturn", n[n.Space = 32] = "Space", n[n.ExclamationMark = 33] = "ExclamationMark", n[n.Number = 35] = "Number", n[n.Amp = 38] = "Amp", n[n.SingleQuote = 39] = "SingleQuote", n[n.DoubleQuote = 34] = "DoubleQuote", n[n.Dash = 45] = "Dash", n[n.Slash = 47] = "Slash", n[n.Zero = 48] = "Zero", n[n.Nine = 57] = "Nine", n[n.Semi = 59] = "Semi", n[n.Lt = 60] = "Lt", n[n.Eq = 61] = "Eq", n[n.Gt = 62] = "Gt", n[n.Questionmark = 63] = "Questionmark", n[n.UpperA = 65] = "UpperA", n[n.LowerA = 97] = "LowerA", n[n.UpperF = 70] = "UpperF", n[n.LowerF = 102] = "LowerF", n[n.UpperZ = 90] = "UpperZ", n[n.LowerZ = 122] = "LowerZ", n[n.LowerX = 120] = "LowerX", n[n.OpeningSquareBracket = 91] = "OpeningSquareBracket";
    })(r || (r = {}));
    var u;
    (function(n) {
      n[n.Text = 1] = "Text", n[n.BeforeTagName = 2] = "BeforeTagName", n[n.InTagName = 3] = "InTagName", n[n.InSelfClosingTag = 4] = "InSelfClosingTag", n[n.BeforeClosingTagName = 5] = "BeforeClosingTagName", n[n.InClosingTagName = 6] = "InClosingTagName", n[n.AfterClosingTagName = 7] = "AfterClosingTagName", n[n.BeforeAttributeName = 8] = "BeforeAttributeName", n[n.InAttributeName = 9] = "InAttributeName", n[n.AfterAttributeName = 10] = "AfterAttributeName", n[n.BeforeAttributeValue = 11] = "BeforeAttributeValue", n[n.InAttributeValueDq = 12] = "InAttributeValueDq", n[n.InAttributeValueSq = 13] = "InAttributeValueSq", n[n.InAttributeValueNq = 14] = "InAttributeValueNq", n[n.BeforeDeclaration = 15] = "BeforeDeclaration", n[n.InDeclaration = 16] = "InDeclaration", n[n.InProcessingInstruction = 17] = "InProcessingInstruction", n[n.BeforeComment = 18] = "BeforeComment", n[n.CDATASequence = 19] = "CDATASequence", n[n.InSpecialComment = 20] = "InSpecialComment", n[n.InCommentLike = 21] = "InCommentLike", n[n.BeforeSpecialS = 22] = "BeforeSpecialS", n[n.SpecialStartSequence = 23] = "SpecialStartSequence", n[n.InSpecialTag = 24] = "InSpecialTag", n[n.BeforeEntity = 25] = "BeforeEntity", n[n.BeforeNumericEntity = 26] = "BeforeNumericEntity", n[n.InNamedEntity = 27] = "InNamedEntity", n[n.InNumericEntity = 28] = "InNumericEntity", n[n.InHexEntity = 29] = "InHexEntity";
    })(u || (u = {}));
    function i(n) {
      return n === r.Space || n === r.NewLine || n === r.Tab || n === r.FormFeed || n === r.CarriageReturn;
    }
    function c(n) {
      return n === r.Slash || n === r.Gt || i(n);
    }
    function a(n) {
      return n >= r.Zero && n <= r.Nine;
    }
    function l(n) {
      return n >= r.LowerA && n <= r.LowerZ || n >= r.UpperA && n <= r.UpperZ;
    }
    function d(n) {
      return n >= r.UpperA && n <= r.UpperF || n >= r.LowerA && n <= r.LowerF;
    }
    var o;
    (function(n) {
      n[n.NoValue = 0] = "NoValue", n[n.Unquoted = 1] = "Unquoted", n[n.Single = 2] = "Single", n[n.Double = 3] = "Double";
    })(o = e.QuoteType || (e.QuoteType = {}));
    var f = {
      Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
      CdataEnd: new Uint8Array([93, 93, 62]),
      CommentEnd: new Uint8Array([45, 45, 62]),
      ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
      StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
      TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
      // `</title`
    }, p = (
      /** @class */
      function() {
        function n(s, m) {
          var b = s.xmlMode, g = b === void 0 ? !1 : b, h = s.decodeEntities, v = h === void 0 ? !0 : h;
          this.cbs = m, this.state = u.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = u.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = g, this.decodeEntities = v, this.entityTrie = g ? t.xmlDecodeTree : t.htmlDecodeTree;
        }
        return n.prototype.reset = function() {
          this.state = u.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = u.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
        }, n.prototype.write = function(s) {
          this.offset += this.buffer.length, this.buffer = s, this.parse();
        }, n.prototype.end = function() {
          this.running && this.finish();
        }, n.prototype.pause = function() {
          this.running = !1;
        }, n.prototype.resume = function() {
          this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
        }, n.prototype.getIndex = function() {
          return this.index;
        }, n.prototype.getSectionStart = function() {
          return this.sectionStart;
        }, n.prototype.stateText = function(s) {
          s === r.Lt || !this.decodeEntities && this.fastForwardTo(r.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = u.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && s === r.Amp && (this.state = u.BeforeEntity);
        }, n.prototype.stateSpecialStartSequence = function(s) {
          var m = this.sequenceIndex === this.currentSequence.length, b = m ? (
            // If we are at the end of the sequence, make sure the tag name has ended
            c(s)
          ) : (
            // Otherwise, do a case-insensitive comparison
            (s | 32) === this.currentSequence[this.sequenceIndex]
          );
          if (!b)
            this.isSpecial = !1;
          else if (!m) {
            this.sequenceIndex++;
            return;
          }
          this.sequenceIndex = 0, this.state = u.InTagName, this.stateInTagName(s);
        }, n.prototype.stateInSpecialTag = function(s) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (s === r.Gt || i(s)) {
              var m = this.index - this.currentSequence.length;
              if (this.sectionStart < m) {
                var b = this.index;
                this.index = m, this.cbs.ontext(this.sectionStart, m), this.index = b;
              }
              this.isSpecial = !1, this.sectionStart = m + 2, this.stateInClosingTagName(s);
              return;
            }
            this.sequenceIndex = 0;
          }
          (s | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === f.TitleEnd ? this.decodeEntities && s === r.Amp && (this.state = u.BeforeEntity) : this.fastForwardTo(r.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(s === r.Lt);
        }, n.prototype.stateCDATASequence = function(s) {
          s === f.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === f.Cdata.length && (this.state = u.InCommentLike, this.currentSequence = f.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = u.InDeclaration, this.stateInDeclaration(s));
        }, n.prototype.fastForwardTo = function(s) {
          for (; ++this.index < this.buffer.length + this.offset; )
            if (this.buffer.charCodeAt(this.index - this.offset) === s)
              return !0;
          return this.index = this.buffer.length + this.offset - 1, !1;
        }, n.prototype.stateInCommentLike = function(s) {
          s === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === f.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = u.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : s !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
        }, n.prototype.isTagStartChar = function(s) {
          return this.xmlMode ? !c(s) : l(s);
        }, n.prototype.startSpecial = function(s, m) {
          this.isSpecial = !0, this.currentSequence = s, this.sequenceIndex = m, this.state = u.SpecialStartSequence;
        }, n.prototype.stateBeforeTagName = function(s) {
          if (s === r.ExclamationMark)
            this.state = u.BeforeDeclaration, this.sectionStart = this.index + 1;
          else if (s === r.Questionmark)
            this.state = u.InProcessingInstruction, this.sectionStart = this.index + 1;
          else if (this.isTagStartChar(s)) {
            var m = s | 32;
            this.sectionStart = this.index, !this.xmlMode && m === f.TitleEnd[2] ? this.startSpecial(f.TitleEnd, 3) : this.state = !this.xmlMode && m === f.ScriptEnd[2] ? u.BeforeSpecialS : u.InTagName;
          } else s === r.Slash ? this.state = u.BeforeClosingTagName : (this.state = u.Text, this.stateText(s));
        }, n.prototype.stateInTagName = function(s) {
          c(s) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(s));
        }, n.prototype.stateBeforeClosingTagName = function(s) {
          i(s) || (s === r.Gt ? this.state = u.Text : (this.state = this.isTagStartChar(s) ? u.InClosingTagName : u.InSpecialComment, this.sectionStart = this.index));
        }, n.prototype.stateInClosingTagName = function(s) {
          (s === r.Gt || i(s)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.AfterClosingTagName, this.stateAfterClosingTagName(s));
        }, n.prototype.stateAfterClosingTagName = function(s) {
          (s === r.Gt || this.fastForwardTo(r.Gt)) && (this.state = u.Text, this.baseState = u.Text, this.sectionStart = this.index + 1);
        }, n.prototype.stateBeforeAttributeName = function(s) {
          s === r.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = u.InSpecialTag, this.sequenceIndex = 0) : this.state = u.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : s === r.Slash ? this.state = u.InSelfClosingTag : i(s) || (this.state = u.InAttributeName, this.sectionStart = this.index);
        }, n.prototype.stateInSelfClosingTag = function(s) {
          s === r.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = u.Text, this.baseState = u.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : i(s) || (this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(s));
        }, n.prototype.stateInAttributeName = function(s) {
          (s === r.Eq || c(s)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.AfterAttributeName, this.stateAfterAttributeName(s));
        }, n.prototype.stateAfterAttributeName = function(s) {
          s === r.Eq ? this.state = u.BeforeAttributeValue : s === r.Slash || s === r.Gt ? (this.cbs.onattribend(o.NoValue, this.index), this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(s)) : i(s) || (this.cbs.onattribend(o.NoValue, this.index), this.state = u.InAttributeName, this.sectionStart = this.index);
        }, n.prototype.stateBeforeAttributeValue = function(s) {
          s === r.DoubleQuote ? (this.state = u.InAttributeValueDq, this.sectionStart = this.index + 1) : s === r.SingleQuote ? (this.state = u.InAttributeValueSq, this.sectionStart = this.index + 1) : i(s) || (this.sectionStart = this.index, this.state = u.InAttributeValueNq, this.stateInAttributeValueNoQuotes(s));
        }, n.prototype.handleInAttributeValue = function(s, m) {
          s === m || !this.decodeEntities && this.fastForwardTo(m) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(m === r.DoubleQuote ? o.Double : o.Single, this.index), this.state = u.BeforeAttributeName) : this.decodeEntities && s === r.Amp && (this.baseState = this.state, this.state = u.BeforeEntity);
        }, n.prototype.stateInAttributeValueDoubleQuotes = function(s) {
          this.handleInAttributeValue(s, r.DoubleQuote);
        }, n.prototype.stateInAttributeValueSingleQuotes = function(s) {
          this.handleInAttributeValue(s, r.SingleQuote);
        }, n.prototype.stateInAttributeValueNoQuotes = function(s) {
          i(s) || s === r.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(o.Unquoted, this.index), this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(s)) : this.decodeEntities && s === r.Amp && (this.baseState = this.state, this.state = u.BeforeEntity);
        }, n.prototype.stateBeforeDeclaration = function(s) {
          s === r.OpeningSquareBracket ? (this.state = u.CDATASequence, this.sequenceIndex = 0) : this.state = s === r.Dash ? u.BeforeComment : u.InDeclaration;
        }, n.prototype.stateInDeclaration = function(s) {
          (s === r.Gt || this.fastForwardTo(r.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = u.Text, this.sectionStart = this.index + 1);
        }, n.prototype.stateInProcessingInstruction = function(s) {
          (s === r.Gt || this.fastForwardTo(r.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = u.Text, this.sectionStart = this.index + 1);
        }, n.prototype.stateBeforeComment = function(s) {
          s === r.Dash ? (this.state = u.InCommentLike, this.currentSequence = f.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = u.InDeclaration;
        }, n.prototype.stateInSpecialComment = function(s) {
          (s === r.Gt || this.fastForwardTo(r.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = u.Text, this.sectionStart = this.index + 1);
        }, n.prototype.stateBeforeSpecialS = function(s) {
          var m = s | 32;
          m === f.ScriptEnd[3] ? this.startSpecial(f.ScriptEnd, 4) : m === f.StyleEnd[3] ? this.startSpecial(f.StyleEnd, 4) : (this.state = u.InTagName, this.stateInTagName(s));
        }, n.prototype.stateBeforeEntity = function(s) {
          this.entityExcess = 1, this.entityResult = 0, s === r.Number ? this.state = u.BeforeNumericEntity : s === r.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = u.InNamedEntity, this.stateInNamedEntity(s));
        }, n.prototype.stateInNamedEntity = function(s) {
          if (this.entityExcess += 1, this.trieIndex = (0, t.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, s), this.trieIndex < 0) {
            this.emitNamedEntity(), this.index--;
            return;
          }
          this.trieCurrent = this.entityTrie[this.trieIndex];
          var m = this.trieCurrent & t.BinTrieFlags.VALUE_LENGTH;
          if (m) {
            var b = (m >> 14) - 1;
            if (!this.allowLegacyEntity() && s !== r.Semi)
              this.trieIndex += b;
            else {
              var g = this.index - this.entityExcess + 1;
              g > this.sectionStart && this.emitPartial(this.sectionStart, g), this.entityResult = this.trieIndex, this.trieIndex += b, this.entityExcess = 0, this.sectionStart = this.index + 1, b === 0 && this.emitNamedEntity();
            }
          }
        }, n.prototype.emitNamedEntity = function() {
          if (this.state = this.baseState, this.entityResult !== 0) {
            var s = (this.entityTrie[this.entityResult] & t.BinTrieFlags.VALUE_LENGTH) >> 14;
            switch (s) {
              case 1: {
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~t.BinTrieFlags.VALUE_LENGTH);
                break;
              }
              case 2: {
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
              }
              case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
            }
          }
        }, n.prototype.stateBeforeNumericEntity = function(s) {
          (s | 32) === r.LowerX ? (this.entityExcess++, this.state = u.InHexEntity) : (this.state = u.InNumericEntity, this.stateInNumericEntity(s));
        }, n.prototype.emitNumericEntity = function(s) {
          var m = this.index - this.entityExcess - 1, b = m + 2 + +(this.state === u.InHexEntity);
          b !== this.index && (m > this.sectionStart && this.emitPartial(this.sectionStart, m), this.sectionStart = this.index + Number(s), this.emitCodePoint((0, t.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
        }, n.prototype.stateInNumericEntity = function(s) {
          s === r.Semi ? this.emitNumericEntity(!0) : a(s) ? (this.entityResult = this.entityResult * 10 + (s - r.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, n.prototype.stateInHexEntity = function(s) {
          s === r.Semi ? this.emitNumericEntity(!0) : a(s) ? (this.entityResult = this.entityResult * 16 + (s - r.Zero), this.entityExcess++) : d(s) ? (this.entityResult = this.entityResult * 16 + ((s | 32) - r.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, n.prototype.allowLegacyEntity = function() {
          return !this.xmlMode && (this.baseState === u.Text || this.baseState === u.InSpecialTag);
        }, n.prototype.cleanup = function() {
          this.running && this.sectionStart !== this.index && (this.state === u.Text || this.state === u.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === u.InAttributeValueDq || this.state === u.InAttributeValueSq || this.state === u.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
        }, n.prototype.shouldContinue = function() {
          return this.index < this.buffer.length + this.offset && this.running;
        }, n.prototype.parse = function() {
          for (; this.shouldContinue(); ) {
            var s = this.buffer.charCodeAt(this.index - this.offset);
            switch (this.state) {
              case u.Text: {
                this.stateText(s);
                break;
              }
              case u.SpecialStartSequence: {
                this.stateSpecialStartSequence(s);
                break;
              }
              case u.InSpecialTag: {
                this.stateInSpecialTag(s);
                break;
              }
              case u.CDATASequence: {
                this.stateCDATASequence(s);
                break;
              }
              case u.InAttributeValueDq: {
                this.stateInAttributeValueDoubleQuotes(s);
                break;
              }
              case u.InAttributeName: {
                this.stateInAttributeName(s);
                break;
              }
              case u.InCommentLike: {
                this.stateInCommentLike(s);
                break;
              }
              case u.InSpecialComment: {
                this.stateInSpecialComment(s);
                break;
              }
              case u.BeforeAttributeName: {
                this.stateBeforeAttributeName(s);
                break;
              }
              case u.InTagName: {
                this.stateInTagName(s);
                break;
              }
              case u.InClosingTagName: {
                this.stateInClosingTagName(s);
                break;
              }
              case u.BeforeTagName: {
                this.stateBeforeTagName(s);
                break;
              }
              case u.AfterAttributeName: {
                this.stateAfterAttributeName(s);
                break;
              }
              case u.InAttributeValueSq: {
                this.stateInAttributeValueSingleQuotes(s);
                break;
              }
              case u.BeforeAttributeValue: {
                this.stateBeforeAttributeValue(s);
                break;
              }
              case u.BeforeClosingTagName: {
                this.stateBeforeClosingTagName(s);
                break;
              }
              case u.AfterClosingTagName: {
                this.stateAfterClosingTagName(s);
                break;
              }
              case u.BeforeSpecialS: {
                this.stateBeforeSpecialS(s);
                break;
              }
              case u.InAttributeValueNq: {
                this.stateInAttributeValueNoQuotes(s);
                break;
              }
              case u.InSelfClosingTag: {
                this.stateInSelfClosingTag(s);
                break;
              }
              case u.InDeclaration: {
                this.stateInDeclaration(s);
                break;
              }
              case u.BeforeDeclaration: {
                this.stateBeforeDeclaration(s);
                break;
              }
              case u.BeforeComment: {
                this.stateBeforeComment(s);
                break;
              }
              case u.InProcessingInstruction: {
                this.stateInProcessingInstruction(s);
                break;
              }
              case u.InNamedEntity: {
                this.stateInNamedEntity(s);
                break;
              }
              case u.BeforeEntity: {
                this.stateBeforeEntity(s);
                break;
              }
              case u.InHexEntity: {
                this.stateInHexEntity(s);
                break;
              }
              case u.InNumericEntity: {
                this.stateInNumericEntity(s);
                break;
              }
              default:
                this.stateBeforeNumericEntity(s);
            }
            this.index++;
          }
          this.cleanup();
        }, n.prototype.finish = function() {
          this.state === u.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
        }, n.prototype.handleTrailingData = function() {
          var s = this.buffer.length + this.offset;
          this.state === u.InCommentLike ? this.currentSequence === f.CdataEnd ? this.cbs.oncdata(this.sectionStart, s, 0) : this.cbs.oncomment(this.sectionStart, s, 0) : this.state === u.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === u.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === u.InTagName || this.state === u.BeforeAttributeName || this.state === u.BeforeAttributeValue || this.state === u.AfterAttributeName || this.state === u.InAttributeName || this.state === u.InAttributeValueSq || this.state === u.InAttributeValueDq || this.state === u.InAttributeValueNq || this.state === u.InClosingTagName || this.cbs.ontext(this.sectionStart, s);
        }, n.prototype.emitPartial = function(s, m) {
          this.baseState !== u.Text && this.baseState !== u.InSpecialTag ? this.cbs.onattribdata(s, m) : this.cbs.ontext(s, m);
        }, n.prototype.emitCodePoint = function(s) {
          this.baseState !== u.Text && this.baseState !== u.InSpecialTag ? this.cbs.onattribentity(s) : this.cbs.ontextentity(s);
        }, n;
      }()
    );
    e.default = p;
  }(Jt)), Jt;
}
var vu;
function xu() {
  if (vu) return Ae;
  vu = 1;
  var e = Ae && Ae.__createBinding || (Object.create ? function(g, h, v, x) {
    x === void 0 && (x = v);
    var _ = Object.getOwnPropertyDescriptor(h, v);
    (!_ || ("get" in _ ? !h.__esModule : _.writable || _.configurable)) && (_ = { enumerable: !0, get: function() {
      return h[v];
    } }), Object.defineProperty(g, x, _);
  } : function(g, h, v, x) {
    x === void 0 && (x = v), g[x] = h[v];
  }), t = Ae && Ae.__setModuleDefault || (Object.create ? function(g, h) {
    Object.defineProperty(g, "default", { enumerable: !0, value: h });
  } : function(g, h) {
    g.default = h;
  }), r = Ae && Ae.__importStar || function(g) {
    if (g && g.__esModule) return g;
    var h = {};
    if (g != null) for (var v in g) v !== "default" && Object.prototype.hasOwnProperty.call(g, v) && e(h, g, v);
    return t(h, g), h;
  };
  Object.defineProperty(Ae, "__esModule", { value: !0 }), Ae.Parser = void 0;
  var u = r(/* @__PURE__ */ Sn()), i = /* @__PURE__ */ zt(), c = /* @__PURE__ */ new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
  ]), a = /* @__PURE__ */ new Set(["p"]), l = /* @__PURE__ */ new Set(["thead", "tbody"]), d = /* @__PURE__ */ new Set(["dd", "dt"]), o = /* @__PURE__ */ new Set(["rt", "rp"]), f = /* @__PURE__ */ new Map([
    ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
    ["th", /* @__PURE__ */ new Set(["th"])],
    ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
    ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
    ["li", /* @__PURE__ */ new Set(["li"])],
    ["p", a],
    ["h1", a],
    ["h2", a],
    ["h3", a],
    ["h4", a],
    ["h5", a],
    ["h6", a],
    ["select", c],
    ["input", c],
    ["output", c],
    ["button", c],
    ["datalist", c],
    ["textarea", c],
    ["option", /* @__PURE__ */ new Set(["option"])],
    ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
    ["dd", d],
    ["dt", d],
    ["address", a],
    ["article", a],
    ["aside", a],
    ["blockquote", a],
    ["details", a],
    ["div", a],
    ["dl", a],
    ["fieldset", a],
    ["figcaption", a],
    ["figure", a],
    ["footer", a],
    ["form", a],
    ["header", a],
    ["hr", a],
    ["main", a],
    ["nav", a],
    ["ol", a],
    ["pre", a],
    ["section", a],
    ["table", a],
    ["ul", a],
    ["rt", o],
    ["rp", o],
    ["tbody", l],
    ["tfoot", l]
  ]), p = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]), n = /* @__PURE__ */ new Set(["math", "svg"]), s = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
  ]), m = /\s|\//, b = (
    /** @class */
    function() {
      function g(h, v) {
        v === void 0 && (v = {});
        var x, _, y, w, S;
        this.options = v, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = h ?? {}, this.lowerCaseTagNames = (x = v.lowerCaseTags) !== null && x !== void 0 ? x : !v.xmlMode, this.lowerCaseAttributeNames = (_ = v.lowerCaseAttributeNames) !== null && _ !== void 0 ? _ : !v.xmlMode, this.tokenizer = new ((y = v.Tokenizer) !== null && y !== void 0 ? y : u.default)(this.options, this), (S = (w = this.cbs).onparserinit) === null || S === void 0 || S.call(w, this);
      }
      return g.prototype.ontext = function(h, v) {
        var x, _, y = this.getSlice(h, v);
        this.endIndex = v - 1, (_ = (x = this.cbs).ontext) === null || _ === void 0 || _.call(x, y), this.startIndex = v;
      }, g.prototype.ontextentity = function(h) {
        var v, x, _ = this.tokenizer.getSectionStart();
        this.endIndex = _ - 1, (x = (v = this.cbs).ontext) === null || x === void 0 || x.call(v, (0, i.fromCodePoint)(h)), this.startIndex = _;
      }, g.prototype.isVoidElement = function(h) {
        return !this.options.xmlMode && p.has(h);
      }, g.prototype.onopentagname = function(h, v) {
        this.endIndex = v;
        var x = this.getSlice(h, v);
        this.lowerCaseTagNames && (x = x.toLowerCase()), this.emitOpenTag(x);
      }, g.prototype.emitOpenTag = function(h) {
        var v, x, _, y;
        this.openTagStart = this.startIndex, this.tagname = h;
        var w = !this.options.xmlMode && f.get(h);
        if (w)
          for (; this.stack.length > 0 && w.has(this.stack[this.stack.length - 1]); ) {
            var S = this.stack.pop();
            (x = (v = this.cbs).onclosetag) === null || x === void 0 || x.call(v, S, !0);
          }
        this.isVoidElement(h) || (this.stack.push(h), n.has(h) ? this.foreignContext.push(!0) : s.has(h) && this.foreignContext.push(!1)), (y = (_ = this.cbs).onopentagname) === null || y === void 0 || y.call(_, h), this.cbs.onopentag && (this.attribs = {});
      }, g.prototype.endOpenTag = function(h) {
        var v, x;
        this.startIndex = this.openTagStart, this.attribs && ((x = (v = this.cbs).onopentag) === null || x === void 0 || x.call(v, this.tagname, this.attribs, h), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
      }, g.prototype.onopentagend = function(h) {
        this.endIndex = h, this.endOpenTag(!1), this.startIndex = h + 1;
      }, g.prototype.onclosetag = function(h, v) {
        var x, _, y, w, S, k;
        this.endIndex = v;
        var $ = this.getSlice(h, v);
        if (this.lowerCaseTagNames && ($ = $.toLowerCase()), (n.has($) || s.has($)) && this.foreignContext.pop(), this.isVoidElement($))
          !this.options.xmlMode && $ === "br" && ((_ = (x = this.cbs).onopentagname) === null || _ === void 0 || _.call(x, "br"), (w = (y = this.cbs).onopentag) === null || w === void 0 || w.call(y, "br", {}, !0), (k = (S = this.cbs).onclosetag) === null || k === void 0 || k.call(S, "br", !1));
        else {
          var D = this.stack.lastIndexOf($);
          if (D !== -1)
            if (this.cbs.onclosetag)
              for (var T = this.stack.length - D; T--; )
                this.cbs.onclosetag(this.stack.pop(), T !== 0);
            else
              this.stack.length = D;
          else !this.options.xmlMode && $ === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
        }
        this.startIndex = v + 1;
      }, g.prototype.onselfclosingtag = function(h) {
        this.endIndex = h, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = h + 1) : this.onopentagend(h);
      }, g.prototype.closeCurrentTag = function(h) {
        var v, x, _ = this.tagname;
        this.endOpenTag(h), this.stack[this.stack.length - 1] === _ && ((x = (v = this.cbs).onclosetag) === null || x === void 0 || x.call(v, _, !h), this.stack.pop());
      }, g.prototype.onattribname = function(h, v) {
        this.startIndex = h;
        var x = this.getSlice(h, v);
        this.attribname = this.lowerCaseAttributeNames ? x.toLowerCase() : x;
      }, g.prototype.onattribdata = function(h, v) {
        this.attribvalue += this.getSlice(h, v);
      }, g.prototype.onattribentity = function(h) {
        this.attribvalue += (0, i.fromCodePoint)(h);
      }, g.prototype.onattribend = function(h, v) {
        var x, _;
        this.endIndex = v, (_ = (x = this.cbs).onattribute) === null || _ === void 0 || _.call(x, this.attribname, this.attribvalue, h === u.QuoteType.Double ? '"' : h === u.QuoteType.Single ? "'" : h === u.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
      }, g.prototype.getInstructionName = function(h) {
        var v = h.search(m), x = v < 0 ? h : h.substr(0, v);
        return this.lowerCaseTagNames && (x = x.toLowerCase()), x;
      }, g.prototype.ondeclaration = function(h, v) {
        this.endIndex = v;
        var x = this.getSlice(h, v);
        if (this.cbs.onprocessinginstruction) {
          var _ = this.getInstructionName(x);
          this.cbs.onprocessinginstruction("!".concat(_), "!".concat(x));
        }
        this.startIndex = v + 1;
      }, g.prototype.onprocessinginstruction = function(h, v) {
        this.endIndex = v;
        var x = this.getSlice(h, v);
        if (this.cbs.onprocessinginstruction) {
          var _ = this.getInstructionName(x);
          this.cbs.onprocessinginstruction("?".concat(_), "?".concat(x));
        }
        this.startIndex = v + 1;
      }, g.prototype.oncomment = function(h, v, x) {
        var _, y, w, S;
        this.endIndex = v, (y = (_ = this.cbs).oncomment) === null || y === void 0 || y.call(_, this.getSlice(h, v - x)), (S = (w = this.cbs).oncommentend) === null || S === void 0 || S.call(w), this.startIndex = v + 1;
      }, g.prototype.oncdata = function(h, v, x) {
        var _, y, w, S, k, $, D, T, A, P;
        this.endIndex = v;
        var L = this.getSlice(h, v - x);
        this.options.xmlMode || this.options.recognizeCDATA ? ((y = (_ = this.cbs).oncdatastart) === null || y === void 0 || y.call(_), (S = (w = this.cbs).ontext) === null || S === void 0 || S.call(w, L), ($ = (k = this.cbs).oncdataend) === null || $ === void 0 || $.call(k)) : ((T = (D = this.cbs).oncomment) === null || T === void 0 || T.call(D, "[CDATA[".concat(L, "]]")), (P = (A = this.cbs).oncommentend) === null || P === void 0 || P.call(A)), this.startIndex = v + 1;
      }, g.prototype.onend = function() {
        var h, v;
        if (this.cbs.onclosetag) {
          this.endIndex = this.startIndex;
          for (var x = this.stack.length; x > 0; this.cbs.onclosetag(this.stack[--x], !0))
            ;
        }
        (v = (h = this.cbs).onend) === null || v === void 0 || v.call(h);
      }, g.prototype.reset = function() {
        var h, v, x, _;
        (v = (h = this.cbs).onreset) === null || v === void 0 || v.call(h), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (_ = (x = this.cbs).onparserinit) === null || _ === void 0 || _.call(x, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
      }, g.prototype.parseComplete = function(h) {
        this.reset(), this.end(h);
      }, g.prototype.getSlice = function(h, v) {
        for (; h - this.bufferOffset >= this.buffers[0].length; )
          this.shiftBuffer();
        for (var x = this.buffers[0].slice(h - this.bufferOffset, v - this.bufferOffset); v - this.bufferOffset > this.buffers[0].length; )
          this.shiftBuffer(), x += this.buffers[0].slice(0, v - this.bufferOffset);
        return x;
      }, g.prototype.shiftBuffer = function() {
        this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
      }, g.prototype.write = function(h) {
        var v, x;
        if (this.ended) {
          (x = (v = this.cbs).onerror) === null || x === void 0 || x.call(v, new Error(".write() after done!"));
          return;
        }
        this.buffers.push(h), this.tokenizer.running && (this.tokenizer.write(h), this.writeIndex++);
      }, g.prototype.end = function(h) {
        var v, x;
        if (this.ended) {
          (x = (v = this.cbs).onerror) === null || x === void 0 || x.call(v, new Error(".end() after done!"));
          return;
        }
        h && this.write(h), this.ended = !0, this.tokenizer.end();
      }, g.prototype.pause = function() {
        this.tokenizer.pause();
      }, g.prototype.resume = function() {
        for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
          this.tokenizer.write(this.buffers[this.writeIndex++]);
        this.ended && this.tokenizer.end();
      }, g.prototype.parseChunk = function(h) {
        this.write(h);
      }, g.prototype.done = function(h) {
        this.end(h);
      }, g;
    }()
  );
  return Ae.Parser = b, Ae;
}
var it = {}, Xt = {}, wu;
function pt() {
  return wu || (wu = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
    var t;
    (function(u) {
      u.Root = "root", u.Text = "text", u.Directive = "directive", u.Comment = "comment", u.Script = "script", u.Style = "style", u.Tag = "tag", u.CDATA = "cdata", u.Doctype = "doctype";
    })(t = e.ElementType || (e.ElementType = {}));
    function r(u) {
      return u.type === t.Tag || u.type === t.Script || u.type === t.Style;
    }
    e.isTag = r, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
  }(Xt)), Xt;
}
var J = {}, _u;
function Su() {
  if (_u) return J;
  _u = 1;
  var e = J && J.__extends || /* @__PURE__ */ function() {
    var y = function(w, S) {
      return y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(k, $) {
        k.__proto__ = $;
      } || function(k, $) {
        for (var D in $) Object.prototype.hasOwnProperty.call($, D) && (k[D] = $[D]);
      }, y(w, S);
    };
    return function(w, S) {
      if (typeof S != "function" && S !== null)
        throw new TypeError("Class extends value " + String(S) + " is not a constructor or null");
      y(w, S);
      function k() {
        this.constructor = w;
      }
      w.prototype = S === null ? Object.create(S) : (k.prototype = S.prototype, new k());
    };
  }(), t = J && J.__assign || function() {
    return t = Object.assign || function(y) {
      for (var w, S = 1, k = arguments.length; S < k; S++) {
        w = arguments[S];
        for (var $ in w) Object.prototype.hasOwnProperty.call(w, $) && (y[$] = w[$]);
      }
      return y;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(J, "__esModule", { value: !0 }), J.cloneNode = J.hasChildren = J.isDocument = J.isDirective = J.isComment = J.isText = J.isCDATA = J.isTag = J.Element = J.Document = J.CDATA = J.NodeWithChildren = J.ProcessingInstruction = J.Comment = J.Text = J.DataNode = J.Node = void 0;
  var r = /* @__PURE__ */ pt(), u = (
    /** @class */
    function() {
      function y() {
        this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
      }
      return Object.defineProperty(y.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(w) {
          this.parent = w;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(y.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(w) {
          this.prev = w;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(y.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(w) {
          this.next = w;
        },
        enumerable: !1,
        configurable: !0
      }), y.prototype.cloneNode = function(w) {
        return w === void 0 && (w = !1), x(this, w);
      }, y;
    }()
  );
  J.Node = u;
  var i = (
    /** @class */
    function(y) {
      e(w, y);
      function w(S) {
        var k = y.call(this) || this;
        return k.data = S, k;
      }
      return Object.defineProperty(w.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function(S) {
          this.data = S;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(u)
  );
  J.DataNode = i;
  var c = (
    /** @class */
    function(y) {
      e(w, y);
      function w() {
        var S = y !== null && y.apply(this, arguments) || this;
        return S.type = r.ElementType.Text, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 3;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(i)
  );
  J.Text = c;
  var a = (
    /** @class */
    function(y) {
      e(w, y);
      function w() {
        var S = y !== null && y.apply(this, arguments) || this;
        return S.type = r.ElementType.Comment, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 8;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(i)
  );
  J.Comment = a;
  var l = (
    /** @class */
    function(y) {
      e(w, y);
      function w(S, k) {
        var $ = y.call(this, k) || this;
        return $.name = S, $.type = r.ElementType.Directive, $;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(i)
  );
  J.ProcessingInstruction = l;
  var d = (
    /** @class */
    function(y) {
      e(w, y);
      function w(S) {
        var k = y.call(this) || this;
        return k.children = S, k;
      }
      return Object.defineProperty(w.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var S;
          return (S = this.children[0]) !== null && S !== void 0 ? S : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function(S) {
          this.children = S;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(u)
  );
  J.NodeWithChildren = d;
  var o = (
    /** @class */
    function(y) {
      e(w, y);
      function w() {
        var S = y !== null && y.apply(this, arguments) || this;
        return S.type = r.ElementType.CDATA, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 4;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(d)
  );
  J.CDATA = o;
  var f = (
    /** @class */
    function(y) {
      e(w, y);
      function w() {
        var S = y !== null && y.apply(this, arguments) || this;
        return S.type = r.ElementType.Root, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 9;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(d)
  );
  J.Document = f;
  var p = (
    /** @class */
    function(y) {
      e(w, y);
      function w(S, k, $, D) {
        $ === void 0 && ($ = []), D === void 0 && (D = S === "script" ? r.ElementType.Script : S === "style" ? r.ElementType.Style : r.ElementType.Tag);
        var T = y.call(this, $) || this;
        return T.name = S, T.attribs = k, T.type = D, T;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function(S) {
          this.name = S;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "attributes", {
        get: function() {
          var S = this;
          return Object.keys(this.attribs).map(function(k) {
            var $, D;
            return {
              name: k,
              value: S.attribs[k],
              namespace: ($ = S["x-attribsNamespace"]) === null || $ === void 0 ? void 0 : $[k],
              prefix: (D = S["x-attribsPrefix"]) === null || D === void 0 ? void 0 : D[k]
            };
          });
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(d)
  );
  J.Element = p;
  function n(y) {
    return (0, r.isTag)(y);
  }
  J.isTag = n;
  function s(y) {
    return y.type === r.ElementType.CDATA;
  }
  J.isCDATA = s;
  function m(y) {
    return y.type === r.ElementType.Text;
  }
  J.isText = m;
  function b(y) {
    return y.type === r.ElementType.Comment;
  }
  J.isComment = b;
  function g(y) {
    return y.type === r.ElementType.Directive;
  }
  J.isDirective = g;
  function h(y) {
    return y.type === r.ElementType.Root;
  }
  J.isDocument = h;
  function v(y) {
    return Object.prototype.hasOwnProperty.call(y, "children");
  }
  J.hasChildren = v;
  function x(y, w) {
    w === void 0 && (w = !1);
    var S;
    if (m(y))
      S = new c(y.data);
    else if (b(y))
      S = new a(y.data);
    else if (n(y)) {
      var k = w ? _(y.children) : [], $ = new p(y.name, t({}, y.attribs), k);
      k.forEach(function(P) {
        return P.parent = $;
      }), y.namespace != null && ($.namespace = y.namespace), y["x-attribsNamespace"] && ($["x-attribsNamespace"] = t({}, y["x-attribsNamespace"])), y["x-attribsPrefix"] && ($["x-attribsPrefix"] = t({}, y["x-attribsPrefix"])), S = $;
    } else if (s(y)) {
      var k = w ? _(y.children) : [], D = new o(k);
      k.forEach(function(L) {
        return L.parent = D;
      }), S = D;
    } else if (h(y)) {
      var k = w ? _(y.children) : [], T = new f(k);
      k.forEach(function(L) {
        return L.parent = T;
      }), y["x-mode"] && (T["x-mode"] = y["x-mode"]), S = T;
    } else if (g(y)) {
      var A = new l(y.name, y.data);
      y["x-name"] != null && (A["x-name"] = y["x-name"], A["x-publicId"] = y["x-publicId"], A["x-systemId"] = y["x-systemId"]), S = A;
    } else
      throw new Error("Not implemented yet: ".concat(y.type));
    return S.startIndex = y.startIndex, S.endIndex = y.endIndex, y.sourceCodeLocation != null && (S.sourceCodeLocation = y.sourceCodeLocation), S;
  }
  J.cloneNode = x;
  function _(y) {
    for (var w = y.map(function(k) {
      return x(k, !0);
    }), S = 1; S < w.length; S++)
      w[S].prev = w[S - 1], w[S - 1].next = w[S];
    return w;
  }
  return J;
}
var Mu;
function rt() {
  return Mu || (Mu = 1, function(e) {
    var t = it && it.__createBinding || (Object.create ? function(l, d, o, f) {
      f === void 0 && (f = o);
      var p = Object.getOwnPropertyDescriptor(d, o);
      (!p || ("get" in p ? !d.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return d[o];
      } }), Object.defineProperty(l, f, p);
    } : function(l, d, o, f) {
      f === void 0 && (f = o), l[f] = d[o];
    }), r = it && it.__exportStar || function(l, d) {
      for (var o in l) o !== "default" && !Object.prototype.hasOwnProperty.call(d, o) && t(d, l, o);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
    var u = /* @__PURE__ */ pt(), i = /* @__PURE__ */ Su();
    r(/* @__PURE__ */ Su(), e);
    var c = {
      withStartIndices: !1,
      withEndIndices: !1,
      xmlMode: !1
    }, a = (
      /** @class */
      function() {
        function l(d, o, f) {
          this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof o == "function" && (f = o, o = c), typeof d == "object" && (o = d, d = void 0), this.callback = d ?? null, this.options = o ?? c, this.elementCB = f ?? null;
        }
        return l.prototype.onparserinit = function(d) {
          this.parser = d;
        }, l.prototype.onreset = function() {
          this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
        }, l.prototype.onend = function() {
          this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
        }, l.prototype.onerror = function(d) {
          this.handleCallback(d);
        }, l.prototype.onclosetag = function() {
          this.lastNode = null;
          var d = this.tagStack.pop();
          this.options.withEndIndices && (d.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(d);
        }, l.prototype.onopentag = function(d, o) {
          var f = this.options.xmlMode ? u.ElementType.Tag : void 0, p = new i.Element(d, o, void 0, f);
          this.addNode(p), this.tagStack.push(p);
        }, l.prototype.ontext = function(d) {
          var o = this.lastNode;
          if (o && o.type === u.ElementType.Text)
            o.data += d, this.options.withEndIndices && (o.endIndex = this.parser.endIndex);
          else {
            var f = new i.Text(d);
            this.addNode(f), this.lastNode = f;
          }
        }, l.prototype.oncomment = function(d) {
          if (this.lastNode && this.lastNode.type === u.ElementType.Comment) {
            this.lastNode.data += d;
            return;
          }
          var o = new i.Comment(d);
          this.addNode(o), this.lastNode = o;
        }, l.prototype.oncommentend = function() {
          this.lastNode = null;
        }, l.prototype.oncdatastart = function() {
          var d = new i.Text(""), o = new i.CDATA([d]);
          this.addNode(o), d.parent = o, this.lastNode = d;
        }, l.prototype.oncdataend = function() {
          this.lastNode = null;
        }, l.prototype.onprocessinginstruction = function(d, o) {
          var f = new i.ProcessingInstruction(d, o);
          this.addNode(f);
        }, l.prototype.handleCallback = function(d) {
          if (typeof this.callback == "function")
            this.callback(d, this.dom);
          else if (d)
            throw d;
        }, l.prototype.addNode = function(d) {
          var o = this.tagStack[this.tagStack.length - 1], f = o.children[o.children.length - 1];
          this.options.withStartIndices && (d.startIndex = this.parser.startIndex), this.options.withEndIndices && (d.endIndex = this.parser.endIndex), o.children.push(d), f && (d.prev = f, f.next = d), d.parent = o, this.lastNode = null;
        }, l;
      }()
    );
    e.DomHandler = a, e.default = a;
  }(it)), it;
}
var at = {}, He = {}, we = {}, er = {}, Be = {}, yt = {}, ku;
function Ki() {
  if (ku) return yt;
  ku = 1, Object.defineProperty(yt, "__esModule", { value: !0 });
  function e(t) {
    for (var r = 1; r < t.length; r++)
      t[r][0] += t[r - 1][0] + 1;
    return t;
  }
  return yt.default = new Map(/* @__PURE__ */ e([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ e([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ e([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ e([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]])), yt;
}
var tr = {}, Tu;
function Ir() {
  return Tu || (Tu = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.getCodePoint = e.xmlReplacer = void 0, e.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
    var t = /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [39, "&apos;"],
      [60, "&lt;"],
      [62, "&gt;"]
    ]);
    e.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? function(i, c) {
      return i.codePointAt(c);
    } : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(i, c) {
        return (i.charCodeAt(c) & 64512) === 55296 ? (i.charCodeAt(c) - 55296) * 1024 + i.charCodeAt(c + 1) - 56320 + 65536 : i.charCodeAt(c);
      }
    );
    function r(i) {
      for (var c = "", a = 0, l; (l = e.xmlReplacer.exec(i)) !== null; ) {
        var d = l.index, o = i.charCodeAt(d), f = t.get(o);
        f !== void 0 ? (c += i.substring(a, d) + f, a = d + 1) : (c += "".concat(i.substring(a, d), "&#x").concat((0, e.getCodePoint)(i, d).toString(16), ";"), a = e.xmlReplacer.lastIndex += +((o & 64512) === 55296));
      }
      return c + i.substr(a);
    }
    e.encodeXML = r, e.escape = r;
    function u(i, c) {
      return function(l) {
        for (var d, o = 0, f = ""; d = i.exec(l); )
          o !== d.index && (f += l.substring(o, d.index)), f += c.get(d[0].charCodeAt(0)), o = d.index + 1;
        return f + l.substring(o);
      };
    }
    e.escapeUTF8 = u(/[&<>'"]/g, t), e.escapeAttribute = u(/["&\u00A0]/g, /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [160, "&nbsp;"]
    ])), e.escapeText = u(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
      [38, "&amp;"],
      [60, "&lt;"],
      [62, "&gt;"],
      [160, "&nbsp;"]
    ]));
  }(tr)), tr;
}
var Eu;
function Au() {
  if (Eu) return Be;
  Eu = 1;
  var e = Be && Be.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(Be, "__esModule", { value: !0 }), Be.encodeNonAsciiHTML = Be.encodeHTML = void 0;
  var t = e(/* @__PURE__ */ Ki()), r = /* @__PURE__ */ Ir(), u = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
  function i(l) {
    return a(u, l);
  }
  Be.encodeHTML = i;
  function c(l) {
    return a(r.xmlReplacer, l);
  }
  Be.encodeNonAsciiHTML = c;
  function a(l, d) {
    for (var o = "", f = 0, p; (p = l.exec(d)) !== null; ) {
      var n = p.index;
      o += d.substring(f, n);
      var s = d.charCodeAt(n), m = t.default.get(s);
      if (typeof m == "object") {
        if (n + 1 < d.length) {
          var b = d.charCodeAt(n + 1), g = typeof m.n == "number" ? m.n === b ? m.o : void 0 : m.n.get(b);
          if (g !== void 0) {
            o += g, f = l.lastIndex += 1;
            continue;
          }
        }
        m = m.v;
      }
      if (m !== void 0)
        o += m, f = n + 1;
      else {
        var h = (0, r.getCodePoint)(d, n);
        o += "&#x".concat(h.toString(16), ";"), f = l.lastIndex += +(h !== s);
      }
    }
    return o + d.substr(f);
  }
  return Be;
}
var $u;
function Xi() {
  return $u || ($u = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXMLStrict = e.decodeHTML5Strict = e.decodeHTML4Strict = e.decodeHTML5 = e.decodeHTML4 = e.decodeHTMLAttribute = e.decodeHTMLStrict = e.decodeHTML = e.decodeXML = e.DecodingMode = e.EntityDecoder = e.encodeHTML5 = e.encodeHTML4 = e.encodeNonAsciiHTML = e.encodeHTML = e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.encode = e.decodeStrict = e.decode = e.EncodingMode = e.EntityLevel = void 0;
    var t = /* @__PURE__ */ zt(), r = /* @__PURE__ */ Au(), u = /* @__PURE__ */ Ir(), i;
    (function(n) {
      n[n.XML = 0] = "XML", n[n.HTML = 1] = "HTML";
    })(i = e.EntityLevel || (e.EntityLevel = {}));
    var c;
    (function(n) {
      n[n.UTF8 = 0] = "UTF8", n[n.ASCII = 1] = "ASCII", n[n.Extensive = 2] = "Extensive", n[n.Attribute = 3] = "Attribute", n[n.Text = 4] = "Text";
    })(c = e.EncodingMode || (e.EncodingMode = {}));
    function a(n, s) {
      s === void 0 && (s = i.XML);
      var m = typeof s == "number" ? s : s.level;
      if (m === i.HTML) {
        var b = typeof s == "object" ? s.mode : void 0;
        return (0, t.decodeHTML)(n, b);
      }
      return (0, t.decodeXML)(n);
    }
    e.decode = a;
    function l(n, s) {
      var m;
      s === void 0 && (s = i.XML);
      var b = typeof s == "number" ? { level: s } : s;
      return (m = b.mode) !== null && m !== void 0 || (b.mode = t.DecodingMode.Strict), a(n, b);
    }
    e.decodeStrict = l;
    function d(n, s) {
      s === void 0 && (s = i.XML);
      var m = typeof s == "number" ? { level: s } : s;
      return m.mode === c.UTF8 ? (0, u.escapeUTF8)(n) : m.mode === c.Attribute ? (0, u.escapeAttribute)(n) : m.mode === c.Text ? (0, u.escapeText)(n) : m.level === i.HTML ? m.mode === c.ASCII ? (0, r.encodeNonAsciiHTML)(n) : (0, r.encodeHTML)(n) : (0, u.encodeXML)(n);
    }
    e.encode = d;
    var o = /* @__PURE__ */ Ir();
    Object.defineProperty(e, "encodeXML", { enumerable: !0, get: function() {
      return o.encodeXML;
    } }), Object.defineProperty(e, "escape", { enumerable: !0, get: function() {
      return o.escape;
    } }), Object.defineProperty(e, "escapeUTF8", { enumerable: !0, get: function() {
      return o.escapeUTF8;
    } }), Object.defineProperty(e, "escapeAttribute", { enumerable: !0, get: function() {
      return o.escapeAttribute;
    } }), Object.defineProperty(e, "escapeText", { enumerable: !0, get: function() {
      return o.escapeText;
    } });
    var f = /* @__PURE__ */ Au();
    Object.defineProperty(e, "encodeHTML", { enumerable: !0, get: function() {
      return f.encodeHTML;
    } }), Object.defineProperty(e, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
      return f.encodeNonAsciiHTML;
    } }), Object.defineProperty(e, "encodeHTML4", { enumerable: !0, get: function() {
      return f.encodeHTML;
    } }), Object.defineProperty(e, "encodeHTML5", { enumerable: !0, get: function() {
      return f.encodeHTML;
    } });
    var p = /* @__PURE__ */ zt();
    Object.defineProperty(e, "EntityDecoder", { enumerable: !0, get: function() {
      return p.EntityDecoder;
    } }), Object.defineProperty(e, "DecodingMode", { enumerable: !0, get: function() {
      return p.DecodingMode;
    } }), Object.defineProperty(e, "decodeXML", { enumerable: !0, get: function() {
      return p.decodeXML;
    } }), Object.defineProperty(e, "decodeHTML", { enumerable: !0, get: function() {
      return p.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTMLStrict", { enumerable: !0, get: function() {
      return p.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeHTMLAttribute", { enumerable: !0, get: function() {
      return p.decodeHTMLAttribute;
    } }), Object.defineProperty(e, "decodeHTML4", { enumerable: !0, get: function() {
      return p.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTML5", { enumerable: !0, get: function() {
      return p.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTML4Strict", { enumerable: !0, get: function() {
      return p.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeHTML5Strict", { enumerable: !0, get: function() {
      return p.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeXMLStrict", { enumerable: !0, get: function() {
      return p.decodeXML;
    } });
  }(er)), er;
}
var st = {}, Du;
function ea() {
  return Du || (Du = 1, Object.defineProperty(st, "__esModule", { value: !0 }), st.attributeNames = st.elementNames = void 0, st.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
  ].map(function(e) {
    return [e.toLowerCase(), e];
  })), st.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
  ].map(function(e) {
    return [e.toLowerCase(), e];
  }))), st;
}
var Ou;
function ta() {
  if (Ou) return we;
  Ou = 1;
  var e = we && we.__assign || function() {
    return e = Object.assign || function(_) {
      for (var y, w = 1, S = arguments.length; w < S; w++) {
        y = arguments[w];
        for (var k in y) Object.prototype.hasOwnProperty.call(y, k) && (_[k] = y[k]);
      }
      return _;
    }, e.apply(this, arguments);
  }, t = we && we.__createBinding || (Object.create ? function(_, y, w, S) {
    S === void 0 && (S = w);
    var k = Object.getOwnPropertyDescriptor(y, w);
    (!k || ("get" in k ? !y.__esModule : k.writable || k.configurable)) && (k = { enumerable: !0, get: function() {
      return y[w];
    } }), Object.defineProperty(_, S, k);
  } : function(_, y, w, S) {
    S === void 0 && (S = w), _[S] = y[w];
  }), r = we && we.__setModuleDefault || (Object.create ? function(_, y) {
    Object.defineProperty(_, "default", { enumerable: !0, value: y });
  } : function(_, y) {
    _.default = y;
  }), u = we && we.__importStar || function(_) {
    if (_ && _.__esModule) return _;
    var y = {};
    if (_ != null) for (var w in _) w !== "default" && Object.prototype.hasOwnProperty.call(_, w) && t(y, _, w);
    return r(y, _), y;
  };
  Object.defineProperty(we, "__esModule", { value: !0 }), we.render = void 0;
  var i = u(/* @__PURE__ */ pt()), c = /* @__PURE__ */ Xi(), a = /* @__PURE__ */ ea(), l = /* @__PURE__ */ new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
  ]);
  function d(_) {
    return _.replace(/"/g, "&quot;");
  }
  function o(_, y) {
    var w;
    if (_) {
      var S = ((w = y.encodeEntities) !== null && w !== void 0 ? w : y.decodeEntities) === !1 ? d : y.xmlMode || y.encodeEntities !== "utf8" ? c.encodeXML : c.escapeAttribute;
      return Object.keys(_).map(function(k) {
        var $, D, T = ($ = _[k]) !== null && $ !== void 0 ? $ : "";
        return y.xmlMode === "foreign" && (k = (D = a.attributeNames.get(k)) !== null && D !== void 0 ? D : k), !y.emptyAttrs && !y.xmlMode && T === "" ? k : "".concat(k, '="').concat(S(T), '"');
      }).join(" ");
    }
  }
  var f = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]);
  function p(_, y) {
    y === void 0 && (y = {});
    for (var w = ("length" in _) ? _ : [_], S = "", k = 0; k < w.length; k++)
      S += n(w[k], y);
    return S;
  }
  we.render = p, we.default = p;
  function n(_, y) {
    switch (_.type) {
      case i.Root:
        return p(_.children, y);
      // @ts-expect-error We don't use `Doctype` yet
      case i.Doctype:
      case i.Directive:
        return g(_);
      case i.Comment:
        return x(_);
      case i.CDATA:
        return v(_);
      case i.Script:
      case i.Style:
      case i.Tag:
        return b(_, y);
      case i.Text:
        return h(_, y);
    }
  }
  var s = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
  ]), m = /* @__PURE__ */ new Set(["svg", "math"]);
  function b(_, y) {
    var w;
    y.xmlMode === "foreign" && (_.name = (w = a.elementNames.get(_.name)) !== null && w !== void 0 ? w : _.name, _.parent && s.has(_.parent.name) && (y = e(e({}, y), { xmlMode: !1 }))), !y.xmlMode && m.has(_.name) && (y = e(e({}, y), { xmlMode: "foreign" }));
    var S = "<".concat(_.name), k = o(_.attribs, y);
    return k && (S += " ".concat(k)), _.children.length === 0 && (y.xmlMode ? (
      // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
      y.selfClosingTags !== !1
    ) : (
      // User explicitly asked for self-closing tags, even in HTML mode
      y.selfClosingTags && f.has(_.name)
    )) ? (y.xmlMode || (S += " "), S += "/>") : (S += ">", _.children.length > 0 && (S += p(_.children, y)), (y.xmlMode || !f.has(_.name)) && (S += "</".concat(_.name, ">"))), S;
  }
  function g(_) {
    return "<".concat(_.data, ">");
  }
  function h(_, y) {
    var w, S = _.data || "";
    return ((w = y.encodeEntities) !== null && w !== void 0 ? w : y.decodeEntities) !== !1 && !(!y.xmlMode && _.parent && l.has(_.parent.name)) && (S = y.xmlMode || y.encodeEntities !== "utf8" ? (0, c.encodeXML)(S) : (0, c.escapeText)(S)), S;
  }
  function v(_) {
    return "<![CDATA[".concat(_.children[0].data, "]]>");
  }
  function x(_) {
    return "<!--".concat(_.data, "-->");
  }
  return we;
}
var Lu;
function Mn() {
  if (Lu) return He;
  Lu = 1;
  var e = He && He.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(He, "__esModule", { value: !0 }), He.getOuterHTML = i, He.getInnerHTML = c, He.getText = a, He.textContent = l, He.innerText = d;
  var t = /* @__PURE__ */ rt(), r = e(/* @__PURE__ */ ta()), u = /* @__PURE__ */ pt();
  function i(o, f) {
    return (0, r.default)(o, f);
  }
  function c(o, f) {
    return (0, t.hasChildren)(o) ? o.children.map(function(p) {
      return i(p, f);
    }).join("") : "";
  }
  function a(o) {
    return Array.isArray(o) ? o.map(a).join("") : (0, t.isTag)(o) ? o.name === "br" ? `
` : a(o.children) : (0, t.isCDATA)(o) ? a(o.children) : (0, t.isText)(o) ? o.data : "";
  }
  function l(o) {
    return Array.isArray(o) ? o.map(l).join("") : (0, t.hasChildren)(o) && !(0, t.isComment)(o) ? l(o.children) : (0, t.isText)(o) ? o.data : "";
  }
  function d(o) {
    return Array.isArray(o) ? o.map(d).join("") : (0, t.hasChildren)(o) && (o.type === u.ElementType.Tag || (0, t.isCDATA)(o)) ? d(o.children) : (0, t.isText)(o) ? o.data : "";
  }
  return He;
}
var De = {}, Cu;
function ra() {
  if (Cu) return De;
  Cu = 1, Object.defineProperty(De, "__esModule", { value: !0 }), De.getChildren = t, De.getParent = r, De.getSiblings = u, De.getAttributeValue = i, De.hasAttrib = c, De.getName = a, De.nextElementSibling = l, De.prevElementSibling = d;
  var e = /* @__PURE__ */ rt();
  function t(o) {
    return (0, e.hasChildren)(o) ? o.children : [];
  }
  function r(o) {
    return o.parent || null;
  }
  function u(o) {
    var f, p, n = r(o);
    if (n != null)
      return t(n);
    for (var s = [o], m = o.prev, b = o.next; m != null; )
      s.unshift(m), f = m, m = f.prev;
    for (; b != null; )
      s.push(b), p = b, b = p.next;
    return s;
  }
  function i(o, f) {
    var p;
    return (p = o.attribs) === null || p === void 0 ? void 0 : p[f];
  }
  function c(o, f) {
    return o.attribs != null && Object.prototype.hasOwnProperty.call(o.attribs, f) && o.attribs[f] != null;
  }
  function a(o) {
    return o.name;
  }
  function l(o) {
    for (var f, p = o.next; p !== null && !(0, e.isTag)(p); )
      f = p, p = f.next;
    return p;
  }
  function d(o) {
    for (var f, p = o.prev; p !== null && !(0, e.isTag)(p); )
      f = p, p = f.prev;
    return p;
  }
  return De;
}
var Ye = {}, Iu;
function ua() {
  if (Iu) return Ye;
  Iu = 1, Object.defineProperty(Ye, "__esModule", { value: !0 }), Ye.removeElement = e, Ye.replaceElement = t, Ye.appendChild = r, Ye.append = u, Ye.prependChild = i, Ye.prepend = c;
  function e(a) {
    if (a.prev && (a.prev.next = a.next), a.next && (a.next.prev = a.prev), a.parent) {
      var l = a.parent.children, d = l.lastIndexOf(a);
      d >= 0 && l.splice(d, 1);
    }
    a.next = null, a.prev = null, a.parent = null;
  }
  function t(a, l) {
    var d = l.prev = a.prev;
    d && (d.next = l);
    var o = l.next = a.next;
    o && (o.prev = l);
    var f = l.parent = a.parent;
    if (f) {
      var p = f.children;
      p[p.lastIndexOf(a)] = l, a.parent = null;
    }
  }
  function r(a, l) {
    if (e(l), l.next = null, l.parent = a, a.children.push(l) > 1) {
      var d = a.children[a.children.length - 2];
      d.next = l, l.prev = d;
    } else
      l.prev = null;
  }
  function u(a, l) {
    e(l);
    var d = a.parent, o = a.next;
    if (l.next = o, l.prev = a, a.next = l, l.parent = d, o) {
      if (o.prev = l, d) {
        var f = d.children;
        f.splice(f.lastIndexOf(o), 0, l);
      }
    } else d && d.children.push(l);
  }
  function i(a, l) {
    if (e(l), l.parent = a, l.prev = null, a.children.unshift(l) !== 1) {
      var d = a.children[1];
      d.prev = l, l.next = d;
    } else
      l.next = null;
  }
  function c(a, l) {
    e(l);
    var d = a.parent;
    if (d) {
      var o = d.children;
      o.splice(o.indexOf(a), 0, l);
    }
    a.prev && (a.prev.next = l), l.parent = d, l.prev = a.prev, l.next = a, a.prev = l;
  }
  return Ye;
}
var Ve = {}, Nu;
function kn() {
  if (Nu) return Ve;
  Nu = 1, Object.defineProperty(Ve, "__esModule", { value: !0 }), Ve.filter = t, Ve.find = r, Ve.findOneChild = u, Ve.findOne = i, Ve.existsOne = c, Ve.findAll = a;
  var e = /* @__PURE__ */ rt();
  function t(l, d, o, f) {
    return o === void 0 && (o = !0), f === void 0 && (f = 1 / 0), r(l, Array.isArray(d) ? d : [d], o, f);
  }
  function r(l, d, o, f) {
    for (var p = [], n = [Array.isArray(d) ? d : [d]], s = [0]; ; ) {
      if (s[0] >= n[0].length) {
        if (s.length === 1)
          return p;
        n.shift(), s.shift();
        continue;
      }
      var m = n[0][s[0]++];
      if (l(m) && (p.push(m), --f <= 0))
        return p;
      o && (0, e.hasChildren)(m) && m.children.length > 0 && (s.unshift(0), n.unshift(m.children));
    }
  }
  function u(l, d) {
    return d.find(l);
  }
  function i(l, d, o) {
    o === void 0 && (o = !0);
    for (var f = Array.isArray(d) ? d : [d], p = 0; p < f.length; p++) {
      var n = f[p];
      if ((0, e.isTag)(n) && l(n))
        return n;
      if (o && (0, e.hasChildren)(n) && n.children.length > 0) {
        var s = i(l, n.children, !0);
        if (s)
          return s;
      }
    }
    return null;
  }
  function c(l, d) {
    return (Array.isArray(d) ? d : [d]).some(function(o) {
      return (0, e.isTag)(o) && l(o) || (0, e.hasChildren)(o) && c(l, o.children);
    });
  }
  function a(l, d) {
    for (var o = [], f = [Array.isArray(d) ? d : [d]], p = [0]; ; ) {
      if (p[0] >= f[0].length) {
        if (f.length === 1)
          return o;
        f.shift(), p.shift();
        continue;
      }
      var n = f[0][p[0]++];
      (0, e.isTag)(n) && l(n) && o.push(n), (0, e.hasChildren)(n) && n.children.length > 0 && (p.unshift(0), f.unshift(n.children));
    }
  }
  return Ve;
}
var Ge = {}, Pu;
function Tn() {
  if (Pu) return Ge;
  Pu = 1, Object.defineProperty(Ge, "__esModule", { value: !0 }), Ge.testElement = a, Ge.getElements = l, Ge.getElementById = d, Ge.getElementsByTagName = o, Ge.getElementsByClassName = f, Ge.getElementsByTagType = p;
  var e = /* @__PURE__ */ rt(), t = /* @__PURE__ */ kn(), r = {
    tag_name: function(n) {
      return typeof n == "function" ? function(s) {
        return (0, e.isTag)(s) && n(s.name);
      } : n === "*" ? e.isTag : function(s) {
        return (0, e.isTag)(s) && s.name === n;
      };
    },
    tag_type: function(n) {
      return typeof n == "function" ? function(s) {
        return n(s.type);
      } : function(s) {
        return s.type === n;
      };
    },
    tag_contains: function(n) {
      return typeof n == "function" ? function(s) {
        return (0, e.isText)(s) && n(s.data);
      } : function(s) {
        return (0, e.isText)(s) && s.data === n;
      };
    }
  };
  function u(n, s) {
    return typeof s == "function" ? function(m) {
      return (0, e.isTag)(m) && s(m.attribs[n]);
    } : function(m) {
      return (0, e.isTag)(m) && m.attribs[n] === s;
    };
  }
  function i(n, s) {
    return function(m) {
      return n(m) || s(m);
    };
  }
  function c(n) {
    var s = Object.keys(n).map(function(m) {
      var b = n[m];
      return Object.prototype.hasOwnProperty.call(r, m) ? r[m](b) : u(m, b);
    });
    return s.length === 0 ? null : s.reduce(i);
  }
  function a(n, s) {
    var m = c(n);
    return m ? m(s) : !0;
  }
  function l(n, s, m, b) {
    b === void 0 && (b = 1 / 0);
    var g = c(n);
    return g ? (0, t.filter)(g, s, m, b) : [];
  }
  function d(n, s, m) {
    return m === void 0 && (m = !0), Array.isArray(s) || (s = [s]), (0, t.findOne)(u("id", n), s, m);
  }
  function o(n, s, m, b) {
    return m === void 0 && (m = !0), b === void 0 && (b = 1 / 0), (0, t.filter)(r.tag_name(n), s, m, b);
  }
  function f(n, s, m, b) {
    return m === void 0 && (m = !0), b === void 0 && (b = 1 / 0), (0, t.filter)(u("class", n), s, m, b);
  }
  function p(n, s, m, b) {
    return m === void 0 && (m = !0), b === void 0 && (b = 1 / 0), (0, t.filter)(r.tag_type(n), s, m, b);
  }
  return Ge;
}
var Xe = {}, qu;
function na() {
  if (qu) return Xe;
  qu = 1, Object.defineProperty(Xe, "__esModule", { value: !0 }), Xe.DocumentPosition = void 0, Xe.removeSubsets = t, Xe.compareDocumentPosition = u, Xe.uniqueSort = i;
  var e = /* @__PURE__ */ rt();
  function t(c) {
    for (var a = c.length; --a >= 0; ) {
      var l = c[a];
      if (a > 0 && c.lastIndexOf(l, a - 1) >= 0) {
        c.splice(a, 1);
        continue;
      }
      for (var d = l.parent; d; d = d.parent)
        if (c.includes(d)) {
          c.splice(a, 1);
          break;
        }
    }
    return c;
  }
  var r;
  (function(c) {
    c[c.DISCONNECTED = 1] = "DISCONNECTED", c[c.PRECEDING = 2] = "PRECEDING", c[c.FOLLOWING = 4] = "FOLLOWING", c[c.CONTAINS = 8] = "CONTAINS", c[c.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(r || (Xe.DocumentPosition = r = {}));
  function u(c, a) {
    var l = [], d = [];
    if (c === a)
      return 0;
    for (var o = (0, e.hasChildren)(c) ? c : c.parent; o; )
      l.unshift(o), o = o.parent;
    for (o = (0, e.hasChildren)(a) ? a : a.parent; o; )
      d.unshift(o), o = o.parent;
    for (var f = Math.min(l.length, d.length), p = 0; p < f && l[p] === d[p]; )
      p++;
    if (p === 0)
      return r.DISCONNECTED;
    var n = l[p - 1], s = n.children, m = l[p], b = d[p];
    return s.indexOf(m) > s.indexOf(b) ? n === a ? r.FOLLOWING | r.CONTAINED_BY : r.FOLLOWING : n === c ? r.PRECEDING | r.CONTAINS : r.PRECEDING;
  }
  function i(c) {
    return c = c.filter(function(a, l, d) {
      return !d.includes(a, l + 1);
    }), c.sort(function(a, l) {
      var d = u(a, l);
      return d & r.PRECEDING ? -1 : d & r.FOLLOWING ? 1 : 0;
    }), c;
  }
  return Xe;
}
var vt = {}, Uu;
function ia() {
  if (Uu) return vt;
  Uu = 1, Object.defineProperty(vt, "__esModule", { value: !0 }), vt.getFeed = r;
  var e = /* @__PURE__ */ Mn(), t = /* @__PURE__ */ Tn();
  function r(n) {
    var s = d(p, n);
    return s ? s.name === "feed" ? u(s) : i(s) : null;
  }
  function u(n) {
    var s, m = n.children, b = {
      type: "atom",
      items: (0, t.getElementsByTagName)("entry", m).map(function(v) {
        var x, _ = v.children, y = { media: l(_) };
        f(y, "id", "id", _), f(y, "title", "title", _);
        var w = (x = d("link", _)) === null || x === void 0 ? void 0 : x.attribs.href;
        w && (y.link = w);
        var S = o("summary", _) || o("content", _);
        S && (y.description = S);
        var k = o("updated", _);
        return k && (y.pubDate = new Date(k)), y;
      })
    };
    f(b, "id", "id", m), f(b, "title", "title", m);
    var g = (s = d("link", m)) === null || s === void 0 ? void 0 : s.attribs.href;
    g && (b.link = g), f(b, "description", "subtitle", m);
    var h = o("updated", m);
    return h && (b.updated = new Date(h)), f(b, "author", "email", m, !0), b;
  }
  function i(n) {
    var s, m, b = (m = (s = d("channel", n.children)) === null || s === void 0 ? void 0 : s.children) !== null && m !== void 0 ? m : [], g = {
      type: n.name.substr(0, 3),
      id: "",
      items: (0, t.getElementsByTagName)("item", n.children).map(function(v) {
        var x = v.children, _ = { media: l(x) };
        f(_, "id", "guid", x), f(_, "title", "title", x), f(_, "link", "link", x), f(_, "description", "description", x);
        var y = o("pubDate", x) || o("dc:date", x);
        return y && (_.pubDate = new Date(y)), _;
      })
    };
    f(g, "title", "title", b), f(g, "link", "link", b), f(g, "description", "description", b);
    var h = o("lastBuildDate", b);
    return h && (g.updated = new Date(h)), f(g, "author", "managingEditor", b, !0), g;
  }
  var c = ["url", "type", "lang"], a = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
  ];
  function l(n) {
    return (0, t.getElementsByTagName)("media:content", n).map(function(s) {
      for (var m = s.attribs, b = {
        medium: m.medium,
        isDefault: !!m.isDefault
      }, g = 0, h = c; g < h.length; g++) {
        var v = h[g];
        m[v] && (b[v] = m[v]);
      }
      for (var x = 0, _ = a; x < _.length; x++) {
        var v = _[x];
        m[v] && (b[v] = parseInt(m[v], 10));
      }
      return m.expression && (b.expression = m.expression), b;
    });
  }
  function d(n, s) {
    return (0, t.getElementsByTagName)(n, s, !0, 1)[0];
  }
  function o(n, s, m) {
    return m === void 0 && (m = !1), (0, e.textContent)((0, t.getElementsByTagName)(n, s, m, 1)).trim();
  }
  function f(n, s, m, b, g) {
    g === void 0 && (g = !1);
    var h = o(m, b, g);
    h && (n[s] = h);
  }
  function p(n) {
    return n === "rss" || n === "feed" || n === "rdf:RDF";
  }
  return vt;
}
var Hu;
function rr() {
  return Hu || (Hu = 1, function(e) {
    var t = at && at.__createBinding || (Object.create ? function(i, c, a, l) {
      l === void 0 && (l = a);
      var d = Object.getOwnPropertyDescriptor(c, a);
      (!d || ("get" in d ? !c.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return c[a];
      } }), Object.defineProperty(i, l, d);
    } : function(i, c, a, l) {
      l === void 0 && (l = a), i[l] = c[a];
    }), r = at && at.__exportStar || function(i, c) {
      for (var a in i) a !== "default" && !Object.prototype.hasOwnProperty.call(c, a) && t(c, i, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.hasChildren = e.isDocument = e.isComment = e.isText = e.isCDATA = e.isTag = void 0, r(/* @__PURE__ */ Mn(), e), r(/* @__PURE__ */ ra(), e), r(/* @__PURE__ */ ua(), e), r(/* @__PURE__ */ kn(), e), r(/* @__PURE__ */ Tn(), e), r(/* @__PURE__ */ na(), e), r(/* @__PURE__ */ ia(), e);
    var u = /* @__PURE__ */ rt();
    Object.defineProperty(e, "isTag", { enumerable: !0, get: function() {
      return u.isTag;
    } }), Object.defineProperty(e, "isCDATA", { enumerable: !0, get: function() {
      return u.isCDATA;
    } }), Object.defineProperty(e, "isText", { enumerable: !0, get: function() {
      return u.isText;
    } }), Object.defineProperty(e, "isComment", { enumerable: !0, get: function() {
      return u.isComment;
    } }), Object.defineProperty(e, "isDocument", { enumerable: !0, get: function() {
      return u.isDocument;
    } }), Object.defineProperty(e, "hasChildren", { enumerable: !0, get: function() {
      return u.hasChildren;
    } });
  }(at)), at;
}
var Ru;
function aa() {
  return Ru || (Ru = 1, function(e) {
    var t = Ee && Ee.__createBinding || (Object.create ? function(h, v, x, _) {
      _ === void 0 && (_ = x);
      var y = Object.getOwnPropertyDescriptor(v, x);
      (!y || ("get" in y ? !v.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
        return v[x];
      } }), Object.defineProperty(h, _, y);
    } : function(h, v, x, _) {
      _ === void 0 && (_ = x), h[_] = v[x];
    }), r = Ee && Ee.__setModuleDefault || (Object.create ? function(h, v) {
      Object.defineProperty(h, "default", { enumerable: !0, value: v });
    } : function(h, v) {
      h.default = v;
    }), u = Ee && Ee.__importStar || function(h) {
      if (h && h.__esModule) return h;
      var v = {};
      if (h != null) for (var x in h) x !== "default" && Object.prototype.hasOwnProperty.call(h, x) && t(v, h, x);
      return r(v, h), v;
    }, i = Ee && Ee.__importDefault || function(h) {
      return h && h.__esModule ? h : { default: h };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DomUtils = e.parseFeed = e.getFeed = e.ElementType = e.Tokenizer = e.createDomStream = e.parseDOM = e.parseDocument = e.DefaultHandler = e.DomHandler = e.Parser = void 0;
    var c = /* @__PURE__ */ xu(), a = /* @__PURE__ */ xu();
    Object.defineProperty(e, "Parser", { enumerable: !0, get: function() {
      return a.Parser;
    } });
    var l = /* @__PURE__ */ rt(), d = /* @__PURE__ */ rt();
    Object.defineProperty(e, "DomHandler", { enumerable: !0, get: function() {
      return d.DomHandler;
    } }), Object.defineProperty(e, "DefaultHandler", { enumerable: !0, get: function() {
      return d.DomHandler;
    } });
    function o(h, v) {
      var x = new l.DomHandler(void 0, v);
      return new c.Parser(x, v).end(h), x.root;
    }
    e.parseDocument = o;
    function f(h, v) {
      return o(h, v).children;
    }
    e.parseDOM = f;
    function p(h, v, x) {
      var _ = new l.DomHandler(h, v, x);
      return new c.Parser(_, v);
    }
    e.createDomStream = p;
    var n = /* @__PURE__ */ Sn();
    Object.defineProperty(e, "Tokenizer", { enumerable: !0, get: function() {
      return i(n).default;
    } }), e.ElementType = u(/* @__PURE__ */ pt());
    var s = /* @__PURE__ */ rr(), m = /* @__PURE__ */ rr();
    Object.defineProperty(e, "getFeed", { enumerable: !0, get: function() {
      return m.getFeed;
    } });
    var b = { xmlMode: !0 };
    function g(h, v) {
      return v === void 0 && (v = b), (0, s.getFeed)(f(h, v));
    }
    e.parseFeed = g, e.DomUtils = u(/* @__PURE__ */ rr());
  }(Ee)), Ee;
}
var ur, ju;
function sa() {
  return ju || (ju = 1, ur = (e) => {
    if (typeof e != "string")
      throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }), ur;
}
var xt = {}, Fu;
function oa() {
  if (Fu) return xt;
  Fu = 1, Object.defineProperty(xt, "__esModule", { value: !0 });
  /*!
   * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */
  function e(r) {
    return Object.prototype.toString.call(r) === "[object Object]";
  }
  function t(r) {
    var u, i;
    return e(r) === !1 ? !1 : (u = r.constructor, u === void 0 ? !0 : (i = u.prototype, !(e(i) === !1 || i.hasOwnProperty("isPrototypeOf") === !1)));
  }
  return xt.isPlainObject = t, xt;
}
var nr, zu;
function ca() {
  if (zu) return nr;
  zu = 1;
  var e = function(v) {
    return t(v) && !r(v);
  };
  function t(h) {
    return !!h && typeof h == "object";
  }
  function r(h) {
    var v = Object.prototype.toString.call(h);
    return v === "[object RegExp]" || v === "[object Date]" || c(h);
  }
  var u = typeof Symbol == "function" && Symbol.for, i = u ? Symbol.for("react.element") : 60103;
  function c(h) {
    return h.$$typeof === i;
  }
  function a(h) {
    return Array.isArray(h) ? [] : {};
  }
  function l(h, v) {
    return v.clone !== !1 && v.isMergeableObject(h) ? b(a(h), h, v) : h;
  }
  function d(h, v, x) {
    return h.concat(v).map(function(_) {
      return l(_, x);
    });
  }
  function o(h, v) {
    if (!v.customMerge)
      return b;
    var x = v.customMerge(h);
    return typeof x == "function" ? x : b;
  }
  function f(h) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(h).filter(function(v) {
      return Object.propertyIsEnumerable.call(h, v);
    }) : [];
  }
  function p(h) {
    return Object.keys(h).concat(f(h));
  }
  function n(h, v) {
    try {
      return v in h;
    } catch {
      return !1;
    }
  }
  function s(h, v) {
    return n(h, v) && !(Object.hasOwnProperty.call(h, v) && Object.propertyIsEnumerable.call(h, v));
  }
  function m(h, v, x) {
    var _ = {};
    return x.isMergeableObject(h) && p(h).forEach(function(y) {
      _[y] = l(h[y], x);
    }), p(v).forEach(function(y) {
      s(h, y) || (n(h, y) && x.isMergeableObject(v[y]) ? _[y] = o(y, x)(h[y], v[y], x) : _[y] = l(v[y], x));
    }), _;
  }
  function b(h, v, x) {
    x = x || {}, x.arrayMerge = x.arrayMerge || d, x.isMergeableObject = x.isMergeableObject || e, x.cloneUnlessOtherwiseSpecified = l;
    var _ = Array.isArray(v), y = Array.isArray(h), w = _ === y;
    return w ? _ ? x.arrayMerge(h, v, x) : m(h, v, x) : l(v, x);
  }
  b.all = function(v, x) {
    if (!Array.isArray(v))
      throw new Error("first argument should be an array");
    return v.reduce(function(_, y) {
      return b(_, y, x);
    }, {});
  };
  var g = b;
  return nr = g, nr;
}
var jt = { exports: {} }, la = jt.exports, Bu;
function fa() {
  return Bu || (Bu = 1, function(e) {
    (function(t, r) {
      e.exports ? e.exports = r() : t.parseSrcset = r();
    })(la, function() {
      return function(t) {
        function r(_) {
          return _ === " " || // space
          _ === "	" || // horizontal tab
          _ === `
` || // new line
          _ === "\f" || // form feed
          _ === "\r";
        }
        function u(_) {
          var y, w = _.exec(t.substring(g));
          if (w)
            return y = w[0], g += y.length, y;
        }
        for (var i = t.length, c = /^[ \t\n\r\u000c]+/, a = /^[, \t\n\r\u000c]+/, l = /^[^ \t\n\r\u000c]+/, d = /[,]+$/, o = /^\d+$/, f = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, p, n, s, m, b, g = 0, h = []; ; ) {
          if (u(a), g >= i)
            return h;
          p = u(l), n = [], p.slice(-1) === "," ? (p = p.replace(d, ""), x()) : v();
        }
        function v() {
          for (u(c), s = "", m = "in descriptor"; ; ) {
            if (b = t.charAt(g), m === "in descriptor")
              if (r(b))
                s && (n.push(s), s = "", m = "after descriptor");
              else if (b === ",") {
                g += 1, s && n.push(s), x();
                return;
              } else if (b === "(")
                s = s + b, m = "in parens";
              else if (b === "") {
                s && n.push(s), x();
                return;
              } else
                s = s + b;
            else if (m === "in parens")
              if (b === ")")
                s = s + b, m = "in descriptor";
              else if (b === "") {
                n.push(s), x();
                return;
              } else
                s = s + b;
            else if (m === "after descriptor" && !r(b))
              if (b === "") {
                x();
                return;
              } else
                m = "in descriptor", g -= 1;
            g += 1;
          }
        }
        function x() {
          var _ = !1, y, w, S, k, $ = {}, D, T, A, P, L;
          for (k = 0; k < n.length; k++)
            D = n[k], T = D[D.length - 1], A = D.substring(0, D.length - 1), P = parseInt(A, 10), L = parseFloat(A), o.test(A) && T === "w" ? ((y || w) && (_ = !0), P === 0 ? _ = !0 : y = P) : f.test(A) && T === "x" ? ((y || w || S) && (_ = !0), L < 0 ? _ = !0 : w = L) : o.test(A) && T === "h" ? ((S || w) && (_ = !0), P === 0 ? _ = !0 : S = P) : _ = !0;
          _ ? console && console.log && console.log("Invalid srcset descriptor found in '" + t + "' at '" + D + "'.") : ($.url = p, y && ($.w = y), w && ($.d = w), S && ($.h = S), h.push($));
        }
      };
    });
  }(jt)), jt.exports;
}
var wt = { exports: {} }, Yu;
function da() {
  if (Yu) return wt.exports;
  Yu = 1;
  var e = String, t = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return wt.exports = t(), wt.exports.createColors = t, wt.exports;
}
const ha = {}, pa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ha
}, Symbol.toStringTag, { value: "Module" })), Oe = /* @__PURE__ */ Xn(pa);
var ir, Vu;
function Hr() {
  if (Vu) return ir;
  Vu = 1;
  let e = /* @__PURE__ */ da(), t = Oe;
  class r extends Error {
    constructor(i, c, a, l, d, o) {
      super(i), this.name = "CssSyntaxError", this.reason = i, d && (this.file = d), l && (this.source = l), o && (this.plugin = o), typeof c < "u" && typeof a < "u" && (typeof c == "number" ? (this.line = c, this.column = a) : (this.line = c.line, this.column = c.column, this.endLine = a.line, this.endColumn = a.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, r);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(i) {
      if (!this.source) return "";
      let c = this.source;
      i == null && (i = e.isColorSupported);
      let a = (s) => s, l = (s) => s, d = (s) => s;
      if (i) {
        let { bold: s, gray: m, red: b } = e.createColors(!0);
        l = (g) => s(b(g)), a = (g) => m(g), t && (d = (g) => t(g));
      }
      let o = c.split(/\r?\n/), f = Math.max(this.line - 3, 0), p = Math.min(this.line + 2, o.length), n = String(p).length;
      return o.slice(f, p).map((s, m) => {
        let b = f + 1 + m, g = " " + (" " + b).slice(-n) + " | ";
        if (b === this.line) {
          if (s.length > 160) {
            let v = 20, x = Math.max(0, this.column - v), _ = Math.max(
              this.column + v,
              this.endColumn + v
            ), y = s.slice(x, _), w = a(g.replace(/\d/g, " ")) + s.slice(0, Math.min(this.column - 1, v - 1)).replace(/[^\t]/g, " ");
            return l(">") + a(g) + d(y) + `
 ` + w + l("^");
          }
          let h = a(g.replace(/\d/g, " ")) + s.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return l(">") + a(g) + d(s) + `
 ` + h + l("^");
        }
        return " " + a(g) + d(s);
      }).join(`
`);
    }
    toString() {
      let i = this.showSourceCode();
      return i && (i = `

` + i + `
`), this.name + ": " + this.message + i;
    }
  }
  return ir = r, r.default = r, ir;
}
var ar, Gu;
function En() {
  if (Gu) return ar;
  Gu = 1;
  const e = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function t(u) {
    return u[0].toUpperCase() + u.slice(1);
  }
  class r {
    constructor(i) {
      this.builder = i;
    }
    atrule(i, c) {
      let a = "@" + i.name, l = i.params ? this.rawValue(i, "params") : "";
      if (typeof i.raws.afterName < "u" ? a += i.raws.afterName : l && (a += " "), i.nodes)
        this.block(i, a + l);
      else {
        let d = (i.raws.between || "") + (c ? ";" : "");
        this.builder(a + l + d, i);
      }
    }
    beforeAfter(i, c) {
      let a;
      i.type === "decl" ? a = this.raw(i, null, "beforeDecl") : i.type === "comment" ? a = this.raw(i, null, "beforeComment") : c === "before" ? a = this.raw(i, null, "beforeRule") : a = this.raw(i, null, "beforeClose");
      let l = i.parent, d = 0;
      for (; l && l.type !== "root"; )
        d += 1, l = l.parent;
      if (a.includes(`
`)) {
        let o = this.raw(i, null, "indent");
        if (o.length)
          for (let f = 0; f < d; f++) a += o;
      }
      return a;
    }
    block(i, c) {
      let a = this.raw(i, "between", "beforeOpen");
      this.builder(c + a + "{", i, "start");
      let l;
      i.nodes && i.nodes.length ? (this.body(i), l = this.raw(i, "after")) : l = this.raw(i, "after", "emptyBody"), l && this.builder(l), this.builder("}", i, "end");
    }
    body(i) {
      let c = i.nodes.length - 1;
      for (; c > 0 && i.nodes[c].type === "comment"; )
        c -= 1;
      let a = this.raw(i, "semicolon");
      for (let l = 0; l < i.nodes.length; l++) {
        let d = i.nodes[l], o = this.raw(d, "before");
        o && this.builder(o), this.stringify(d, c !== l || a);
      }
    }
    comment(i) {
      let c = this.raw(i, "left", "commentLeft"), a = this.raw(i, "right", "commentRight");
      this.builder("/*" + c + i.text + a + "*/", i);
    }
    decl(i, c) {
      let a = this.raw(i, "between", "colon"), l = i.prop + a + this.rawValue(i, "value");
      i.important && (l += i.raws.important || " !important"), c && (l += ";"), this.builder(l, i);
    }
    document(i) {
      this.body(i);
    }
    raw(i, c, a) {
      let l;
      if (a || (a = c), c && (l = i.raws[c], typeof l < "u"))
        return l;
      let d = i.parent;
      if (a === "before" && (!d || d.type === "root" && d.first === i || d && d.type === "document"))
        return "";
      if (!d) return e[a];
      let o = i.root();
      if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[a] < "u")
        return o.rawCache[a];
      if (a === "before" || a === "after")
        return this.beforeAfter(i, a);
      {
        let f = "raw" + t(a);
        this[f] ? l = this[f](o, i) : o.walk((p) => {
          if (l = p.raws[c], typeof l < "u") return !1;
        });
      }
      return typeof l > "u" && (l = e[a]), o.rawCache[a] = l, l;
    }
    rawBeforeClose(i) {
      let c;
      return i.walk((a) => {
        if (a.nodes && a.nodes.length > 0 && typeof a.raws.after < "u")
          return c = a.raws.after, c.includes(`
`) && (c = c.replace(/[^\n]+$/, "")), !1;
      }), c && (c = c.replace(/\S/g, "")), c;
    }
    rawBeforeComment(i, c) {
      let a;
      return i.walkComments((l) => {
        if (typeof l.raws.before < "u")
          return a = l.raws.before, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), typeof a > "u" ? a = this.raw(c, null, "beforeDecl") : a && (a = a.replace(/\S/g, "")), a;
    }
    rawBeforeDecl(i, c) {
      let a;
      return i.walkDecls((l) => {
        if (typeof l.raws.before < "u")
          return a = l.raws.before, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), typeof a > "u" ? a = this.raw(c, null, "beforeRule") : a && (a = a.replace(/\S/g, "")), a;
    }
    rawBeforeOpen(i) {
      let c;
      return i.walk((a) => {
        if (a.type !== "decl" && (c = a.raws.between, typeof c < "u"))
          return !1;
      }), c;
    }
    rawBeforeRule(i) {
      let c;
      return i.walk((a) => {
        if (a.nodes && (a.parent !== i || i.first !== a) && typeof a.raws.before < "u")
          return c = a.raws.before, c.includes(`
`) && (c = c.replace(/[^\n]+$/, "")), !1;
      }), c && (c = c.replace(/\S/g, "")), c;
    }
    rawColon(i) {
      let c;
      return i.walkDecls((a) => {
        if (typeof a.raws.between < "u")
          return c = a.raws.between.replace(/[^\s:]/g, ""), !1;
      }), c;
    }
    rawEmptyBody(i) {
      let c;
      return i.walk((a) => {
        if (a.nodes && a.nodes.length === 0 && (c = a.raws.after, typeof c < "u"))
          return !1;
      }), c;
    }
    rawIndent(i) {
      if (i.raws.indent) return i.raws.indent;
      let c;
      return i.walk((a) => {
        let l = a.parent;
        if (l && l !== i && l.parent && l.parent === i && typeof a.raws.before < "u") {
          let d = a.raws.before.split(`
`);
          return c = d[d.length - 1], c = c.replace(/\S/g, ""), !1;
        }
      }), c;
    }
    rawSemicolon(i) {
      let c;
      return i.walk((a) => {
        if (a.nodes && a.nodes.length && a.last.type === "decl" && (c = a.raws.semicolon, typeof c < "u"))
          return !1;
      }), c;
    }
    rawValue(i, c) {
      let a = i[c], l = i.raws[c];
      return l && l.value === a ? l.raw : a;
    }
    root(i) {
      this.body(i), i.raws.after && this.builder(i.raws.after);
    }
    rule(i) {
      this.block(i, this.rawValue(i, "selector")), i.raws.ownSemicolon && this.builder(i.raws.ownSemicolon, i, "end");
    }
    stringify(i, c) {
      if (!this[i.type])
        throw new Error(
          "Unknown AST node type " + i.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[i.type](i, c);
    }
  }
  return ar = r, r.default = r, ar;
}
var sr, Wu;
function Yt() {
  if (Wu) return sr;
  Wu = 1;
  let e = En();
  function t(r, u) {
    new e(u).stringify(r);
  }
  return sr = t, t.default = t, sr;
}
var _t = {}, Qu;
function Rr() {
  return Qu || (Qu = 1, _t.isClean = Symbol("isClean"), _t.my = Symbol("my")), _t;
}
var or, Zu;
function Vt() {
  if (Zu) return or;
  Zu = 1;
  let e = Hr(), t = En(), r = Yt(), { isClean: u, my: i } = Rr();
  function c(d, o) {
    let f = new d.constructor();
    for (let p in d) {
      if (!Object.prototype.hasOwnProperty.call(d, p) || p === "proxyCache") continue;
      let n = d[p], s = typeof n;
      p === "parent" && s === "object" ? o && (f[p] = o) : p === "source" ? f[p] = n : Array.isArray(n) ? f[p] = n.map((m) => c(m, f)) : (s === "object" && n !== null && (n = c(n)), f[p] = n);
    }
    return f;
  }
  function a(d, o) {
    if (o && typeof o.offset < "u")
      return o.offset;
    let f = 1, p = 1, n = 0;
    for (let s = 0; s < d.length; s++) {
      if (p === o.line && f === o.column) {
        n = s;
        break;
      }
      d[s] === `
` ? (f = 1, p += 1) : f += 1;
    }
    return n;
  }
  class l {
    get proxyOf() {
      return this;
    }
    constructor(o = {}) {
      this.raws = {}, this[u] = !1, this[i] = !0;
      for (let f in o)
        if (f === "nodes") {
          this.nodes = [];
          for (let p of o[f])
            typeof p.clone == "function" ? this.append(p.clone()) : this.append(p);
        } else
          this[f] = o[f];
    }
    addToError(o) {
      if (o.postcssNode = this, o.stack && this.source && /\n\s{4}at /.test(o.stack)) {
        let f = this.source;
        o.stack = o.stack.replace(
          /\n\s{4}at /,
          `$&${f.input.from}:${f.start.line}:${f.start.column}$&`
        );
      }
      return o;
    }
    after(o) {
      return this.parent.insertAfter(this, o), this;
    }
    assign(o = {}) {
      for (let f in o)
        this[f] = o[f];
      return this;
    }
    before(o) {
      return this.parent.insertBefore(this, o), this;
    }
    cleanRaws(o) {
      delete this.raws.before, delete this.raws.after, o || delete this.raws.between;
    }
    clone(o = {}) {
      let f = c(this);
      for (let p in o)
        f[p] = o[p];
      return f;
    }
    cloneAfter(o = {}) {
      let f = this.clone(o);
      return this.parent.insertAfter(this, f), f;
    }
    cloneBefore(o = {}) {
      let f = this.clone(o);
      return this.parent.insertBefore(this, f), f;
    }
    error(o, f = {}) {
      if (this.source) {
        let { end: p, start: n } = this.rangeBy(f);
        return this.source.input.error(
          o,
          { column: n.column, line: n.line },
          { column: p.column, line: p.line },
          f
        );
      }
      return new e(o);
    }
    getProxyProcessor() {
      return {
        get(o, f) {
          return f === "proxyOf" ? o : f === "root" ? () => o.root().toProxy() : o[f];
        },
        set(o, f, p) {
          return o[f] === p || (o[f] = p, (f === "prop" || f === "value" || f === "name" || f === "params" || f === "important" || /* c8 ignore next */
          f === "text") && o.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[u] = !0;
    }
    markDirty() {
      if (this[u]) {
        this[u] = !1;
        let o = this;
        for (; o = o.parent; )
          o[u] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let o = this.parent.index(this);
      return this.parent.nodes[o + 1];
    }
    positionBy(o) {
      let f = this.source.start;
      if (o.index)
        f = this.positionInside(o.index);
      else if (o.word) {
        let p = "document" in this.source.input ? this.source.input.document : this.source.input.css, s = p.slice(
          a(p, this.source.start),
          a(p, this.source.end)
        ).indexOf(o.word);
        s !== -1 && (f = this.positionInside(s));
      }
      return f;
    }
    positionInside(o) {
      let f = this.source.start.column, p = this.source.start.line, n = "document" in this.source.input ? this.source.input.document : this.source.input.css, s = a(n, this.source.start), m = s + o;
      for (let b = s; b < m; b++)
        n[b] === `
` ? (f = 1, p += 1) : f += 1;
      return { column: f, line: p };
    }
    prev() {
      if (!this.parent) return;
      let o = this.parent.index(this);
      return this.parent.nodes[o - 1];
    }
    rangeBy(o) {
      let f = {
        column: this.source.start.column,
        line: this.source.start.line
      }, p = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line
      } : {
        column: f.column + 1,
        line: f.line
      };
      if (o.word) {
        let n = "document" in this.source.input ? this.source.input.document : this.source.input.css, m = n.slice(
          a(n, this.source.start),
          a(n, this.source.end)
        ).indexOf(o.word);
        m !== -1 && (f = this.positionInside(m), p = this.positionInside(
          m + o.word.length
        ));
      } else
        o.start ? f = {
          column: o.start.column,
          line: o.start.line
        } : o.index && (f = this.positionInside(o.index)), o.end ? p = {
          column: o.end.column,
          line: o.end.line
        } : typeof o.endIndex == "number" ? p = this.positionInside(o.endIndex) : o.index && (p = this.positionInside(o.index + 1));
      return (p.line < f.line || p.line === f.line && p.column <= f.column) && (p = { column: f.column + 1, line: f.line }), { end: p, start: f };
    }
    raw(o, f) {
      return new t().raw(this, o, f);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...o) {
      if (this.parent) {
        let f = this, p = !1;
        for (let n of o)
          n === this ? p = !0 : p ? (this.parent.insertAfter(f, n), f = n) : this.parent.insertBefore(f, n);
        p || this.remove();
      }
      return this;
    }
    root() {
      let o = this;
      for (; o.parent && o.parent.type !== "document"; )
        o = o.parent;
      return o;
    }
    toJSON(o, f) {
      let p = {}, n = f == null;
      f = f || /* @__PURE__ */ new Map();
      let s = 0;
      for (let m in this) {
        if (!Object.prototype.hasOwnProperty.call(this, m) || m === "parent" || m === "proxyCache") continue;
        let b = this[m];
        if (Array.isArray(b))
          p[m] = b.map((g) => typeof g == "object" && g.toJSON ? g.toJSON(null, f) : g);
        else if (typeof b == "object" && b.toJSON)
          p[m] = b.toJSON(null, f);
        else if (m === "source") {
          let g = f.get(b.input);
          g == null && (g = s, f.set(b.input, s), s++), p[m] = {
            end: b.end,
            inputId: g,
            start: b.start
          };
        } else
          p[m] = b;
      }
      return n && (p.inputs = [...f.keys()].map((m) => m.toJSON())), p;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(o = r) {
      o.stringify && (o = o.stringify);
      let f = "";
      return o(this, (p) => {
        f += p;
      }), f;
    }
    warn(o, f, p) {
      let n = { node: this };
      for (let s in p) n[s] = p[s];
      return o.warn(f, n);
    }
  }
  return or = l, l.default = l, or;
}
var cr, Ju;
function Gt() {
  if (Ju) return cr;
  Ju = 1;
  let e = Vt();
  class t extends e {
    constructor(u) {
      super(u), this.type = "comment";
    }
  }
  return cr = t, t.default = t, cr;
}
var lr, Ku;
function Wt() {
  if (Ku) return lr;
  Ku = 1;
  let e = Vt();
  class t extends e {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(u) {
      u && typeof u.value < "u" && typeof u.value != "string" && (u = { ...u, value: String(u.value) }), super(u), this.type = "decl";
    }
  }
  return lr = t, t.default = t, lr;
}
var fr, Xu;
function ot() {
  if (Xu) return fr;
  Xu = 1;
  let e = Gt(), t = Wt(), r = Vt(), { isClean: u, my: i } = Rr(), c, a, l, d;
  function o(n) {
    return n.map((s) => (s.nodes && (s.nodes = o(s.nodes)), delete s.source, s));
  }
  function f(n) {
    if (n[u] = !1, n.proxyOf.nodes)
      for (let s of n.proxyOf.nodes)
        f(s);
  }
  class p extends r {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...s) {
      for (let m of s) {
        let b = this.normalize(m, this.last);
        for (let g of b) this.proxyOf.nodes.push(g);
      }
      return this.markDirty(), this;
    }
    cleanRaws(s) {
      if (super.cleanRaws(s), this.nodes)
        for (let m of this.nodes) m.cleanRaws(s);
    }
    each(s) {
      if (!this.proxyOf.nodes) return;
      let m = this.getIterator(), b, g;
      for (; this.indexes[m] < this.proxyOf.nodes.length && (b = this.indexes[m], g = s(this.proxyOf.nodes[b], b), g !== !1); )
        this.indexes[m] += 1;
      return delete this.indexes[m], g;
    }
    every(s) {
      return this.nodes.every(s);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let s = this.lastEach;
      return this.indexes[s] = 0, s;
    }
    getProxyProcessor() {
      return {
        get(s, m) {
          return m === "proxyOf" ? s : s[m] ? m === "each" || typeof m == "string" && m.startsWith("walk") ? (...b) => s[m](
            ...b.map((g) => typeof g == "function" ? (h, v) => g(h.toProxy(), v) : g)
          ) : m === "every" || m === "some" ? (b) => s[m](
            (g, ...h) => b(g.toProxy(), ...h)
          ) : m === "root" ? () => s.root().toProxy() : m === "nodes" ? s.nodes.map((b) => b.toProxy()) : m === "first" || m === "last" ? s[m].toProxy() : s[m] : s[m];
        },
        set(s, m, b) {
          return s[m] === b || (s[m] = b, (m === "name" || m === "params" || m === "selector") && s.markDirty()), !0;
        }
      };
    }
    index(s) {
      return typeof s == "number" ? s : (s.proxyOf && (s = s.proxyOf), this.proxyOf.nodes.indexOf(s));
    }
    insertAfter(s, m) {
      let b = this.index(s), g = this.normalize(m, this.proxyOf.nodes[b]).reverse();
      b = this.index(s);
      for (let v of g) this.proxyOf.nodes.splice(b + 1, 0, v);
      let h;
      for (let v in this.indexes)
        h = this.indexes[v], b < h && (this.indexes[v] = h + g.length);
      return this.markDirty(), this;
    }
    insertBefore(s, m) {
      let b = this.index(s), g = b === 0 ? "prepend" : !1, h = this.normalize(
        m,
        this.proxyOf.nodes[b],
        g
      ).reverse();
      b = this.index(s);
      for (let x of h) this.proxyOf.nodes.splice(b, 0, x);
      let v;
      for (let x in this.indexes)
        v = this.indexes[x], b <= v && (this.indexes[x] = v + h.length);
      return this.markDirty(), this;
    }
    normalize(s, m) {
      if (typeof s == "string")
        s = o(a(s).nodes);
      else if (typeof s > "u")
        s = [];
      else if (Array.isArray(s)) {
        s = s.slice(0);
        for (let g of s)
          g.parent && g.parent.removeChild(g, "ignore");
      } else if (s.type === "root" && this.type !== "document") {
        s = s.nodes.slice(0);
        for (let g of s)
          g.parent && g.parent.removeChild(g, "ignore");
      } else if (s.type)
        s = [s];
      else if (s.prop) {
        if (typeof s.value > "u")
          throw new Error("Value field is missed in node creation");
        typeof s.value != "string" && (s.value = String(s.value)), s = [new t(s)];
      } else if (s.selector || s.selectors)
        s = [new d(s)];
      else if (s.name)
        s = [new c(s)];
      else if (s.text)
        s = [new e(s)];
      else
        throw new Error("Unknown node type in node creation");
      return s.map((g) => (g[i] || p.rebuild(g), g = g.proxyOf, g.parent && g.parent.removeChild(g), g[u] && f(g), g.raws || (g.raws = {}), typeof g.raws.before > "u" && m && typeof m.raws.before < "u" && (g.raws.before = m.raws.before.replace(/\S/g, "")), g.parent = this.proxyOf, g));
    }
    prepend(...s) {
      s = s.reverse();
      for (let m of s) {
        let b = this.normalize(m, this.first, "prepend").reverse();
        for (let g of b) this.proxyOf.nodes.unshift(g);
        for (let g in this.indexes)
          this.indexes[g] = this.indexes[g] + b.length;
      }
      return this.markDirty(), this;
    }
    push(s) {
      return s.parent = this, this.proxyOf.nodes.push(s), this;
    }
    removeAll() {
      for (let s of this.proxyOf.nodes) s.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(s) {
      s = this.index(s), this.proxyOf.nodes[s].parent = void 0, this.proxyOf.nodes.splice(s, 1);
      let m;
      for (let b in this.indexes)
        m = this.indexes[b], m >= s && (this.indexes[b] = m - 1);
      return this.markDirty(), this;
    }
    replaceValues(s, m, b) {
      return b || (b = m, m = {}), this.walkDecls((g) => {
        m.props && !m.props.includes(g.prop) || m.fast && !g.value.includes(m.fast) || (g.value = g.value.replace(s, b));
      }), this.markDirty(), this;
    }
    some(s) {
      return this.nodes.some(s);
    }
    walk(s) {
      return this.each((m, b) => {
        let g;
        try {
          g = s(m, b);
        } catch (h) {
          throw m.addToError(h);
        }
        return g !== !1 && m.walk && (g = m.walk(s)), g;
      });
    }
    walkAtRules(s, m) {
      return m ? s instanceof RegExp ? this.walk((b, g) => {
        if (b.type === "atrule" && s.test(b.name))
          return m(b, g);
      }) : this.walk((b, g) => {
        if (b.type === "atrule" && b.name === s)
          return m(b, g);
      }) : (m = s, this.walk((b, g) => {
        if (b.type === "atrule")
          return m(b, g);
      }));
    }
    walkComments(s) {
      return this.walk((m, b) => {
        if (m.type === "comment")
          return s(m, b);
      });
    }
    walkDecls(s, m) {
      return m ? s instanceof RegExp ? this.walk((b, g) => {
        if (b.type === "decl" && s.test(b.prop))
          return m(b, g);
      }) : this.walk((b, g) => {
        if (b.type === "decl" && b.prop === s)
          return m(b, g);
      }) : (m = s, this.walk((b, g) => {
        if (b.type === "decl")
          return m(b, g);
      }));
    }
    walkRules(s, m) {
      return m ? s instanceof RegExp ? this.walk((b, g) => {
        if (b.type === "rule" && s.test(b.selector))
          return m(b, g);
      }) : this.walk((b, g) => {
        if (b.type === "rule" && b.selector === s)
          return m(b, g);
      }) : (m = s, this.walk((b, g) => {
        if (b.type === "rule")
          return m(b, g);
      }));
    }
  }
  return p.registerParse = (n) => {
    a = n;
  }, p.registerRule = (n) => {
    d = n;
  }, p.registerAtRule = (n) => {
    c = n;
  }, p.registerRoot = (n) => {
    l = n;
  }, fr = p, p.default = p, p.rebuild = (n) => {
    n.type === "atrule" ? Object.setPrototypeOf(n, c.prototype) : n.type === "rule" ? Object.setPrototypeOf(n, d.prototype) : n.type === "decl" ? Object.setPrototypeOf(n, t.prototype) : n.type === "comment" ? Object.setPrototypeOf(n, e.prototype) : n.type === "root" && Object.setPrototypeOf(n, l.prototype), n[i] = !0, n.nodes && n.nodes.forEach((s) => {
      p.rebuild(s);
    });
  }, fr;
}
var dr, en;
function jr() {
  if (en) return dr;
  en = 1;
  let e = ot();
  class t extends e {
    constructor(u) {
      super(u), this.type = "atrule";
    }
    append(...u) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...u);
    }
    prepend(...u) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...u);
    }
  }
  return dr = t, t.default = t, e.registerAtRule(t), dr;
}
var hr, tn;
function Fr() {
  if (tn) return hr;
  tn = 1;
  let e = ot(), t, r;
  class u extends e {
    constructor(c) {
      super({ type: "document", ...c }), this.nodes || (this.nodes = []);
    }
    toResult(c = {}) {
      return new t(new r(), this, c).stringify();
    }
  }
  return u.registerLazyResult = (i) => {
    t = i;
  }, u.registerProcessor = (i) => {
    r = i;
  }, hr = u, u.default = u, hr;
}
var pr, rn;
function ma() {
  if (rn) return pr;
  rn = 1;
  let e = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return pr = { nanoid: (u = 21) => {
    let i = "", c = u | 0;
    for (; c--; )
      i += e[Math.random() * 64 | 0];
    return i;
  }, customAlphabet: (u, i = 21) => (c = i) => {
    let a = "", l = c | 0;
    for (; l--; )
      a += u[Math.random() * u.length | 0];
    return a;
  } }, pr;
}
var mr, un;
function An() {
  if (un) return mr;
  un = 1;
  let { existsSync: e, readFileSync: t } = Oe, { dirname: r, join: u } = Oe, { SourceMapConsumer: i, SourceMapGenerator: c } = Oe;
  function a(d) {
    return Buffer ? Buffer.from(d, "base64").toString() : window.atob(d);
  }
  class l {
    constructor(o, f) {
      if (f.map === !1) return;
      this.loadAnnotation(o), this.inline = this.startWith(this.annotation, "data:");
      let p = f.map ? f.map.prev : void 0, n = this.loadMap(f.from, p);
      !this.mapFile && f.from && (this.mapFile = f.from), this.mapFile && (this.root = r(this.mapFile)), n && (this.text = n);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new i(this.text)), this.consumerCache;
    }
    decodeInline(o) {
      let f = /^data:application\/json;charset=utf-?8;base64,/, p = /^data:application\/json;base64,/, n = /^data:application\/json;charset=utf-?8,/, s = /^data:application\/json,/, m = o.match(n) || o.match(s);
      if (m)
        return decodeURIComponent(o.substr(m[0].length));
      let b = o.match(f) || o.match(p);
      if (b)
        return a(o.substr(b[0].length));
      let g = o.match(/data:application\/json;([^,]+),/)[1];
      throw new Error("Unsupported source map encoding " + g);
    }
    getAnnotationURL(o) {
      return o.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(o) {
      return typeof o != "object" ? !1 : typeof o.mappings == "string" || typeof o._mappings == "string" || Array.isArray(o.sections);
    }
    loadAnnotation(o) {
      let f = o.match(/\/\*\s*# sourceMappingURL=/g);
      if (!f) return;
      let p = o.lastIndexOf(f.pop()), n = o.indexOf("*/", p);
      p > -1 && n > -1 && (this.annotation = this.getAnnotationURL(o.substring(p, n)));
    }
    loadFile(o) {
      if (this.root = r(o), e(o))
        return this.mapFile = o, t(o, "utf-8").toString().trim();
    }
    loadMap(o, f) {
      if (f === !1) return !1;
      if (f) {
        if (typeof f == "string")
          return f;
        if (typeof f == "function") {
          let p = f(o);
          if (p) {
            let n = this.loadFile(p);
            if (!n)
              throw new Error(
                "Unable to load previous source map: " + p.toString()
              );
            return n;
          }
        } else {
          if (f instanceof i)
            return c.fromSourceMap(f).toString();
          if (f instanceof c)
            return f.toString();
          if (this.isMap(f))
            return JSON.stringify(f);
          throw new Error(
            "Unsupported previous source map format: " + f.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let p = this.annotation;
          return o && (p = u(r(o), p)), this.loadFile(p);
        }
      }
    }
    startWith(o, f) {
      return o ? o.substr(0, f.length) === f : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return mr = l, l.default = l, mr;
}
var br, nn;
function Qt() {
  if (nn) return br;
  nn = 1;
  let { nanoid: e } = /* @__PURE__ */ ma(), { isAbsolute: t, resolve: r } = Oe, { SourceMapConsumer: u, SourceMapGenerator: i } = Oe, { fileURLToPath: c, pathToFileURL: a } = Oe, l = Hr(), d = An(), o = Oe, f = Symbol("fromOffsetCache"), p = !!(u && i), n = !!(r && t);
  class s {
    get from() {
      return this.file || this.id;
    }
    constructor(b, g = {}) {
      if (b === null || typeof b > "u" || typeof b == "object" && !b.toString)
        throw new Error(`PostCSS received ${b} instead of CSS string`);
      if (this.css = b.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, g.document && (this.document = g.document.toString()), g.from && (!n || /^\w+:\/\//.test(g.from) || t(g.from) ? this.file = g.from : this.file = r(g.from)), n && p) {
        let h = new d(this.css, g);
        if (h.text) {
          this.map = h;
          let v = h.consumer().file;
          !this.file && v && (this.file = this.mapResolve(v));
        }
      }
      this.file || (this.id = "<input css " + e(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(b, g, h, v = {}) {
      let x, _, y;
      if (g && typeof g == "object") {
        let S = g, k = h;
        if (typeof S.offset == "number") {
          let $ = this.fromOffset(S.offset);
          g = $.line, h = $.col;
        } else
          g = S.line, h = S.column;
        if (typeof k.offset == "number") {
          let $ = this.fromOffset(k.offset);
          _ = $.line, x = $.col;
        } else
          _ = k.line, x = k.column;
      } else if (!h) {
        let S = this.fromOffset(g);
        g = S.line, h = S.col;
      }
      let w = this.origin(g, h, _, x);
      return w ? y = new l(
        b,
        w.endLine === void 0 ? w.line : { column: w.column, line: w.line },
        w.endLine === void 0 ? w.column : { column: w.endColumn, line: w.endLine },
        w.source,
        w.file,
        v.plugin
      ) : y = new l(
        b,
        _ === void 0 ? g : { column: h, line: g },
        _ === void 0 ? h : { column: x, line: _ },
        this.css,
        this.file,
        v.plugin
      ), y.input = { column: h, endColumn: x, endLine: _, line: g, source: this.css }, this.file && (a && (y.input.url = a(this.file).toString()), y.input.file = this.file), y;
    }
    fromOffset(b) {
      let g, h;
      if (this[f])
        h = this[f];
      else {
        let x = this.css.split(`
`);
        h = new Array(x.length);
        let _ = 0;
        for (let y = 0, w = x.length; y < w; y++)
          h[y] = _, _ += x[y].length + 1;
        this[f] = h;
      }
      g = h[h.length - 1];
      let v = 0;
      if (b >= g)
        v = h.length - 1;
      else {
        let x = h.length - 2, _;
        for (; v < x; )
          if (_ = v + (x - v >> 1), b < h[_])
            x = _ - 1;
          else if (b >= h[_ + 1])
            v = _ + 1;
          else {
            v = _;
            break;
          }
      }
      return {
        col: b - h[v] + 1,
        line: v + 1
      };
    }
    mapResolve(b) {
      return /^\w+:\/\//.test(b) ? b : r(this.map.consumer().sourceRoot || this.map.root || ".", b);
    }
    origin(b, g, h, v) {
      if (!this.map) return !1;
      let x = this.map.consumer(), _ = x.originalPositionFor({ column: g, line: b });
      if (!_.source) return !1;
      let y;
      typeof h == "number" && (y = x.originalPositionFor({ column: v, line: h }));
      let w;
      t(_.source) ? w = a(_.source) : w = new URL(
        _.source,
        this.map.consumer().sourceRoot || a(this.map.mapFile)
      );
      let S = {
        column: _.column,
        endColumn: y && y.column,
        endLine: y && y.line,
        line: _.line,
        url: w.toString()
      };
      if (w.protocol === "file:")
        if (c)
          S.file = c(w);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let k = x.sourceContentFor(_.source);
      return k && (S.source = k), S;
    }
    toJSON() {
      let b = {};
      for (let g of ["hasBOM", "css", "file", "id"])
        this[g] != null && (b[g] = this[g]);
      return this.map && (b.map = { ...this.map }, b.map.consumerCache && (b.map.consumerCache = void 0)), b;
    }
  }
  return br = s, s.default = s, o && o.registerInput && o.registerInput(s), br;
}
var gr, an;
function mt() {
  if (an) return gr;
  an = 1;
  let e = ot(), t, r;
  class u extends e {
    constructor(c) {
      super(c), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(c, a, l) {
      let d = super.normalize(c);
      if (a) {
        if (l === "prepend")
          this.nodes.length > 1 ? a.raws.before = this.nodes[1].raws.before : delete a.raws.before;
        else if (this.first !== a)
          for (let o of d)
            o.raws.before = a.raws.before;
      }
      return d;
    }
    removeChild(c, a) {
      let l = this.index(c);
      return !a && l === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[l].raws.before), super.removeChild(c);
    }
    toResult(c = {}) {
      return new t(new r(), this, c).stringify();
    }
  }
  return u.registerLazyResult = (i) => {
    t = i;
  }, u.registerProcessor = (i) => {
    r = i;
  }, gr = u, u.default = u, e.registerRoot(u), gr;
}
var yr, sn;
function $n() {
  if (sn) return yr;
  sn = 1;
  let e = {
    comma(t) {
      return e.split(t, [","], !0);
    },
    space(t) {
      let r = [" ", `
`, "	"];
      return e.split(t, r);
    },
    split(t, r, u) {
      let i = [], c = "", a = !1, l = 0, d = !1, o = "", f = !1;
      for (let p of t)
        f ? f = !1 : p === "\\" ? f = !0 : d ? p === o && (d = !1) : p === '"' || p === "'" ? (d = !0, o = p) : p === "(" ? l += 1 : p === ")" ? l > 0 && (l -= 1) : l === 0 && r.includes(p) && (a = !0), a ? (c !== "" && i.push(c.trim()), c = "", a = !1) : c += p;
      return (u || c !== "") && i.push(c.trim()), i;
    }
  };
  return yr = e, e.default = e, yr;
}
var vr, on;
function zr() {
  if (on) return vr;
  on = 1;
  let e = ot(), t = $n();
  class r extends e {
    get selectors() {
      return t.comma(this.selector);
    }
    set selectors(i) {
      let c = this.selector ? this.selector.match(/,\s*/) : null, a = c ? c[0] : "," + this.raw("between", "beforeOpen");
      this.selector = i.join(a);
    }
    constructor(i) {
      super(i), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return vr = r, r.default = r, e.registerRule(r), vr;
}
var xr, cn;
function ba() {
  if (cn) return xr;
  cn = 1;
  let e = jr(), t = Gt(), r = Wt(), u = Qt(), i = An(), c = mt(), a = zr();
  function l(d, o) {
    if (Array.isArray(d)) return d.map((n) => l(n));
    let { inputs: f, ...p } = d;
    if (f) {
      o = [];
      for (let n of f) {
        let s = { ...n, __proto__: u.prototype };
        s.map && (s.map = {
          ...s.map,
          __proto__: i.prototype
        }), o.push(s);
      }
    }
    if (p.nodes && (p.nodes = d.nodes.map((n) => l(n, o))), p.source) {
      let { inputId: n, ...s } = p.source;
      p.source = s, n != null && (p.source.input = o[n]);
    }
    if (p.type === "root")
      return new c(p);
    if (p.type === "decl")
      return new r(p);
    if (p.type === "rule")
      return new a(p);
    if (p.type === "comment")
      return new t(p);
    if (p.type === "atrule")
      return new e(p);
    throw new Error("Unknown node type: " + d.type);
  }
  return xr = l, l.default = l, xr;
}
var wr, ln;
function Dn() {
  if (ln) return wr;
  ln = 1;
  let { dirname: e, relative: t, resolve: r, sep: u } = Oe, { SourceMapConsumer: i, SourceMapGenerator: c } = Oe, { pathToFileURL: a } = Oe, l = Qt(), d = !!(i && c), o = !!(e && r && t && u);
  class f {
    constructor(n, s, m, b) {
      this.stringify = n, this.mapOpts = m.map || {}, this.root = s, this.opts = m, this.css = b, this.originalCSS = b, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let n;
      this.isInline() ? n = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? n = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? n = this.mapOpts.annotation(this.opts.to, this.root) : n = this.outputFile() + ".map";
      let s = `
`;
      this.css.includes(`\r
`) && (s = `\r
`), this.css += s + "/*# sourceMappingURL=" + n + " */";
    }
    applyPrevMaps() {
      for (let n of this.previous()) {
        let s = this.toUrl(this.path(n.file)), m = n.root || e(n.file), b;
        this.mapOpts.sourcesContent === !1 ? (b = new i(n.text), b.sourcesContent && (b.sourcesContent = null)) : b = n.consumer(), this.map.applySourceMap(b, s, this.toUrl(this.path(m)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1)
        if (this.root) {
          let n;
          for (let s = this.root.nodes.length - 1; s >= 0; s--)
            n = this.root.nodes[s], n.type === "comment" && n.text.startsWith("# sourceMappingURL=") && this.root.removeChild(s);
        } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
    }
    generate() {
      if (this.clearAnnotation(), o && d && this.isMap())
        return this.generateMap();
      {
        let n = "";
        return this.stringify(this.root, (s) => {
          n += s;
        }), [n];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let n = this.previous()[0].consumer();
        n.file = this.outputFile(), this.map = c.fromSourceMap(n, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new c({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new c({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let n = 1, s = 1, m = "<no source>", b = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, g, h;
      this.stringify(this.root, (v, x, _) => {
        if (this.css += v, x && _ !== "end" && (b.generated.line = n, b.generated.column = s - 1, x.source && x.source.start ? (b.source = this.sourcePath(x), b.original.line = x.source.start.line, b.original.column = x.source.start.column - 1, this.map.addMapping(b)) : (b.source = m, b.original.line = 1, b.original.column = 0, this.map.addMapping(b))), h = v.match(/\n/g), h ? (n += h.length, g = v.lastIndexOf(`
`), s = v.length - g) : s += v.length, x && _ !== "start") {
          let y = x.parent || { raws: {} };
          (!(x.type === "decl" || x.type === "atrule" && !x.nodes) || x !== y.last || y.raws.semicolon) && (x.source && x.source.end ? (b.source = this.sourcePath(x), b.original.line = x.source.end.line, b.original.column = x.source.end.column - 1, b.generated.line = n, b.generated.column = s - 2, this.map.addMapping(b)) : (b.source = m, b.original.line = 1, b.original.column = 0, b.generated.line = n, b.generated.column = s - 1, this.map.addMapping(b)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((n) => n.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline < "u")
        return this.mapOpts.inline;
      let n = this.mapOpts.annotation;
      return typeof n < "u" && n !== !0 ? !1 : this.previous().length ? this.previous().some((s) => s.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((n) => n.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(n) {
      if (this.mapOpts.absolute || n.charCodeAt(0) === 60 || /^\w+:\/\//.test(n)) return n;
      let s = this.memoizedPaths.get(n);
      if (s) return s;
      let m = this.opts.to ? e(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (m = e(r(m, this.mapOpts.annotation)));
      let b = t(m, n);
      return this.memoizedPaths.set(n, b), b;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((n) => {
            if (n.source && n.source.input.map) {
              let s = n.source.input.map;
              this.previousMaps.includes(s) || this.previousMaps.push(s);
            }
          });
        else {
          let n = new l(this.originalCSS, this.opts);
          n.map && this.previousMaps.push(n.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let n = {};
      if (this.root)
        this.root.walk((s) => {
          if (s.source) {
            let m = s.source.input.from;
            if (m && !n[m]) {
              n[m] = !0;
              let b = this.usesFileUrls ? this.toFileUrl(m) : this.toUrl(this.path(m));
              this.map.setSourceContent(b, s.source.input.css);
            }
          }
        });
      else if (this.css) {
        let s = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(s, this.css);
      }
    }
    sourcePath(n) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(n.source.input.from) : this.toUrl(this.path(n.source.input.from));
    }
    toBase64(n) {
      return Buffer ? Buffer.from(n).toString("base64") : window.btoa(unescape(encodeURIComponent(n)));
    }
    toFileUrl(n) {
      let s = this.memoizedFileURLs.get(n);
      if (s) return s;
      if (a) {
        let m = a(n).toString();
        return this.memoizedFileURLs.set(n, m), m;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(n) {
      let s = this.memoizedURLs.get(n);
      if (s) return s;
      u === "\\" && (n = n.replace(/\\/g, "/"));
      let m = encodeURI(n).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(n, m), m;
    }
  }
  return wr = f, wr;
}
var _r, fn;
function ga() {
  if (fn) return _r;
  fn = 1;
  const e = 39, t = 34, r = 92, u = 47, i = 10, c = 32, a = 12, l = 9, d = 13, o = 91, f = 93, p = 40, n = 41, s = 123, m = 125, b = 59, g = 42, h = 58, v = 64, x = /[\t\n\f\r "#'()/;[\\\]{}]/g, _ = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, y = /.[\r\n"'(/\\]/, w = /[\da-f]/i;
  return _r = function(k, $ = {}) {
    let D = k.css.valueOf(), T = $.ignoreErrors, A, P, L, E, C, R, q, F, z, O, N = D.length, U = 0, V = [], W = [];
    function ne() {
      return U;
    }
    function se(I) {
      throw k.error("Unclosed " + I, U);
    }
    function de() {
      return W.length === 0 && U >= N;
    }
    function be(I) {
      if (W.length) return W.pop();
      if (U >= N) return;
      let B = I ? I.ignoreUnclosed : !1;
      switch (A = D.charCodeAt(U), A) {
        case i:
        case c:
        case l:
        case d:
        case a: {
          E = U;
          do
            E += 1, A = D.charCodeAt(E);
          while (A === c || A === i || A === l || A === d || A === a);
          R = ["space", D.slice(U, E)], U = E - 1;
          break;
        }
        case o:
        case f:
        case s:
        case m:
        case h:
        case b:
        case n: {
          let j = String.fromCharCode(A);
          R = [j, j, U];
          break;
        }
        case p: {
          if (O = V.length ? V.pop()[1] : "", z = D.charCodeAt(U + 1), O === "url" && z !== e && z !== t && z !== c && z !== i && z !== l && z !== a && z !== d) {
            E = U;
            do {
              if (q = !1, E = D.indexOf(")", E + 1), E === -1)
                if (T || B) {
                  E = U;
                  break;
                } else
                  se("bracket");
              for (F = E; D.charCodeAt(F - 1) === r; )
                F -= 1, q = !q;
            } while (q);
            R = ["brackets", D.slice(U, E + 1), U, E], U = E;
          } else
            E = D.indexOf(")", U + 1), P = D.slice(U, E + 1), E === -1 || y.test(P) ? R = ["(", "(", U] : (R = ["brackets", P, U, E], U = E);
          break;
        }
        case e:
        case t: {
          C = A === e ? "'" : '"', E = U;
          do {
            if (q = !1, E = D.indexOf(C, E + 1), E === -1)
              if (T || B) {
                E = U + 1;
                break;
              } else
                se("string");
            for (F = E; D.charCodeAt(F - 1) === r; )
              F -= 1, q = !q;
          } while (q);
          R = ["string", D.slice(U, E + 1), U, E], U = E;
          break;
        }
        case v: {
          x.lastIndex = U + 1, x.test(D), x.lastIndex === 0 ? E = D.length - 1 : E = x.lastIndex - 2, R = ["at-word", D.slice(U, E + 1), U, E], U = E;
          break;
        }
        case r: {
          for (E = U, L = !0; D.charCodeAt(E + 1) === r; )
            E += 1, L = !L;
          if (A = D.charCodeAt(E + 1), L && A !== u && A !== c && A !== i && A !== l && A !== d && A !== a && (E += 1, w.test(D.charAt(E)))) {
            for (; w.test(D.charAt(E + 1)); )
              E += 1;
            D.charCodeAt(E + 1) === c && (E += 1);
          }
          R = ["word", D.slice(U, E + 1), U, E], U = E;
          break;
        }
        default: {
          A === u && D.charCodeAt(U + 1) === g ? (E = D.indexOf("*/", U + 2) + 1, E === 0 && (T || B ? E = D.length : se("comment")), R = ["comment", D.slice(U, E + 1), U, E], U = E) : (_.lastIndex = U + 1, _.test(D), _.lastIndex === 0 ? E = D.length - 1 : E = _.lastIndex - 2, R = ["word", D.slice(U, E + 1), U, E], V.push(R), U = E);
          break;
        }
      }
      return U++, R;
    }
    function oe(I) {
      W.push(I);
    }
    return {
      back: oe,
      endOfFile: de,
      nextToken: be,
      position: ne
    };
  }, _r;
}
var Sr, dn;
function ya() {
  if (dn) return Sr;
  dn = 1;
  let e = jr(), t = Gt(), r = Wt(), u = mt(), i = zr(), c = ga();
  const a = {
    empty: !0,
    space: !0
  };
  function l(o) {
    for (let f = o.length - 1; f >= 0; f--) {
      let p = o[f], n = p[3] || p[2];
      if (n) return n;
    }
  }
  class d {
    constructor(f) {
      this.input = f, this.root = new u(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: f, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(f) {
      let p = new e();
      p.name = f[1].slice(1), p.name === "" && this.unnamedAtrule(p, f), this.init(p, f[2]);
      let n, s, m, b = !1, g = !1, h = [], v = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (f = this.tokenizer.nextToken(), n = f[0], n === "(" || n === "[" ? v.push(n === "(" ? ")" : "]") : n === "{" && v.length > 0 ? v.push("}") : n === v[v.length - 1] && v.pop(), v.length === 0)
          if (n === ";") {
            p.source.end = this.getPosition(f[2]), p.source.end.offset++, this.semicolon = !0;
            break;
          } else if (n === "{") {
            g = !0;
            break;
          } else if (n === "}") {
            if (h.length > 0) {
              for (m = h.length - 1, s = h[m]; s && s[0] === "space"; )
                s = h[--m];
              s && (p.source.end = this.getPosition(s[3] || s[2]), p.source.end.offset++);
            }
            this.end(f);
            break;
          } else
            h.push(f);
        else
          h.push(f);
        if (this.tokenizer.endOfFile()) {
          b = !0;
          break;
        }
      }
      p.raws.between = this.spacesAndCommentsFromEnd(h), h.length ? (p.raws.afterName = this.spacesAndCommentsFromStart(h), this.raw(p, "params", h), b && (f = h[h.length - 1], p.source.end = this.getPosition(f[3] || f[2]), p.source.end.offset++, this.spaces = p.raws.between, p.raws.between = "")) : (p.raws.afterName = "", p.params = ""), g && (p.nodes = [], this.current = p);
    }
    checkMissedSemicolon(f) {
      let p = this.colon(f);
      if (p === !1) return;
      let n = 0, s;
      for (let m = p - 1; m >= 0 && (s = f[m], !(s[0] !== "space" && (n += 1, n === 2))); m--)
        ;
      throw this.input.error(
        "Missed semicolon",
        s[0] === "word" ? s[3] + 1 : s[2]
      );
    }
    colon(f) {
      let p = 0, n, s, m;
      for (let [b, g] of f.entries()) {
        if (s = g, m = s[0], m === "(" && (p += 1), m === ")" && (p -= 1), p === 0 && m === ":")
          if (!n)
            this.doubleColon(s);
          else {
            if (n[0] === "word" && n[1] === "progid")
              continue;
            return b;
          }
        n = s;
      }
      return !1;
    }
    comment(f) {
      let p = new t();
      this.init(p, f[2]), p.source.end = this.getPosition(f[3] || f[2]), p.source.end.offset++;
      let n = f[1].slice(2, -2);
      if (/^\s*$/.test(n))
        p.text = "", p.raws.left = n, p.raws.right = "";
      else {
        let s = n.match(/^(\s*)([^]*\S)(\s*)$/);
        p.text = s[2], p.raws.left = s[1], p.raws.right = s[3];
      }
    }
    createTokenizer() {
      this.tokenizer = c(this.input);
    }
    decl(f, p) {
      let n = new r();
      this.init(n, f[0][2]);
      let s = f[f.length - 1];
      for (s[0] === ";" && (this.semicolon = !0, f.pop()), n.source.end = this.getPosition(
        s[3] || s[2] || l(f)
      ), n.source.end.offset++; f[0][0] !== "word"; )
        f.length === 1 && this.unknownWord(f), n.raws.before += f.shift()[1];
      for (n.source.start = this.getPosition(f[0][2]), n.prop = ""; f.length; ) {
        let v = f[0][0];
        if (v === ":" || v === "space" || v === "comment")
          break;
        n.prop += f.shift()[1];
      }
      n.raws.between = "";
      let m;
      for (; f.length; )
        if (m = f.shift(), m[0] === ":") {
          n.raws.between += m[1];
          break;
        } else
          m[0] === "word" && /\w/.test(m[1]) && this.unknownWord([m]), n.raws.between += m[1];
      (n.prop[0] === "_" || n.prop[0] === "*") && (n.raws.before += n.prop[0], n.prop = n.prop.slice(1));
      let b = [], g;
      for (; f.length && (g = f[0][0], !(g !== "space" && g !== "comment")); )
        b.push(f.shift());
      this.precheckMissedSemicolon(f);
      for (let v = f.length - 1; v >= 0; v--) {
        if (m = f[v], m[1].toLowerCase() === "!important") {
          n.important = !0;
          let x = this.stringFrom(f, v);
          x = this.spacesFromEnd(f) + x, x !== " !important" && (n.raws.important = x);
          break;
        } else if (m[1].toLowerCase() === "important") {
          let x = f.slice(0), _ = "";
          for (let y = v; y > 0; y--) {
            let w = x[y][0];
            if (_.trim().startsWith("!") && w !== "space")
              break;
            _ = x.pop()[1] + _;
          }
          _.trim().startsWith("!") && (n.important = !0, n.raws.important = _, f = x);
        }
        if (m[0] !== "space" && m[0] !== "comment")
          break;
      }
      f.some((v) => v[0] !== "space" && v[0] !== "comment") && (n.raws.between += b.map((v) => v[1]).join(""), b = []), this.raw(n, "value", b.concat(f), p), n.value.includes(":") && !p && this.checkMissedSemicolon(f);
    }
    doubleColon(f) {
      throw this.input.error(
        "Double colon",
        { offset: f[2] },
        { offset: f[2] + f[1].length }
      );
    }
    emptyRule(f) {
      let p = new i();
      this.init(p, f[2]), p.selector = "", p.raws.between = "", this.current = p;
    }
    end(f) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(f[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(f);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(f) {
      if (this.spaces += f[1], this.current.nodes) {
        let p = this.current.nodes[this.current.nodes.length - 1];
        p && p.type === "rule" && !p.raws.ownSemicolon && (p.raws.ownSemicolon = this.spaces, this.spaces = "", p.source.end = this.getPosition(f[2]), p.source.end.offset += p.raws.ownSemicolon.length);
      }
    }
    // Helpers
    getPosition(f) {
      let p = this.input.fromOffset(f);
      return {
        column: p.col,
        line: p.line,
        offset: f
      };
    }
    init(f, p) {
      this.current.push(f), f.source = {
        input: this.input,
        start: this.getPosition(p)
      }, f.raws.before = this.spaces, this.spaces = "", f.type !== "comment" && (this.semicolon = !1);
    }
    other(f) {
      let p = !1, n = null, s = !1, m = null, b = [], g = f[1].startsWith("--"), h = [], v = f;
      for (; v; ) {
        if (n = v[0], h.push(v), n === "(" || n === "[")
          m || (m = v), b.push(n === "(" ? ")" : "]");
        else if (g && s && n === "{")
          m || (m = v), b.push("}");
        else if (b.length === 0)
          if (n === ";")
            if (s) {
              this.decl(h, g);
              return;
            } else
              break;
          else if (n === "{") {
            this.rule(h);
            return;
          } else if (n === "}") {
            this.tokenizer.back(h.pop()), p = !0;
            break;
          } else n === ":" && (s = !0);
        else n === b[b.length - 1] && (b.pop(), b.length === 0 && (m = null));
        v = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (p = !0), b.length > 0 && this.unclosedBracket(m), p && s) {
        if (!g)
          for (; h.length && (v = h[h.length - 1][0], !(v !== "space" && v !== "comment")); )
            this.tokenizer.back(h.pop());
        this.decl(h, g);
      } else
        this.unknownWord(h);
    }
    parse() {
      let f;
      for (; !this.tokenizer.endOfFile(); )
        switch (f = this.tokenizer.nextToken(), f[0]) {
          case "space":
            this.spaces += f[1];
            break;
          case ";":
            this.freeSemicolon(f);
            break;
          case "}":
            this.end(f);
            break;
          case "comment":
            this.comment(f);
            break;
          case "at-word":
            this.atrule(f);
            break;
          case "{":
            this.emptyRule(f);
            break;
          default:
            this.other(f);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(f, p, n, s) {
      let m, b, g = n.length, h = "", v = !0, x, _;
      for (let y = 0; y < g; y += 1)
        m = n[y], b = m[0], b === "space" && y === g - 1 && !s ? v = !1 : b === "comment" ? (_ = n[y - 1] ? n[y - 1][0] : "empty", x = n[y + 1] ? n[y + 1][0] : "empty", !a[_] && !a[x] ? h.slice(-1) === "," ? v = !1 : h += m[1] : v = !1) : h += m[1];
      if (!v) {
        let y = n.reduce((w, S) => w + S[1], "");
        f.raws[p] = { raw: y, value: h };
      }
      f[p] = h;
    }
    rule(f) {
      f.pop();
      let p = new i();
      this.init(p, f[0][2]), p.raws.between = this.spacesAndCommentsFromEnd(f), this.raw(p, "selector", f), this.current = p;
    }
    spacesAndCommentsFromEnd(f) {
      let p, n = "";
      for (; f.length && (p = f[f.length - 1][0], !(p !== "space" && p !== "comment")); )
        n = f.pop()[1] + n;
      return n;
    }
    // Errors
    spacesAndCommentsFromStart(f) {
      let p, n = "";
      for (; f.length && (p = f[0][0], !(p !== "space" && p !== "comment")); )
        n += f.shift()[1];
      return n;
    }
    spacesFromEnd(f) {
      let p, n = "";
      for (; f.length && (p = f[f.length - 1][0], p === "space"); )
        n = f.pop()[1] + n;
      return n;
    }
    stringFrom(f, p) {
      let n = "";
      for (let s = p; s < f.length; s++)
        n += f[s][1];
      return f.splice(p, f.length - p), n;
    }
    unclosedBlock() {
      let f = this.current.source.start;
      throw this.input.error("Unclosed block", f.line, f.column);
    }
    unclosedBracket(f) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: f[2] },
        { offset: f[2] + 1 }
      );
    }
    unexpectedClose(f) {
      throw this.input.error(
        "Unexpected }",
        { offset: f[2] },
        { offset: f[2] + 1 }
      );
    }
    unknownWord(f) {
      throw this.input.error(
        "Unknown word " + f[0][1],
        { offset: f[0][2] },
        { offset: f[0][2] + f[0][1].length }
      );
    }
    unnamedAtrule(f, p) {
      throw this.input.error(
        "At-rule without name",
        { offset: p[2] },
        { offset: p[2] + p[1].length }
      );
    }
  }
  return Sr = d, Sr;
}
var Mr, hn;
function Br() {
  if (hn) return Mr;
  hn = 1;
  let e = ot(), t = Qt(), r = ya();
  function u(i, c) {
    let a = new t(i, c), l = new r(a);
    try {
      l.parse();
    } catch (d) {
      throw process.env.NODE_ENV !== "production" && d.name === "CssSyntaxError" && c && c.from && (/\.scss$/i.test(c.from) ? d.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(c.from) ? d.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(c.from) && (d.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), d;
    }
    return l.root;
  }
  return Mr = u, u.default = u, e.registerParse(u), Mr;
}
var kr, pn;
function On() {
  if (pn) return kr;
  pn = 1;
  class e {
    constructor(r, u = {}) {
      if (this.type = "warning", this.text = r, u.node && u.node.source) {
        let i = u.node.rangeBy(u);
        this.line = i.start.line, this.column = i.start.column, this.endLine = i.end.line, this.endColumn = i.end.column;
      }
      for (let i in u) this[i] = u[i];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return kr = e, e.default = e, kr;
}
var Tr, mn;
function Yr() {
  if (mn) return Tr;
  mn = 1;
  let e = On();
  class t {
    get content() {
      return this.css;
    }
    constructor(u, i, c) {
      this.processor = u, this.messages = [], this.root = i, this.opts = c, this.css = void 0, this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(u, i = {}) {
      i.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (i.plugin = this.lastPlugin.postcssPlugin);
      let c = new e(u, i);
      return this.messages.push(c), c;
    }
    warnings() {
      return this.messages.filter((u) => u.type === "warning");
    }
  }
  return Tr = t, t.default = t, Tr;
}
var Er, bn;
function Ln() {
  if (bn) return Er;
  bn = 1;
  let e = {};
  return Er = function(r) {
    e[r] || (e[r] = !0, typeof console < "u" && console.warn && console.warn(r));
  }, Er;
}
var Ar, gn;
function Cn() {
  if (gn) return Ar;
  gn = 1;
  let e = ot(), t = Fr(), r = Dn(), u = Br(), i = Yr(), c = mt(), a = Yt(), { isClean: l, my: d } = Rr(), o = Ln();
  const f = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, p = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, n = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, s = 0;
  function m(_) {
    return typeof _ == "object" && typeof _.then == "function";
  }
  function b(_) {
    let y = !1, w = f[_.type];
    return _.type === "decl" ? y = _.prop.toLowerCase() : _.type === "atrule" && (y = _.name.toLowerCase()), y && _.append ? [
      w,
      w + "-" + y,
      s,
      w + "Exit",
      w + "Exit-" + y
    ] : y ? [w, w + "-" + y, w + "Exit", w + "Exit-" + y] : _.append ? [w, s, w + "Exit"] : [w, w + "Exit"];
  }
  function g(_) {
    let y;
    return _.type === "document" ? y = ["Document", s, "DocumentExit"] : _.type === "root" ? y = ["Root", s, "RootExit"] : y = b(_), {
      eventIndex: 0,
      events: y,
      iterator: 0,
      node: _,
      visitorIndex: 0,
      visitors: []
    };
  }
  function h(_) {
    return _[l] = !1, _.nodes && _.nodes.forEach((y) => h(y)), _;
  }
  let v = {};
  class x {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(y, w, S) {
      this.stringified = !1, this.processed = !1;
      let k;
      if (typeof w == "object" && w !== null && (w.type === "root" || w.type === "document"))
        k = h(w);
      else if (w instanceof x || w instanceof i)
        k = h(w.root), w.map && (typeof S.map > "u" && (S.map = {}), S.map.inline || (S.map.inline = !1), S.map.prev = w.map);
      else {
        let $ = u;
        S.syntax && ($ = S.syntax.parse), S.parser && ($ = S.parser), $.parse && ($ = $.parse);
        try {
          k = $(w, S);
        } catch (D) {
          this.processed = !0, this.error = D;
        }
        k && !k[d] && e.rebuild(k);
      }
      this.result = new i(y, k, S), this.helpers = { ...v, postcss: v, result: this.result }, this.plugins = this.processor.plugins.map(($) => typeof $ == "object" && $.prepare ? { ...$, ...$.prepare(this.result) } : $);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(y) {
      return this.async().catch(y);
    }
    finally(y) {
      return this.async().then(y, y);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(y, w) {
      let S = this.result.lastPlugin;
      try {
        if (w && w.addToError(y), this.error = y, y.name === "CssSyntaxError" && !y.plugin)
          y.plugin = S.postcssPlugin, y.setMessage();
        else if (S.postcssVersion && process.env.NODE_ENV !== "production") {
          let k = S.postcssPlugin, $ = S.postcssVersion, D = this.result.processor.version, T = $.split("."), A = D.split(".");
          (T[0] !== A[0] || parseInt(T[1]) > parseInt(A[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + D + ", but " + k + " uses " + $ + ". Perhaps this is the source of the error below."
          );
        }
      } catch (k) {
        console && console.error && console.error(k);
      }
      return y;
    }
    prepareVisitors() {
      this.listeners = {};
      let y = (w, S, k) => {
        this.listeners[S] || (this.listeners[S] = []), this.listeners[S].push([w, k]);
      };
      for (let w of this.plugins)
        if (typeof w == "object")
          for (let S in w) {
            if (!p[S] && /^[A-Z]/.test(S))
              throw new Error(
                `Unknown event ${S} in ${w.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!n[S])
              if (typeof w[S] == "object")
                for (let k in w[S])
                  k === "*" ? y(w, S, w[S][k]) : y(
                    w,
                    S + "-" + k.toLowerCase(),
                    w[S][k]
                  );
              else typeof w[S] == "function" && y(w, S, w[S]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let y = 0; y < this.plugins.length; y++) {
        let w = this.plugins[y], S = this.runOnRoot(w);
        if (m(S))
          try {
            await S;
          } catch (k) {
            throw this.handleError(k);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let y = this.result.root;
        for (; !y[l]; ) {
          y[l] = !0;
          let w = [g(y)];
          for (; w.length > 0; ) {
            let S = this.visitTick(w);
            if (m(S))
              try {
                await S;
              } catch (k) {
                let $ = w[w.length - 1].node;
                throw this.handleError(k, $);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [w, S] of this.listeners.OnceExit) {
            this.result.lastPlugin = w;
            try {
              if (y.type === "document") {
                let k = y.nodes.map(
                  ($) => S($, this.helpers)
                );
                await Promise.all(k);
              } else
                await S(y, this.helpers);
            } catch (k) {
              throw this.handleError(k);
            }
          }
      }
      return this.processed = !0, this.stringify();
    }
    runOnRoot(y) {
      this.result.lastPlugin = y;
      try {
        if (typeof y == "object" && y.Once) {
          if (this.result.root.type === "document") {
            let w = this.result.root.nodes.map(
              (S) => y.Once(S, this.helpers)
            );
            return m(w[0]) ? Promise.all(w) : w;
          }
          return y.Once(this.result.root, this.helpers);
        } else if (typeof y == "function")
          return y(this.result.root, this.result);
      } catch (w) {
        throw this.handleError(w);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let y = this.result.opts, w = a;
      y.syntax && (w = y.syntax.stringify), y.stringifier && (w = y.stringifier), w.stringify && (w = w.stringify);
      let k = new r(w, this.result.root, this.result.opts).generate();
      return this.result.css = k[0], this.result.map = k[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let y of this.plugins) {
        let w = this.runOnRoot(y);
        if (m(w))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let y = this.result.root;
        for (; !y[l]; )
          y[l] = !0, this.walkSync(y);
        if (this.listeners.OnceExit)
          if (y.type === "document")
            for (let w of y.nodes)
              this.visitSync(this.listeners.OnceExit, w);
          else
            this.visitSync(this.listeners.OnceExit, y);
      }
      return this.result;
    }
    then(y, w) {
      return process.env.NODE_ENV !== "production" && ("from" in this.opts || o(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(y, w);
    }
    toString() {
      return this.css;
    }
    visitSync(y, w) {
      for (let [S, k] of y) {
        this.result.lastPlugin = S;
        let $;
        try {
          $ = k(w, this.helpers);
        } catch (D) {
          throw this.handleError(D, w.proxyOf);
        }
        if (w.type !== "root" && w.type !== "document" && !w.parent)
          return !0;
        if (m($))
          throw this.getAsyncError();
      }
    }
    visitTick(y) {
      let w = y[y.length - 1], { node: S, visitors: k } = w;
      if (S.type !== "root" && S.type !== "document" && !S.parent) {
        y.pop();
        return;
      }
      if (k.length > 0 && w.visitorIndex < k.length) {
        let [D, T] = k[w.visitorIndex];
        w.visitorIndex += 1, w.visitorIndex === k.length && (w.visitors = [], w.visitorIndex = 0), this.result.lastPlugin = D;
        try {
          return T(S.toProxy(), this.helpers);
        } catch (A) {
          throw this.handleError(A, S);
        }
      }
      if (w.iterator !== 0) {
        let D = w.iterator, T;
        for (; T = S.nodes[S.indexes[D]]; )
          if (S.indexes[D] += 1, !T[l]) {
            T[l] = !0, y.push(g(T));
            return;
          }
        w.iterator = 0, delete S.indexes[D];
      }
      let $ = w.events;
      for (; w.eventIndex < $.length; ) {
        let D = $[w.eventIndex];
        if (w.eventIndex += 1, D === s) {
          S.nodes && S.nodes.length && (S[l] = !0, w.iterator = S.getIterator());
          return;
        } else if (this.listeners[D]) {
          w.visitors = this.listeners[D];
          return;
        }
      }
      y.pop();
    }
    walkSync(y) {
      y[l] = !0;
      let w = b(y);
      for (let S of w)
        if (S === s)
          y.nodes && y.each((k) => {
            k[l] || this.walkSync(k);
          });
        else {
          let k = this.listeners[S];
          if (k && this.visitSync(k, y.toProxy()))
            return;
        }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return x.registerPostcss = (_) => {
    v = _;
  }, Ar = x, x.default = x, c.registerLazyResult(x), t.registerLazyResult(x), Ar;
}
var $r, yn;
function va() {
  if (yn) return $r;
  yn = 1;
  let e = Dn(), t = Br();
  const r = Yr();
  let u = Yt(), i = Ln();
  class c {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let l, d = t;
      try {
        l = d(this._css, this._opts);
      } catch (o) {
        this.error = o;
      }
      if (this.error)
        throw this.error;
      return this._root = l, l;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(l, d, o) {
      d = d.toString(), this.stringified = !1, this._processor = l, this._css = d, this._opts = o, this._map = void 0;
      let f, p = u;
      this.result = new r(this._processor, f, this._opts), this.result.css = d;
      let n = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return n.root;
        }
      });
      let s = new e(p, f, this._opts, d);
      if (s.isMap()) {
        let [m, b] = s.generate();
        m && (this.result.css = m), b && (this.result.map = b);
      } else
        s.clearAnnotation(), this.result.css = s.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(l) {
      return this.async().catch(l);
    }
    finally(l) {
      return this.async().then(l, l);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(l, d) {
      return process.env.NODE_ENV !== "production" && ("from" in this._opts || i(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(l, d);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return $r = c, c.default = c, $r;
}
var Dr, vn;
function xa() {
  if (vn) return Dr;
  vn = 1;
  let e = Fr(), t = Cn(), r = va(), u = mt();
  class i {
    constructor(a = []) {
      this.version = "8.5.3", this.plugins = this.normalize(a);
    }
    normalize(a) {
      let l = [];
      for (let d of a)
        if (d.postcss === !0 ? d = d() : d.postcss && (d = d.postcss), typeof d == "object" && Array.isArray(d.plugins))
          l = l.concat(d.plugins);
        else if (typeof d == "object" && d.postcssPlugin)
          l.push(d);
        else if (typeof d == "function")
          l.push(d);
        else if (typeof d == "object" && (d.parse || d.stringify)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(d + " is not a PostCSS plugin");
      return l;
    }
    process(a, l = {}) {
      return !this.plugins.length && !l.parser && !l.stringifier && !l.syntax ? new r(this, a, l) : new t(this, a, l);
    }
    use(a) {
      return this.plugins = this.plugins.concat(this.normalize([a])), this;
    }
  }
  return Dr = i, i.default = i, u.registerProcessor(i), e.registerProcessor(i), Dr;
}
var Or, xn;
function wa() {
  if (xn) return Or;
  xn = 1;
  let e = jr(), t = Gt(), r = ot(), u = Hr(), i = Wt(), c = Fr(), a = ba(), l = Qt(), d = Cn(), o = $n(), f = Vt(), p = Br(), n = xa(), s = Yr(), m = mt(), b = zr(), g = Yt(), h = On();
  function v(...x) {
    return x.length === 1 && Array.isArray(x[0]) && (x = x[0]), new n(x);
  }
  return v.plugin = function(_, y) {
    let w = !1;
    function S(...$) {
      console && console.warn && !w && (w = !0, console.warn(
        _ + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
        _ + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let D = y(...$);
      return D.postcssPlugin = _, D.postcssVersion = new n().version, D;
    }
    let k;
    return Object.defineProperty(S, "postcss", {
      get() {
        return k || (k = S()), k;
      }
    }), S.process = function($, D, T) {
      return v([S(T)]).process($, D);
    }, S;
  }, v.stringify = g, v.parse = p, v.fromJSON = a, v.list = o, v.comment = (x) => new t(x), v.atRule = (x) => new e(x), v.decl = (x) => new i(x), v.rule = (x) => new b(x), v.root = (x) => new m(x), v.document = (x) => new c(x), v.CssSyntaxError = u, v.Declaration = i, v.Container = r, v.Processor = n, v.Document = c, v.Comment = t, v.Warning = h, v.AtRule = e, v.Result = s, v.Input = l, v.Rule = b, v.Root = m, v.Node = f, d.registerPostcss(v), Or = v, v.default = v, Or;
}
var Lr, wn;
function _a() {
  if (wn) return Lr;
  wn = 1;
  const e = /* @__PURE__ */ aa(), t = sa(), { isPlainObject: r } = oa(), u = ca(), i = fa(), { parse: c } = wa(), a = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ], l = ["script", "style"];
  function d(g, h) {
    g && Object.keys(g).forEach(function(v) {
      h(g[v], v);
    });
  }
  function o(g, h) {
    return {}.hasOwnProperty.call(g, h);
  }
  function f(g, h) {
    const v = [];
    return d(g, function(x) {
      h(x) && v.push(x);
    }), v;
  }
  function p(g) {
    for (const h in g)
      if (o(g, h))
        return !1;
    return !0;
  }
  function n(g) {
    return g.map(function(h) {
      if (!h.url)
        throw new Error("URL missing");
      return h.url + (h.w ? ` ${h.w}w` : "") + (h.h ? ` ${h.h}h` : "") + (h.d ? ` ${h.d}x` : "");
    }).join(", ");
  }
  Lr = m;
  const s = /^[^\0\t\n\f\r /<=>]+$/;
  function m(g, h, v) {
    if (g == null)
      return "";
    typeof g == "number" && (g = g.toString());
    let x = "", _ = "";
    function y(I, B) {
      const j = this;
      this.tag = I, this.attribs = B || {}, this.tagPosition = x.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
        if (C.length) {
          const G = C[C.length - 1];
          G.text += j.text;
        }
      }, this.updateParentNodeMediaChildren = function() {
        C.length && a.includes(this.tag) && C[C.length - 1].mediaChildren.push(this.tag);
      };
    }
    h = Object.assign({}, m.defaults, h), h.parser = Object.assign({}, b, h.parser);
    const w = function(I) {
      return h.allowedTags === !1 || (h.allowedTags || []).indexOf(I) > -1;
    };
    l.forEach(function(I) {
      w(I) && !h.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${I}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
    });
    const S = h.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option"
    ];
    let k, $;
    h.allowedAttributes && (k = {}, $ = {}, d(h.allowedAttributes, function(I, B) {
      k[B] = [];
      const j = [];
      I.forEach(function(G) {
        typeof G == "string" && G.indexOf("*") >= 0 ? j.push(t(G).replace(/\\\*/g, ".*")) : k[B].push(G);
      }), j.length && ($[B] = new RegExp("^(" + j.join("|") + ")$"));
    }));
    const D = {}, T = {}, A = {};
    d(h.allowedClasses, function(I, B) {
      if (k && (o(k, B) || (k[B] = []), k[B].push("class")), D[B] = I, Array.isArray(I)) {
        const j = [];
        D[B] = [], A[B] = [], I.forEach(function(G) {
          typeof G == "string" && G.indexOf("*") >= 0 ? j.push(t(G).replace(/\\\*/g, ".*")) : G instanceof RegExp ? A[B].push(G) : D[B].push(G);
        }), j.length && (T[B] = new RegExp("^(" + j.join("|") + ")$"));
      }
    });
    const P = {};
    let L;
    d(h.transformTags, function(I, B) {
      let j;
      typeof I == "function" ? j = I : typeof I == "string" && (j = m.simpleTransform(I)), B === "*" ? L = j : P[B] = j;
    });
    let E, C, R, q, F, z, O = !1;
    U();
    const N = new e.Parser({
      onopentag: function(I, B) {
        if (h.onOpenTag && h.onOpenTag(I, B), h.enforceHtmlBoundary && I === "html" && U(), F) {
          z++;
          return;
        }
        const j = new y(I, B);
        C.push(j);
        let G = !1;
        const ce = !!j.text;
        let le;
        if (o(P, I) && (le = P[I](I, B), j.attribs = B = le.attribs, le.text !== void 0 && (j.innerText = le.text), I !== le.tagName && (j.name = I = le.tagName, q[E] = le.tagName)), L && (le = L(I, B), j.attribs = B = le.attribs, I !== le.tagName && (j.name = I = le.tagName, q[E] = le.tagName)), (!w(I) || h.disallowedTagsMode === "recursiveEscape" && !p(R) || h.nestingLimit != null && E >= h.nestingLimit) && (G = !0, R[E] = !0, (h.disallowedTagsMode === "discard" || h.disallowedTagsMode === "completelyDiscard") && S.indexOf(I) !== -1 && (F = !0, z = 1)), E++, G) {
          if (h.disallowedTagsMode === "discard" || h.disallowedTagsMode === "completelyDiscard") {
            if (j.innerText && !ce) {
              const X = V(j.innerText);
              h.textFilter ? x += h.textFilter(X, I) : x += X, O = !0;
            }
            return;
          }
          _ = x, x = "";
        }
        x += "<" + I, I === "script" && (h.allowedScriptHostnames || h.allowedScriptDomains) && (j.innerText = ""), G && (h.disallowedTagsMode === "escape" || h.disallowedTagsMode === "recursiveEscape") && h.preserveEscapedAttributes ? d(B, function(X, ee) {
          x += " " + ee + '="' + V(X || "", !0) + '"';
        }) : (!k || o(k, I) || k["*"]) && d(B, function(X, ee) {
          if (!s.test(ee)) {
            delete j.attribs[ee];
            return;
          }
          if (X === "" && !h.allowedEmptyAttributes.includes(ee) && (h.nonBooleanAttributes.includes(ee) || h.nonBooleanAttributes.includes("*"))) {
            delete j.attribs[ee];
            return;
          }
          let Fe = !1;
          if (!k || o(k, I) && k[I].indexOf(ee) !== -1 || k["*"] && k["*"].indexOf(ee) !== -1 || o($, I) && $[I].test(ee) || $["*"] && $["*"].test(ee))
            Fe = !0;
          else if (k && k[I]) {
            for (const ie of k[I])
              if (r(ie) && ie.name && ie.name === ee) {
                Fe = !0;
                let ae = "";
                if (ie.multiple === !0) {
                  const Pe = X.split(" ");
                  for (const Me of Pe)
                    ie.values.indexOf(Me) !== -1 && (ae === "" ? ae = Me : ae += " " + Me);
                } else ie.values.indexOf(X) >= 0 && (ae = X);
                X = ae;
              }
          }
          if (Fe) {
            if (h.allowedSchemesAppliedToAttributes.indexOf(ee) !== -1 && W(I, X)) {
              delete j.attribs[ee];
              return;
            }
            if (I === "script" && ee === "src") {
              let ie = !0;
              try {
                const ae = ne(X);
                if (h.allowedScriptHostnames || h.allowedScriptDomains) {
                  const Pe = (h.allowedScriptHostnames || []).find(function(he) {
                    return he === ae.url.hostname;
                  }), Me = (h.allowedScriptDomains || []).find(function(he) {
                    return ae.url.hostname === he || ae.url.hostname.endsWith(`.${he}`);
                  });
                  ie = Pe || Me;
                }
              } catch {
                ie = !1;
              }
              if (!ie) {
                delete j.attribs[ee];
                return;
              }
            }
            if (I === "iframe" && ee === "src") {
              let ie = !0;
              try {
                const ae = ne(X);
                if (ae.isRelativeUrl)
                  ie = o(h, "allowIframeRelativeUrls") ? h.allowIframeRelativeUrls : !h.allowedIframeHostnames && !h.allowedIframeDomains;
                else if (h.allowedIframeHostnames || h.allowedIframeDomains) {
                  const Pe = (h.allowedIframeHostnames || []).find(function(he) {
                    return he === ae.url.hostname;
                  }), Me = (h.allowedIframeDomains || []).find(function(he) {
                    return ae.url.hostname === he || ae.url.hostname.endsWith(`.${he}`);
                  });
                  ie = Pe || Me;
                }
              } catch {
                ie = !1;
              }
              if (!ie) {
                delete j.attribs[ee];
                return;
              }
            }
            if (ee === "srcset")
              try {
                let ie = i(X);
                if (ie.forEach(function(ae) {
                  W("srcset", ae.url) && (ae.evil = !0);
                }), ie = f(ie, function(ae) {
                  return !ae.evil;
                }), ie.length)
                  X = n(f(ie, function(ae) {
                    return !ae.evil;
                  })), j.attribs[ee] = X;
                else {
                  delete j.attribs[ee];
                  return;
                }
              } catch {
                delete j.attribs[ee];
                return;
              }
            if (ee === "class") {
              const ie = D[I], ae = D["*"], Pe = T[I], Me = A[I], he = A["*"], qe = T["*"], Te = [
                Pe,
                qe
              ].concat(Me, he).filter(function(_e) {
                return _e;
              });
              if (ie && ae ? X = oe(X, u(ie, ae), Te) : X = oe(X, ie || ae, Te), !X.length) {
                delete j.attribs[ee];
                return;
              }
            }
            if (ee === "style") {
              if (h.parseStyleAttributes)
                try {
                  const ie = c(I + " {" + X + "}", { map: !1 }), ae = se(ie, h.allowedStyles);
                  if (X = de(ae), X.length === 0) {
                    delete j.attribs[ee];
                    return;
                  }
                } catch {
                  typeof window < "u" && console.warn('Failed to parse "' + I + " {" + X + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete j.attribs[ee];
                  return;
                }
              else if (h.allowedStyles)
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
            }
            x += " " + ee, X && X.length ? x += '="' + V(X, !0) + '"' : h.allowedEmptyAttributes.includes(ee) && (x += '=""');
          } else
            delete j.attribs[ee];
        }), h.selfClosing.indexOf(I) !== -1 ? x += " />" : (x += ">", j.innerText && !ce && !h.textFilter && (x += V(j.innerText), O = !0)), G && (x = _ + V(x), _ = ""), j.openingTagLength = x.length - j.tagPosition;
      },
      ontext: function(I) {
        if (F)
          return;
        const B = C[C.length - 1];
        let j;
        if (B && (j = B.tag, I = B.innerText !== void 0 ? B.innerText : I), h.disallowedTagsMode === "completelyDiscard" && !w(j))
          I = "";
        else if ((h.disallowedTagsMode === "discard" || h.disallowedTagsMode === "completelyDiscard") && (j === "script" || j === "style"))
          x += I;
        else if (!O) {
          const G = V(I, !1);
          h.textFilter ? x += h.textFilter(G, j) : x += G;
        }
        if (C.length) {
          const G = C[C.length - 1];
          G.text += I;
        }
      },
      onclosetag: function(I, B) {
        if (h.onCloseTag && h.onCloseTag(I, B), F)
          if (z--, !z)
            F = !1;
          else
            return;
        const j = C.pop();
        if (!j)
          return;
        if (j.tag !== I) {
          C.push(j);
          return;
        }
        F = h.enforceHtmlBoundary ? I === "html" : !1, E--;
        const G = R[E];
        if (G) {
          if (delete R[E], h.disallowedTagsMode === "discard" || h.disallowedTagsMode === "completelyDiscard") {
            j.updateParentNodeText();
            return;
          }
          _ = x, x = "";
        }
        if (q[E] && (I = q[E], delete q[E]), h.exclusiveFilter) {
          const ce = h.exclusiveFilter(j);
          if (ce === "excludeTag") {
            G && (x = _, _ = ""), x = x.substring(0, j.tagPosition) + x.substring(j.tagPosition + j.openingTagLength);
            return;
          } else if (ce) {
            x = x.substring(0, j.tagPosition);
            return;
          }
        }
        if (j.updateParentNodeMediaChildren(), j.updateParentNodeText(), // Already output />
        h.selfClosing.indexOf(I) !== -1 || // Escaped tag, closing tag is implied
        B && !w(I) && ["escape", "recursiveEscape"].indexOf(h.disallowedTagsMode) >= 0) {
          G && (x = _, _ = "");
          return;
        }
        x += "</" + I + ">", G && (x = _ + V(x), _ = ""), O = !1;
      }
    }, h.parser);
    return N.write(g), N.end(), x;
    function U() {
      x = "", E = 0, C = [], R = {}, q = {}, F = !1, z = 0;
    }
    function V(I, B) {
      return typeof I != "string" && (I = I + ""), h.parser.decodeEntities && (I = I.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), B && (I = I.replace(/"/g, "&quot;"))), I = I.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), B && (I = I.replace(/"/g, "&quot;")), I;
    }
    function W(I, B) {
      for (B = B.replace(/[\x00-\x20]+/g, ""); ; ) {
        const ce = B.indexOf("<!--");
        if (ce === -1)
          break;
        const le = B.indexOf("-->", ce + 4);
        if (le === -1)
          break;
        B = B.substring(0, ce) + B.substring(le + 3);
      }
      const j = B.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
      if (!j)
        return B.match(/^[/\\]{2}/) ? !h.allowProtocolRelative : !1;
      const G = j[1].toLowerCase();
      return o(h.allowedSchemesByTag, I) ? h.allowedSchemesByTag[I].indexOf(G) === -1 : !h.allowedSchemes || h.allowedSchemes.indexOf(G) === -1;
    }
    function ne(I) {
      if (I = I.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), I.startsWith("relative:"))
        throw new Error("relative: exploit attempt");
      let B = "relative://relative-site";
      for (let ce = 0; ce < 100; ce++)
        B += `/${ce}`;
      const j = new URL(I, B);
      return {
        isRelativeUrl: j && j.hostname === "relative-site" && j.protocol === "relative:",
        url: j
      };
    }
    function se(I, B) {
      if (!B)
        return I;
      const j = I.nodes[0];
      let G;
      return B[j.selector] && B["*"] ? G = u(
        B[j.selector],
        B["*"]
      ) : G = B[j.selector] || B["*"], G && (I.nodes[0].nodes = j.nodes.reduce(be(G), [])), I;
    }
    function de(I) {
      return I.nodes[0].nodes.reduce(function(B, j) {
        return B.push(
          `${j.prop}:${j.value}${j.important ? " !important" : ""}`
        ), B;
      }, []).join(";");
    }
    function be(I) {
      return function(B, j) {
        return o(I, j.prop) && I[j.prop].some(function(ce) {
          return ce.test(j.value);
        }) && B.push(j), B;
      };
    }
    function oe(I, B, j) {
      return B ? (I = I.split(/\s+/), I.filter(function(G) {
        return B.indexOf(G) !== -1 || j.some(function(ce) {
          return ce.test(G);
        });
      }).join(" ")) : I;
    }
  }
  const b = {
    decodeEntities: !0
  };
  return m.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
    allowProtocolRelative: !0,
    enforceHtmlBoundary: !1,
    parseStyleAttributes: !0,
    preserveEscapedAttributes: !1
  }, m.simpleTransform = function(g, h, v) {
    return v = v === void 0 ? !0 : v, h = h || {}, function(x, _) {
      let y;
      if (v)
        for (y in h)
          _[y] = h[y];
      else
        _ = h;
      return {
        tagName: g,
        attribs: _
      };
    };
  }, Lr;
}
var Sa = /* @__PURE__ */ _a();
const In = /* @__PURE__ */ je(Sa);
function Nn(e) {
  Object.defineProperty(e, "__esModule", { value: !0, configurable: !0 });
}
function Vr(e, t, r, u) {
  Object.defineProperty(e, t, { get: r, set: u, enumerable: !0, configurable: !0 });
}
var Pn = {};
Nn(Pn);
Vr(Pn, "default", () => qn);
class qn extends Error {
  constructor(t, r, u, i, c) {
    super(t + ":" + u + ":" + i + ": " + r), this.reason = r, this.filename = t, this.line = u, this.column = i, this.source = c;
  }
}
var Un = {};
Nn(Un);
Vr(Un, "default", () => Hn);
class Hn {
  constructor(t, r, u) {
    this.start = t, this.end = r, this.source = u;
  }
}
var Ma = {};
Vr(Ma, "CssTypes", () => K);
var K = /* @__PURE__ */ function(e) {
  return e.stylesheet = "stylesheet", e.rule = "rule", e.declaration = "declaration", e.comment = "comment", e.container = "container", e.charset = "charset", e.document = "document", e.customMedia = "custom-media", e.fontFace = "font-face", e.host = "host", e.import = "import", e.keyframes = "keyframes", e.keyframe = "keyframe", e.layer = "layer", e.media = "media", e.namespace = "namespace", e.page = "page", e.startingStyle = "starting-style", e.supports = "supports", e;
}({});
const Rn = 1e4, _n = (e, t, r) => {
  let u = r, i = Rn;
  do {
    const c = t.map((d) => e.indexOf(d, u));
    c.push(e.indexOf("\\", u));
    const a = c.filter((d) => d !== -1);
    if (a.length === 0) return -1;
    const l = Math.min(...a);
    if (e[l] === "\\")
      u = l + 2, i--;
    else return l;
  } while (i > 0);
  throw new Error("Too many escaping");
}, Gr = (e, t, r) => {
  let u = r, i = Rn;
  do {
    const c = t.map((o) => e.indexOf(o, u));
    c.push(e.indexOf("(", u)), c.push(e.indexOf('"', u)), c.push(e.indexOf("'", u)), c.push(e.indexOf("\\", u));
    const a = c.filter((o) => o !== -1);
    if (a.length === 0) return -1;
    const l = Math.min(...a);
    switch (e[l]) {
      case "\\":
        u = l + 2;
        break;
      case "(":
        {
          const o = Gr(e, [
            ")"
          ], l + 1);
          if (o === -1) return -1;
          u = o + 1;
        }
        break;
      case '"':
        {
          const o = _n(e, [
            '"'
          ], l + 1);
          if (o === -1) return -1;
          u = o + 1;
        }
        break;
      case "'":
        {
          const o = _n(e, [
            "'"
          ], l + 1);
          if (o === -1) return -1;
          u = o + 1;
        }
        break;
      default:
        return l;
    }
    i--;
  } while (i > 0);
  throw new Error("Too many escaping");
}, ka = (e, t) => {
  const r = [];
  let u = 0;
  for (; u < e.length; ) {
    const i = Gr(e, t, u);
    if (i === -1)
      return r.push(e.substring(u)), r;
    r.push(e.substring(u, i)), u = i + 1;
  }
  return r;
}, Cr = /\/\*[^]*?(?:\*\/|$)/g, Ta = (e, t) => {
  t = t || {};
  let r = 1, u = 1;
  function i(O) {
    const N = O.match(/\n/g);
    N && (r += N.length);
    const U = O.lastIndexOf(`
`);
    u = ~U ? O.length - U : u + O.length;
  }
  function c() {
    const O = {
      line: r,
      column: u
    };
    return function(N) {
      return N.position = new Hn(O, {
        line: r,
        column: u
      }, (t == null ? void 0 : t.source) || ""), s(), N;
    };
  }
  const a = [];
  function l(O) {
    const N = new qn((t == null ? void 0 : t.source) || "", O, r, u, e);
    if (t != null && t.silent) a.push(N);
    else throw N;
  }
  function d() {
    const O = p();
    return {
      type: K.stylesheet,
      stylesheet: {
        source: t == null ? void 0 : t.source,
        rules: O,
        parsingErrors: a
      }
    };
  }
  function o() {
    const O = /^{\s*/.exec(e);
    return O ? (n(O), !0) : !1;
  }
  function f() {
    const O = /^}/.exec(e);
    return O ? (n(O), !0) : !1;
  }
  function p() {
    let O;
    const N = [];
    for (s(), m(N); e.length && e.charAt(0) !== "}" && (O = F() || z()); ) O && (N.push(O), m(N));
    return N;
  }
  function n(O) {
    const N = O[0];
    return i(N), e = e.slice(N.length), O;
  }
  function s() {
    const O = /^\s*/.exec(e);
    O && n(O);
  }
  function m(O) {
    let N;
    for (O = O || []; N = b(); ) N && O.push(N);
    return O;
  }
  function b() {
    const O = c();
    if (e.charAt(0) !== "/" || e.charAt(1) !== "*") return;
    const N = /^\/\*[^]*?\*\//.exec(e);
    return N ? (n(N), O({
      type: K.comment,
      comment: N[0].slice(2, -2)
    })) : l("End of comment missing");
  }
  function g() {
    const O = /^([^{]+)/.exec(e);
    if (!O) return;
    n(O);
    const N = ke(O[0]).replace(Cr, "");
    return ka(N, [
      ","
    ]).map((U) => ke(U));
  }
  function h() {
    const O = c(), N = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/.exec(e);
    if (!N) return;
    n(N);
    const U = ke(N[0]), V = /^:\s*/.exec(e);
    if (!V) return l("property missing ':'");
    n(V);
    let W = "";
    const ne = Gr(e, [
      ";",
      "}"
    ]);
    ne !== -1 && (W = e.substring(0, ne), n([
      W
    ]), W = ke(W).replace(Cr, ""));
    const se = O({
      type: K.declaration,
      property: U.replace(Cr, ""),
      value: W
    }), de = /^[;\s]*/.exec(e);
    return de && n(de), se;
  }
  function v() {
    const O = [];
    if (!o()) return l("missing '{'");
    m(O);
    let N;
    for (; N = h(); ) N && (O.push(N), m(O));
    return f() ? O : l("missing '}'");
  }
  function x() {
    let O;
    const N = [], U = c();
    for (; O = /^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/.exec(e); ) {
      const V = n(O);
      N.push(V[1]);
      const W = /^,\s*/.exec(e);
      W && n(W);
    }
    if (N.length)
      return U({
        type: K.keyframe,
        values: N,
        declarations: v() || []
      });
  }
  function _() {
    const O = c(), N = /^@([-\w]+)?keyframes\s*/.exec(e);
    if (!N) return;
    const U = n(N)[1], V = /^([-\w]+)\s*/.exec(e);
    if (!V) return l("@keyframes missing name");
    const W = n(V)[1];
    if (!o()) return l("@keyframes missing '{'");
    let ne, se = m();
    for (; ne = x(); )
      se.push(ne), se = se.concat(m());
    return f() ? O({
      type: K.keyframes,
      name: W,
      vendor: U,
      keyframes: se
    }) : l("@keyframes missing '}'");
  }
  function y() {
    const O = c(), N = /^@supports *([^{]+)/.exec(e);
    if (!N) return;
    const U = ke(n(N)[1]);
    if (!o()) return l("@supports missing '{'");
    const V = m().concat(p());
    return f() ? O({
      type: K.supports,
      supports: U,
      rules: V
    }) : l("@supports missing '}'");
  }
  function w() {
    const O = c(), N = /^@host\s*/.exec(e);
    if (!N) return;
    if (n(N), !o()) return l("@host missing '{'");
    const U = m().concat(p());
    return f() ? O({
      type: K.host,
      rules: U
    }) : l("@host missing '}'");
  }
  function S() {
    const O = c(), N = /^@container *([^{]+)/.exec(e);
    if (!N) return;
    const U = ke(n(N)[1]);
    if (!o()) return l("@container missing '{'");
    const V = m().concat(p());
    return f() ? O({
      type: K.container,
      container: U,
      rules: V
    }) : l("@container missing '}'");
  }
  function k() {
    const O = c(), N = /^@layer *([^{;@]+)/.exec(e);
    if (!N) return;
    const U = ke(n(N)[1]);
    if (!o()) {
      const W = /^[;\s]*/.exec(e);
      return W && n(W), O({
        type: K.layer,
        layer: U
      });
    }
    const V = m().concat(p());
    return f() ? O({
      type: K.layer,
      layer: U,
      rules: V
    }) : l("@layer missing '}'");
  }
  function $() {
    const O = c(), N = /^@media *([^{]+)/.exec(e);
    if (!N) return;
    const U = ke(n(N)[1]);
    if (!o()) return l("@media missing '{'");
    const V = m().concat(p());
    return f() ? O({
      type: K.media,
      media: U,
      rules: V
    }) : l("@media missing '}'");
  }
  function D() {
    const O = c(), N = /^@custom-media\s+(--\S+)\s+([^{;\s][^{;]*);/.exec(e);
    if (!N) return;
    const U = n(N);
    return O({
      type: K.customMedia,
      name: ke(U[1]),
      media: ke(U[2])
    });
  }
  function T() {
    const O = c(), N = /^@page */.exec(e);
    if (!N) return;
    n(N);
    const U = g() || [];
    if (!o()) return l("@page missing '{'");
    let V = m(), W;
    for (; W = h(); )
      V.push(W), V = V.concat(m());
    return f() ? O({
      type: K.page,
      selectors: U,
      declarations: V
    }) : l("@page missing '}'");
  }
  function A() {
    const O = c(), N = /^@([-\w]+)?document *([^{]+)/.exec(e);
    if (!N) return;
    const U = n(N), V = ke(U[1]), W = ke(U[2]);
    if (!o()) return l("@document missing '{'");
    const ne = m().concat(p());
    return f() ? O({
      type: K.document,
      document: W,
      vendor: V,
      rules: ne
    }) : l("@document missing '}'");
  }
  function P() {
    const O = c(), N = /^@font-face\s*/.exec(e);
    if (!N) return;
    if (n(N), !o()) return l("@font-face missing '{'");
    let U = m(), V;
    for (; V = h(); )
      U.push(V), U = U.concat(m());
    return f() ? O({
      type: K.fontFace,
      declarations: U
    }) : l("@font-face missing '}'");
  }
  function L() {
    const O = c(), N = /^@starting-style\s*/.exec(e);
    if (!N) return;
    if (n(N), !o()) return l("@starting-style missing '{'");
    const U = m().concat(p());
    return f() ? O({
      type: K.startingStyle,
      rules: U
    }) : l("@starting-style missing '}'");
  }
  const E = q("import"), C = q("charset"), R = q("namespace");
  function q(O) {
    const N = new RegExp("^@" + O + `\\s*((?::?[^;'"]|"(?:\\\\"|[^"])*?"|'(?:\\\\'|[^'])*?')+)(?:;|$)`);
    return function() {
      const U = c(), V = N.exec(e);
      if (!V) return;
      const W = n(V), ne = {
        type: O
      };
      return ne[O] = W[1].trim(), U(ne);
    };
  }
  function F() {
    if (e[0] === "@")
      return _() || $() || D() || y() || E() || C() || R() || A() || T() || w() || P() || S() || L() || k();
  }
  function z() {
    const O = c(), N = g();
    return N ? (m(), O({
      type: K.rule,
      selectors: N,
      declarations: v() || []
    })) : l("selector missing");
  }
  return Nr(d());
};
function ke(e) {
  return e ? e.trim() : "";
}
function Nr(e, t) {
  const r = e && typeof e.type == "string", u = r ? e : t;
  for (const i in e) {
    const c = e[i];
    Array.isArray(c) ? c.forEach((a) => {
      Nr(a, u);
    }) : c && typeof c == "object" && Nr(c, u);
  }
  return r && Object.defineProperty(e, "parent", {
    configurable: !0,
    writable: !0,
    enumerable: !1,
    value: t || null
  }), e;
}
var Ea = Ta;
class Aa {
  constructor(t) {
    this.level = 0, this.indentation = "  ", this.compress = !1, typeof (t == null ? void 0 : t.indent) == "string" && (this.indentation = t == null ? void 0 : t.indent), t != null && t.compress && (this.compress = !0);
  }
  // We disable no-unused-vars for _position. We keep position for potential reintroduction of source-map
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  emit(t, r) {
    return t;
  }
  /**
  * Increase, decrease or return current indentation.
  */
  indent(t) {
    return this.level = this.level || 1, t ? (this.level += t, "") : Array(this.level).join(this.indentation);
  }
  visit(t) {
    switch (t.type) {
      case K.stylesheet:
        return this.stylesheet(t);
      case K.rule:
        return this.rule(t);
      case K.declaration:
        return this.declaration(t);
      case K.comment:
        return this.comment(t);
      case K.container:
        return this.container(t);
      case K.charset:
        return this.charset(t);
      case K.document:
        return this.document(t);
      case K.customMedia:
        return this.customMedia(t);
      case K.fontFace:
        return this.fontFace(t);
      case K.host:
        return this.host(t);
      case K.import:
        return this.import(t);
      case K.keyframes:
        return this.keyframes(t);
      case K.keyframe:
        return this.keyframe(t);
      case K.layer:
        return this.layer(t);
      case K.media:
        return this.media(t);
      case K.namespace:
        return this.namespace(t);
      case K.page:
        return this.page(t);
      case K.startingStyle:
        return this.startingStyle(t);
      case K.supports:
        return this.supports(t);
    }
  }
  mapVisit(t, r) {
    let u = "";
    r = r || "";
    for (let i = 0, c = t.length; i < c; i++)
      u += this.visit(t[i]), r && i < c - 1 && (u += this.emit(r));
    return u;
  }
  compile(t) {
    return this.compress ? t.stylesheet.rules.map(this.visit, this).join("") : this.stylesheet(t);
  }
  /**
  * Visit stylesheet node.
  */
  stylesheet(t) {
    return this.mapVisit(t.stylesheet.rules, `

`);
  }
  /**
  * Visit comment node.
  */
  comment(t) {
    return this.compress ? this.emit("", t.position) : this.emit(this.indent() + "/*" + t.comment + "*/", t.position);
  }
  /**
  * Visit container node.
  */
  container(t) {
    return this.compress ? this.emit("@container " + t.container, t.position) + this.emit("{") + this.mapVisit(t.rules) + this.emit("}") : this.emit(this.indent() + "@container " + t.container, t.position) + this.emit(` {
` + this.indent(1)) + this.mapVisit(t.rules, `

`) + this.emit(`
` + this.indent(-1) + this.indent() + "}");
  }
  /**
  * Visit container node.
  */
  layer(t) {
    return this.compress ? this.emit("@layer " + t.layer, t.position) + (t.rules ? this.emit("{") + this.mapVisit(t.rules) + this.emit("}") : ";") : this.emit(this.indent() + "@layer " + t.layer, t.position) + (t.rules ? this.emit(` {
` + this.indent(1)) + this.mapVisit(t.rules, `

`) + this.emit(`
` + this.indent(-1) + this.indent() + "}") : ";");
  }
  /**
  * Visit import node.
  */
  import(t) {
    return this.emit("@import " + t.import + ";", t.position);
  }
  /**
  * Visit media node.
  */
  media(t) {
    return this.compress ? this.emit("@media " + t.media, t.position) + this.emit("{") + this.mapVisit(t.rules) + this.emit("}") : this.emit(this.indent() + "@media " + t.media, t.position) + this.emit(` {
` + this.indent(1)) + this.mapVisit(t.rules, `

`) + this.emit(`
` + this.indent(-1) + this.indent() + "}");
  }
  /**
  * Visit document node.
  */
  document(t) {
    const r = "@" + (t.vendor || "") + "document " + t.document;
    return this.compress ? this.emit(r, t.position) + this.emit("{") + this.mapVisit(t.rules) + this.emit("}") : this.emit(r, t.position) + this.emit(`  {
` + this.indent(1)) + this.mapVisit(t.rules, `

`) + this.emit(this.indent(-1) + `
}`);
  }
  /**
  * Visit charset node.
  */
  charset(t) {
    return this.emit("@charset " + t.charset + ";", t.position);
  }
  /**
  * Visit namespace node.
  */
  namespace(t) {
    return this.emit("@namespace " + t.namespace + ";", t.position);
  }
  /**
  * Visit container node.
  */
  startingStyle(t) {
    return this.compress ? this.emit("@starting-style", t.position) + this.emit("{") + this.mapVisit(t.rules) + this.emit("}") : this.emit(this.indent() + "@starting-style", t.position) + this.emit(` {
` + this.indent(1)) + this.mapVisit(t.rules, `

`) + this.emit(`
` + this.indent(-1) + this.indent() + "}");
  }
  /**
  * Visit supports node.
  */
  supports(t) {
    return this.compress ? this.emit("@supports " + t.supports, t.position) + this.emit("{") + this.mapVisit(t.rules) + this.emit("}") : this.emit(this.indent() + "@supports " + t.supports, t.position) + this.emit(` {
` + this.indent(1)) + this.mapVisit(t.rules, `

`) + this.emit(`
` + this.indent(-1) + this.indent() + "}");
  }
  /**
  * Visit keyframes node.
  */
  keyframes(t) {
    return this.compress ? this.emit("@" + (t.vendor || "") + "keyframes " + t.name, t.position) + this.emit("{") + this.mapVisit(t.keyframes) + this.emit("}") : this.emit("@" + (t.vendor || "") + "keyframes " + t.name, t.position) + this.emit(` {
` + this.indent(1)) + this.mapVisit(t.keyframes, `
`) + this.emit(this.indent(-1) + "}");
  }
  /**
  * Visit keyframe node.
  */
  keyframe(t) {
    const r = t.declarations;
    return this.compress ? this.emit(t.values.join(","), t.position) + this.emit("{") + this.mapVisit(r) + this.emit("}") : this.emit(this.indent()) + this.emit(t.values.join(", "), t.position) + this.emit(` {
` + this.indent(1)) + this.mapVisit(r, `
`) + this.emit(this.indent(-1) + `
` + this.indent() + `}
`);
  }
  /**
  * Visit page node.
  */
  page(t) {
    if (this.compress) {
      const u = t.selectors.length ? t.selectors.join(", ") : "";
      return this.emit("@page " + u, t.position) + this.emit("{") + this.mapVisit(t.declarations) + this.emit("}");
    }
    const r = t.selectors.length ? t.selectors.join(", ") + " " : "";
    return this.emit("@page " + r, t.position) + this.emit(`{
`) + this.emit(this.indent(1)) + this.mapVisit(t.declarations, `
`) + this.emit(this.indent(-1)) + this.emit(`
}`);
  }
  /**
  * Visit font-face node.
  */
  fontFace(t) {
    return this.compress ? this.emit("@font-face", t.position) + this.emit("{") + this.mapVisit(t.declarations) + this.emit("}") : this.emit("@font-face ", t.position) + this.emit(`{
`) + this.emit(this.indent(1)) + this.mapVisit(t.declarations, `
`) + this.emit(this.indent(-1)) + this.emit(`
}`);
  }
  /**
  * Visit host node.
  */
  host(t) {
    return this.compress ? this.emit("@host", t.position) + this.emit("{") + this.mapVisit(t.rules) + this.emit("}") : this.emit("@host", t.position) + this.emit(` {
` + this.indent(1)) + this.mapVisit(t.rules, `

`) + this.emit(this.indent(-1) + `
}`);
  }
  /**
  * Visit custom-media node.
  */
  customMedia(t) {
    return this.emit("@custom-media " + t.name + " " + t.media + ";", t.position);
  }
  /**
  * Visit rule node.
  */
  rule(t) {
    const r = t.declarations;
    if (!r.length) return "";
    if (this.compress) return this.emit(t.selectors.join(","), t.position) + this.emit("{") + this.mapVisit(r) + this.emit("}");
    const u = this.indent();
    return this.emit(t.selectors.map((i) => u + i).join(`,
`), t.position) + this.emit(` {
`) + this.emit(this.indent(1)) + this.mapVisit(r, `
`) + this.emit(this.indent(-1)) + this.emit(`
` + this.indent() + "}");
  }
  /**
  * Visit declaration node.
  */
  declaration(t) {
    return this.compress ? this.emit(t.property + ":" + t.value, t.position) + this.emit(";") : t.property === "grid-template-areas" ? this.emit(this.indent()) + this.emit(t.property + ": " + t.value.split(`
`).join(`
`.padEnd(22) + this.indent()), t.position) + this.emit(";") : this.emit(this.indent()) + this.emit(t.property + ": " + t.value, t.position) + this.emit(";");
  }
}
var $a = Aa, Da = (e, t) => new $a(t || {}).compile(e);
const Oa = Ea, La = Da;
var Ca = Object.defineProperty, jn = (e, t) => Ca(e, "name", { value: t, configurable: !0 });
Ke.extend(ii);
Ke.extend(ci);
Ke.extend(hi);
Ke.extend(gi);
Ke.extend(wi);
Ke.extend(ki);
Ke.extend($i);
Ke.extend(Ci);
Ke.extend((e, t) => {
  const r = t.prototype.format;
  t.prototype.format = function(u) {
    if (!this.isValid() || !u)
      return r.bind(this)(u);
    const i = u.replaceAll("custom-fullMonthNoYear", () => {
      var c, a;
      return `[${this.utc().toDate().toLocaleString((c = this.$locale) == null ? void 0 : c.call(this).name, {
        timeZone: (a = this.$x) == null ? void 0 : a.$timezone,
        weekday: "long",
        month: "short",
        day: "numeric"
      })}]`;
    });
    return r.bind(this)(i);
  };
});
const Ia = {
  ...In.defaults,
  allowedAttributes: {
    a: ["href", "target", "name", "style"],
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"],
    span: ["style"],
    strong: ["style"],
    em: ["style"],
    ul: ["style"]
  },
  parseStyleAttributes: !1
}, Le = /* @__PURE__ */ jn((e) => In(e ?? "", Ia), "sanitize"), Na = /* @__PURE__ */ jn((e, t) => {
  try {
    const r = Oa(e), u = r.stylesheet.rules.map((i) => {
      if (i.type === K.rule) {
        const c = i.selectors.map((a) => a === t ? a : `${t} ${a}`);
        return { ...i, selectors: c };
      }
      if (i.type === K.media) {
        const c = i.rules.map((a) => {
          if (a.type === K.rule) {
            const l = a.selectors.map((d) => d === t ? d : `${t} ${d}`);
            return { ...a, selectors: l };
          }
          return a;
        });
        return { ...i, rules: c };
      }
      return i;
    });
    return La({
      ...r,
      stylesheet: {
        ...r.stylesheet,
        rules: u
      }
    });
  } catch (r) {
    return console.warn("Error parsing custom css", r), "";
  }
}, "prefixCustomCss"), Re = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, Fn = /* @__PURE__ */ Object.create(null);
for (const e in Re)
  Object.hasOwn(Re, e) && (Fn[Re[e]] = e);
const ve = {
  to: {},
  get: {}
};
ve.get = function(e) {
  const t = e.slice(0, 3).toLowerCase();
  let r, u;
  switch (t) {
    case "hsl": {
      r = ve.get.hsl(e), u = "hsl";
      break;
    }
    case "hwb": {
      r = ve.get.hwb(e), u = "hwb";
      break;
    }
    default: {
      r = ve.get.rgb(e), u = "rgb";
      break;
    }
  }
  return r ? { model: u, value: r } : null;
};
ve.get.rgb = function(e) {
  if (!e)
    return null;
  const t = /^#([a-f\d]{3,4})$/i, r = /^#([a-f\d]{6})([a-f\d]{2})?$/i, u = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|/]\s*([+-]?[\d.]+)(%?)\s*)?\)$/, i = /^rgba?\(\s*([+-]?[\d.]+)%\s*,?\s*([+-]?[\d.]+)%\s*,?\s*([+-]?[\d.]+)%\s*(?:[,|/]\s*([+-]?[\d.]+)(%?)\s*)?\)$/, c = /^(\w+)$/;
  let a = [0, 0, 0, 1], l, d, o;
  if (l = e.match(r)) {
    for (o = l[2], l = l[1], d = 0; d < 3; d++) {
      const f = d * 2;
      a[d] = Number.parseInt(l.slice(f, f + 2), 16);
    }
    o && (a[3] = Number.parseInt(o, 16) / 255);
  } else if (l = e.match(t)) {
    for (l = l[1], o = l[3], d = 0; d < 3; d++)
      a[d] = Number.parseInt(l[d] + l[d], 16);
    o && (a[3] = Number.parseInt(o + o, 16) / 255);
  } else if (l = e.match(u)) {
    for (d = 0; d < 3; d++)
      a[d] = Number.parseInt(l[d + 1], 10);
    l[4] && (a[3] = l[5] ? Number.parseFloat(l[4]) * 0.01 : Number.parseFloat(l[4]));
  } else if (l = e.match(i)) {
    for (d = 0; d < 3; d++)
      a[d] = Math.round(Number.parseFloat(l[d + 1]) * 2.55);
    l[4] && (a[3] = l[5] ? Number.parseFloat(l[4]) * 0.01 : Number.parseFloat(l[4]));
  } else return (l = e.match(c)) ? l[1] === "transparent" ? [0, 0, 0, 0] : Object.hasOwn(Re, l[1]) ? (a = Re[l[1]], a[3] = 1, a) : null : null;
  for (d = 0; d < 3; d++)
    a[d] = et(a[d], 0, 255);
  return a[3] = et(a[3], 0, 1), a;
};
ve.get.hsl = function(e) {
  if (!e)
    return null;
  const t = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d.]+)%\s*,?\s*([+-]?[\d.]+)%\s*(?:[,|/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, r = e.match(t);
  if (r) {
    const u = Number.parseFloat(r[4]), i = (Number.parseFloat(r[1]) % 360 + 360) % 360, c = et(Number.parseFloat(r[2]), 0, 100), a = et(Number.parseFloat(r[3]), 0, 100), l = et(Number.isNaN(u) ? 1 : u, 0, 1);
    return [i, c, a, l];
  }
  return null;
};
ve.get.hwb = function(e) {
  if (!e)
    return null;
  const t = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d.]+)%\s*,\s*([+-]?[\d.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, r = e.match(t);
  if (r) {
    const u = Number.parseFloat(r[4]), i = (Number.parseFloat(r[1]) % 360 + 360) % 360, c = et(Number.parseFloat(r[2]), 0, 100), a = et(Number.parseFloat(r[3]), 0, 100), l = et(Number.isNaN(u) ? 1 : u, 0, 1);
    return [i, c, a, l];
  }
  return null;
};
ve.to.hex = function(...e) {
  return "#" + St(e[0]) + St(e[1]) + St(e[2]) + (e[3] < 1 ? St(Math.round(e[3] * 255)) : "");
};
ve.to.rgb = function(...e) {
  return e.length < 4 || e[3] === 1 ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
};
ve.to.rgb.percent = function(...e) {
  const t = Math.round(e[0] / 255 * 100), r = Math.round(e[1] / 255 * 100), u = Math.round(e[2] / 255 * 100);
  return e.length < 4 || e[3] === 1 ? "rgb(" + t + "%, " + r + "%, " + u + "%)" : "rgba(" + t + "%, " + r + "%, " + u + "%, " + e[3] + ")";
};
ve.to.hsl = function(...e) {
  return e.length < 4 || e[3] === 1 ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
};
ve.to.hwb = function(...e) {
  let t = "";
  return e.length >= 4 && e[3] !== 1 && (t = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + t + ")";
};
ve.to.keyword = function(...e) {
  return Fn[e.slice(0, 3)];
};
function et(e, t, r) {
  return Math.min(Math.max(t, e), r);
}
function St(e) {
  const t = Math.round(e).toString(16).toUpperCase();
  return t.length < 2 ? "0" + t : t;
}
const zn = {};
for (const e of Object.keys(Re))
  zn[Re[e]] = e;
const Y = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  oklab: { channels: 3, labels: ["okl", "oka", "okb"] },
  lch: { channels: 3, labels: "lch" },
  oklch: { channels: 3, labels: ["okl", "okc", "okh"] },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
}, Ze = (6 / 29) ** 3;
function ct(e) {
  const t = e > 31308e-7 ? 1.055 * e ** 0.4166666666666667 - 0.055 : e * 12.92;
  return Math.min(Math.max(0, t), 1);
}
function lt(e) {
  return e > 0.04045 ? ((e + 0.055) / 1.055) ** 2.4 : e / 12.92;
}
for (const e of Object.keys(Y)) {
  if (!("channels" in Y[e]))
    throw new Error("missing channels property: " + e);
  if (!("labels" in Y[e]))
    throw new Error("missing channel labels property: " + e);
  if (Y[e].labels.length !== Y[e].channels)
    throw new Error("channel and label counts mismatch: " + e);
  const { channels: t, labels: r } = Y[e];
  delete Y[e].channels, delete Y[e].labels, Object.defineProperty(Y[e], "channels", { value: t }), Object.defineProperty(Y[e], "labels", { value: r });
}
Y.rgb.hsl = function(e) {
  const t = e[0] / 255, r = e[1] / 255, u = e[2] / 255, i = Math.min(t, r, u), c = Math.max(t, r, u), a = c - i;
  let l, d;
  switch (c) {
    case i: {
      l = 0;
      break;
    }
    case t: {
      l = (r - u) / a;
      break;
    }
    case r: {
      l = 2 + (u - t) / a;
      break;
    }
    case u: {
      l = 4 + (t - r) / a;
      break;
    }
  }
  l = Math.min(l * 60, 360), l < 0 && (l += 360);
  const o = (i + c) / 2;
  return c === i ? d = 0 : o <= 0.5 ? d = a / (c + i) : d = a / (2 - c - i), [l, d * 100, o * 100];
};
Y.rgb.hsv = function(e) {
  let t, r, u, i, c;
  const a = e[0] / 255, l = e[1] / 255, d = e[2] / 255, o = Math.max(a, l, d), f = o - Math.min(a, l, d), p = function(n) {
    return (o - n) / 6 / f + 1 / 2;
  };
  if (f === 0)
    i = 0, c = 0;
  else {
    switch (c = f / o, t = p(a), r = p(l), u = p(d), o) {
      case a: {
        i = u - r;
        break;
      }
      case l: {
        i = 1 / 3 + t - u;
        break;
      }
      case d: {
        i = 2 / 3 + r - t;
        break;
      }
    }
    i < 0 ? i += 1 : i > 1 && (i -= 1);
  }
  return [
    i * 360,
    c * 100,
    o * 100
  ];
};
Y.rgb.hwb = function(e) {
  const t = e[0], r = e[1];
  let u = e[2];
  const i = Y.rgb.hsl(e)[0], c = 1 / 255 * Math.min(t, Math.min(r, u));
  return u = 1 - 1 / 255 * Math.max(t, Math.max(r, u)), [i, c * 100, u * 100];
};
Y.rgb.oklab = function(e) {
  const t = lt(e[0] / 255), r = lt(e[1] / 255), u = lt(e[2] / 255), i = Math.cbrt(0.4122214708 * t + 0.5363325363 * r + 0.0514459929 * u), c = Math.cbrt(0.2119034982 * t + 0.6806995451 * r + 0.1073969566 * u), a = Math.cbrt(0.0883024619 * t + 0.2817188376 * r + 0.6299787005 * u), l = 0.2104542553 * i + 0.793617785 * c - 0.0040720468 * a, d = 1.9779984951 * i - 2.428592205 * c + 0.4505937099 * a, o = 0.0259040371 * i + 0.7827717662 * c - 0.808675766 * a;
  return [l * 100, d * 100, o * 100];
};
Y.rgb.cmyk = function(e) {
  const t = e[0] / 255, r = e[1] / 255, u = e[2] / 255, i = Math.min(1 - t, 1 - r, 1 - u), c = (1 - t - i) / (1 - i) || 0, a = (1 - r - i) / (1 - i) || 0, l = (1 - u - i) / (1 - i) || 0;
  return [c * 100, a * 100, l * 100, i * 100];
};
function Pa(e, t) {
  return (e[0] - t[0]) ** 2 + (e[1] - t[1]) ** 2 + (e[2] - t[2]) ** 2;
}
Y.rgb.keyword = function(e) {
  const t = zn[e];
  if (t)
    return t;
  let r = Number.POSITIVE_INFINITY, u;
  for (const i of Object.keys(Re)) {
    const c = Re[i], a = Pa(e, c);
    a < r && (r = a, u = i);
  }
  return u;
};
Y.keyword.rgb = function(e) {
  return Re[e];
};
Y.rgb.xyz = function(e) {
  const t = lt(e[0] / 255), r = lt(e[1] / 255), u = lt(e[2] / 255), i = t * 0.4124564 + r * 0.3575761 + u * 0.1804375, c = t * 0.2126729 + r * 0.7151522 + u * 0.072175, a = t * 0.0193339 + r * 0.119192 + u * 0.9503041;
  return [i * 100, c * 100, a * 100];
};
Y.rgb.lab = function(e) {
  const t = Y.rgb.xyz(e);
  let r = t[0], u = t[1], i = t[2];
  r /= 95.047, u /= 100, i /= 108.883, r = r > Ze ? r ** (1 / 3) : 7.787 * r + 16 / 116, u = u > Ze ? u ** (1 / 3) : 7.787 * u + 16 / 116, i = i > Ze ? i ** (1 / 3) : 7.787 * i + 16 / 116;
  const c = 116 * u - 16, a = 500 * (r - u), l = 200 * (u - i);
  return [c, a, l];
};
Y.hsl.rgb = function(e) {
  const t = e[0] / 360, r = e[1] / 100, u = e[2] / 100;
  let i, c;
  if (r === 0)
    return c = u * 255, [c, c, c];
  const a = u < 0.5 ? u * (1 + r) : u + r - u * r, l = 2 * u - a, d = [0, 0, 0];
  for (let o = 0; o < 3; o++)
    i = t + 1 / 3 * -(o - 1), i < 0 && i++, i > 1 && i--, 6 * i < 1 ? c = l + (a - l) * 6 * i : 2 * i < 1 ? c = a : 3 * i < 2 ? c = l + (a - l) * (2 / 3 - i) * 6 : c = l, d[o] = c * 255;
  return d;
};
Y.hsl.hsv = function(e) {
  const t = e[0];
  let r = e[1] / 100, u = e[2] / 100, i = r;
  const c = Math.max(u, 0.01);
  u *= 2, r *= u <= 1 ? u : 2 - u, i *= c <= 1 ? c : 2 - c;
  const a = (u + r) / 2, l = u === 0 ? 2 * i / (c + i) : 2 * r / (u + r);
  return [t, l * 100, a * 100];
};
Y.hsv.rgb = function(e) {
  const t = e[0] / 60, r = e[1] / 100;
  let u = e[2] / 100;
  const i = Math.floor(t) % 6, c = t - Math.floor(t), a = 255 * u * (1 - r), l = 255 * u * (1 - r * c), d = 255 * u * (1 - r * (1 - c));
  switch (u *= 255, i) {
    case 0:
      return [u, d, a];
    case 1:
      return [l, u, a];
    case 2:
      return [a, u, d];
    case 3:
      return [a, l, u];
    case 4:
      return [d, a, u];
    case 5:
      return [u, a, l];
  }
};
Y.hsv.hsl = function(e) {
  const t = e[0], r = e[1] / 100, u = e[2] / 100, i = Math.max(u, 0.01);
  let c, a;
  a = (2 - r) * u;
  const l = (2 - r) * i;
  return c = r * i, c /= l <= 1 ? l : 2 - l, c = c || 0, a /= 2, [t, c * 100, a * 100];
};
Y.hwb.rgb = function(e) {
  const t = e[0] / 360;
  let r = e[1] / 100, u = e[2] / 100;
  const i = r + u;
  let c;
  i > 1 && (r /= i, u /= i);
  const a = Math.floor(6 * t), l = 1 - u;
  c = 6 * t - a, (a & 1) !== 0 && (c = 1 - c);
  const d = r + c * (l - r);
  let o, f, p;
  switch (a) {
    default:
    case 6:
    case 0: {
      o = l, f = d, p = r;
      break;
    }
    case 1: {
      o = d, f = l, p = r;
      break;
    }
    case 2: {
      o = r, f = l, p = d;
      break;
    }
    case 3: {
      o = r, f = d, p = l;
      break;
    }
    case 4: {
      o = d, f = r, p = l;
      break;
    }
    case 5: {
      o = l, f = r, p = d;
      break;
    }
  }
  return [o * 255, f * 255, p * 255];
};
Y.cmyk.rgb = function(e) {
  const t = e[0] / 100, r = e[1] / 100, u = e[2] / 100, i = e[3] / 100, c = 1 - Math.min(1, t * (1 - i) + i), a = 1 - Math.min(1, r * (1 - i) + i), l = 1 - Math.min(1, u * (1 - i) + i);
  return [c * 255, a * 255, l * 255];
};
Y.xyz.rgb = function(e) {
  const t = e[0] / 100, r = e[1] / 100, u = e[2] / 100;
  let i, c, a;
  return i = t * 3.2404542 + r * -1.5371385 + u * -0.4985314, c = t * -0.969266 + r * 1.8760108 + u * 0.041556, a = t * 0.0556434 + r * -0.2040259 + u * 1.0572252, i = ct(i), c = ct(c), a = ct(a), [i * 255, c * 255, a * 255];
};
Y.xyz.lab = function(e) {
  let t = e[0], r = e[1], u = e[2];
  t /= 95.047, r /= 100, u /= 108.883, t = t > Ze ? t ** (1 / 3) : 7.787 * t + 16 / 116, r = r > Ze ? r ** (1 / 3) : 7.787 * r + 16 / 116, u = u > Ze ? u ** (1 / 3) : 7.787 * u + 16 / 116;
  const i = 116 * r - 16, c = 500 * (t - r), a = 200 * (r - u);
  return [i, c, a];
};
Y.xyz.oklab = function(e) {
  const t = e[0] / 100, r = e[1] / 100, u = e[2] / 100, i = Math.cbrt(0.8189330101 * t + 0.3618667424 * r - 0.1288597137 * u), c = Math.cbrt(0.0329845436 * t + 0.9293118715 * r + 0.0361456387 * u), a = Math.cbrt(0.0482003018 * t + 0.2643662691 * r + 0.633851707 * u), l = 0.2104542553 * i + 0.793617785 * c - 0.0040720468 * a, d = 1.9779984951 * i - 2.428592205 * c + 0.4505937099 * a, o = 0.0259040371 * i + 0.7827717662 * c - 0.808675766 * a;
  return [l * 100, d * 100, o * 100];
};
Y.oklab.oklch = function(e) {
  return Y.lab.lch(e);
};
Y.oklab.xyz = function(e) {
  const t = e[0] / 100, r = e[1] / 100, u = e[2] / 100, i = (0.999999998 * t + 0.396337792 * r + 0.215803758 * u) ** 3, c = (1.000000008 * t - 0.105561342 * r - 0.063854175 * u) ** 3, a = (1.000000055 * t - 0.089484182 * r - 1.291485538 * u) ** 3, l = 1.227013851 * i - 0.55779998 * c + 0.281256149 * a, d = -0.040580178 * i + 1.11225687 * c - 0.071676679 * a, o = -0.076381285 * i - 0.421481978 * c + 1.58616322 * a;
  return [l * 100, d * 100, o * 100];
};
Y.oklab.rgb = function(e) {
  const t = e[0] / 100, r = e[1] / 100, u = e[2] / 100, i = (t + 0.3963377774 * r + 0.2158037573 * u) ** 3, c = (t - 0.1055613458 * r - 0.0638541728 * u) ** 3, a = (t - 0.0894841775 * r - 1.291485548 * u) ** 3, l = ct(4.0767416621 * i - 3.3077115913 * c + 0.2309699292 * a), d = ct(-1.2684380046 * i + 2.6097574011 * c - 0.3413193965 * a), o = ct(-0.0041960863 * i - 0.7034186147 * c + 1.707614701 * a);
  return [l * 255, d * 255, o * 255];
};
Y.oklch.oklab = function(e) {
  return Y.lch.lab(e);
};
Y.lab.xyz = function(e) {
  const t = e[0], r = e[1], u = e[2];
  let i, c, a;
  c = (t + 16) / 116, i = r / 500 + c, a = c - u / 200;
  const l = c ** 3, d = i ** 3, o = a ** 3;
  return c = l > Ze ? l : (c - 16 / 116) / 7.787, i = d > Ze ? d : (i - 16 / 116) / 7.787, a = o > Ze ? o : (a - 16 / 116) / 7.787, i *= 95.047, c *= 100, a *= 108.883, [i, c, a];
};
Y.lab.lch = function(e) {
  const t = e[0], r = e[1], u = e[2];
  let i;
  i = Math.atan2(u, r) * 360 / 2 / Math.PI, i < 0 && (i += 360);
  const a = Math.sqrt(r * r + u * u);
  return [t, a, i];
};
Y.lch.lab = function(e) {
  const t = e[0], r = e[1], i = e[2] / 360 * 2 * Math.PI, c = r * Math.cos(i), a = r * Math.sin(i);
  return [t, c, a];
};
Y.rgb.ansi16 = function(e, t = null) {
  const [r, u, i] = e;
  let c = t === null ? Y.rgb.hsv(e)[2] : t;
  if (c = Math.round(c / 50), c === 0)
    return 30;
  let a = 30 + (Math.round(i / 255) << 2 | Math.round(u / 255) << 1 | Math.round(r / 255));
  return c === 2 && (a += 60), a;
};
Y.hsv.ansi16 = function(e) {
  return Y.rgb.ansi16(Y.hsv.rgb(e), e[2]);
};
Y.rgb.ansi256 = function(e) {
  const t = e[0], r = e[1], u = e[2];
  return t >> 4 === r >> 4 && r >> 4 === u >> 4 ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(r / 255 * 5) + Math.round(u / 255 * 5);
};
Y.ansi16.rgb = function(e) {
  e = e[0];
  let t = e % 10;
  if (t === 0 || t === 7)
    return e > 50 && (t += 3.5), t = t / 10.5 * 255, [t, t, t];
  const r = (Math.trunc(e > 50) + 1) * 0.5, u = (t & 1) * r * 255, i = (t >> 1 & 1) * r * 255, c = (t >> 2 & 1) * r * 255;
  return [u, i, c];
};
Y.ansi256.rgb = function(e) {
  if (e = e[0], e >= 232) {
    const c = (e - 232) * 10 + 8;
    return [c, c, c];
  }
  e -= 16;
  let t;
  const r = Math.floor(e / 36) / 5 * 255, u = Math.floor((t = e % 36) / 6) / 5 * 255, i = t % 6 / 5 * 255;
  return [r, u, i];
};
Y.rgb.hex = function(e) {
  const r = (((Math.round(e[0]) & 255) << 16) + ((Math.round(e[1]) & 255) << 8) + (Math.round(e[2]) & 255)).toString(16).toUpperCase();
  return "000000".slice(r.length) + r;
};
Y.hex.rgb = function(e) {
  const t = e.toString(16).match(/[a-f\d]{6}|[a-f\d]{3}/i);
  if (!t)
    return [0, 0, 0];
  let r = t[0];
  t[0].length === 3 && (r = [...r].map((l) => l + l).join(""));
  const u = Number.parseInt(r, 16), i = u >> 16 & 255, c = u >> 8 & 255, a = u & 255;
  return [i, c, a];
};
Y.rgb.hcg = function(e) {
  const t = e[0] / 255, r = e[1] / 255, u = e[2] / 255, i = Math.max(Math.max(t, r), u), c = Math.min(Math.min(t, r), u), a = i - c;
  let l;
  const d = a < 1 ? c / (1 - a) : 0;
  return a <= 0 ? l = 0 : i === t ? l = (r - u) / a % 6 : i === r ? l = 2 + (u - t) / a : l = 4 + (t - r) / a, l /= 6, l %= 1, [l * 360, a * 100, d * 100];
};
Y.hsl.hcg = function(e) {
  const t = e[1] / 100, r = e[2] / 100, u = r < 0.5 ? 2 * t * r : 2 * t * (1 - r);
  let i = 0;
  return u < 1 && (i = (r - 0.5 * u) / (1 - u)), [e[0], u * 100, i * 100];
};
Y.hsv.hcg = function(e) {
  const t = e[1] / 100, r = e[2] / 100, u = t * r;
  let i = 0;
  return u < 1 && (i = (r - u) / (1 - u)), [e[0], u * 100, i * 100];
};
Y.hcg.rgb = function(e) {
  const t = e[0] / 360, r = e[1] / 100, u = e[2] / 100;
  if (r === 0)
    return [u * 255, u * 255, u * 255];
  const i = [0, 0, 0], c = t % 1 * 6, a = c % 1, l = 1 - a;
  let d = 0;
  switch (Math.floor(c)) {
    case 0: {
      i[0] = 1, i[1] = a, i[2] = 0;
      break;
    }
    case 1: {
      i[0] = l, i[1] = 1, i[2] = 0;
      break;
    }
    case 2: {
      i[0] = 0, i[1] = 1, i[2] = a;
      break;
    }
    case 3: {
      i[0] = 0, i[1] = l, i[2] = 1;
      break;
    }
    case 4: {
      i[0] = a, i[1] = 0, i[2] = 1;
      break;
    }
    default:
      i[0] = 1, i[1] = 0, i[2] = l;
  }
  return d = (1 - r) * u, [
    (r * i[0] + d) * 255,
    (r * i[1] + d) * 255,
    (r * i[2] + d) * 255
  ];
};
Y.hcg.hsv = function(e) {
  const t = e[1] / 100, r = e[2] / 100, u = t + r * (1 - t);
  let i = 0;
  return u > 0 && (i = t / u), [e[0], i * 100, u * 100];
};
Y.hcg.hsl = function(e) {
  const t = e[1] / 100, u = e[2] / 100 * (1 - t) + 0.5 * t;
  let i = 0;
  return u > 0 && u < 0.5 ? i = t / (2 * u) : u >= 0.5 && u < 1 && (i = t / (2 * (1 - u))), [e[0], i * 100, u * 100];
};
Y.hcg.hwb = function(e) {
  const t = e[1] / 100, r = e[2] / 100, u = t + r * (1 - t);
  return [e[0], (u - t) * 100, (1 - u) * 100];
};
Y.hwb.hcg = function(e) {
  const t = e[1] / 100, u = 1 - e[2] / 100, i = u - t;
  let c = 0;
  return i < 1 && (c = (u - i) / (1 - i)), [e[0], i * 100, c * 100];
};
Y.apple.rgb = function(e) {
  return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
};
Y.rgb.apple = function(e) {
  return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
};
Y.gray.rgb = function(e) {
  return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
};
Y.gray.hsl = function(e) {
  return [0, 0, e[0]];
};
Y.gray.hsv = Y.gray.hsl;
Y.gray.hwb = function(e) {
  return [0, 100, e[0]];
};
Y.gray.cmyk = function(e) {
  return [0, 0, 0, e[0]];
};
Y.gray.lab = function(e) {
  return [e[0], 0, 0];
};
Y.gray.hex = function(e) {
  const t = Math.round(e[0] / 100 * 255) & 255, u = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
  return "000000".slice(u.length) + u;
};
Y.rgb.gray = function(e) {
  return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
};
function qa() {
  const e = {}, t = Object.keys(Y);
  for (let { length: r } = t, u = 0; u < r; u++)
    e[t[u]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  return e;
}
function Ua(e) {
  const t = qa(), r = [e];
  for (t[e].distance = 0; r.length > 0; ) {
    const u = r.pop(), i = Object.keys(Y[u]);
    for (let { length: c } = i, a = 0; a < c; a++) {
      const l = i[a], d = t[l];
      d.distance === -1 && (d.distance = t[u].distance + 1, d.parent = u, r.unshift(l));
    }
  }
  return t;
}
function Ha(e, t) {
  return function(r) {
    return t(e(r));
  };
}
function Ra(e, t) {
  const r = [t[e].parent, e];
  let u = Y[t[e].parent][e], i = t[e].parent;
  for (; t[i].parent; )
    r.unshift(t[i].parent), u = Ha(Y[t[i].parent][i], u), i = t[i].parent;
  return u.conversion = r, u;
}
function ja(e) {
  const t = Ua(e), r = {}, u = Object.keys(t);
  for (let { length: i } = u, c = 0; c < i; c++) {
    const a = u[c];
    t[a].parent !== null && (r[a] = Ra(a, t));
  }
  return r;
}
const xe = {}, Fa = Object.keys(Y);
function za(e) {
  const t = function(...r) {
    const u = r[0];
    return u == null ? u : (u.length > 1 && (r = u), e(r));
  };
  return "conversion" in e && (t.conversion = e.conversion), t;
}
function Ba(e) {
  const t = function(...r) {
    const u = r[0];
    if (u == null)
      return u;
    u.length > 1 && (r = u);
    const i = e(r);
    if (typeof i == "object")
      for (let { length: c } = i, a = 0; a < c; a++)
        i[a] = Math.round(i[a]);
    return i;
  };
  return "conversion" in e && (t.conversion = e.conversion), t;
}
for (const e of Fa) {
  xe[e] = {}, Object.defineProperty(xe[e], "channels", { value: Y[e].channels }), Object.defineProperty(xe[e], "labels", { value: Y[e].labels });
  const t = ja(e), r = Object.keys(t);
  for (const u of r) {
    const i = t[u];
    xe[e][u] = Ba(i), xe[e][u].raw = za(i);
  }
}
const Bn = [
  // To be honest, I don't really feel like keyword belongs in color convert, but eh.
  "keyword",
  // Gray conflicts with some method names, and has its own method defined.
  "gray",
  // Shouldn't really be in color-convert either...
  "hex"
], Pr = {};
for (const e of Object.keys(xe))
  Pr[[...xe[e].labels].sort().join("")] = e;
const ht = {};
function te(e, t) {
  if (!(this instanceof te))
    return new te(e, t);
  if (t && t in Bn && (t = null), t && !(t in xe))
    throw new Error("Unknown model: " + t);
  let r, u;
  if (e == null)
    this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (e instanceof te)
    this.model = e.model, this.color = [...e.color], this.valpha = e.valpha;
  else if (typeof e == "string") {
    const i = ve.get(e);
    if (i === null)
      throw new Error("Unable to parse color from string: " + e);
    this.model = i.model, u = xe[this.model].channels, this.color = i.value.slice(0, u), this.valpha = typeof i.value[u] == "number" ? i.value[u] : 1;
  } else if (e.length > 0) {
    this.model = t || "rgb", u = xe[this.model].channels;
    const i = Array.prototype.slice.call(e, 0, u);
    this.color = qr(i, u), this.valpha = typeof e[u] == "number" ? e[u] : 1;
  } else if (typeof e == "number")
    this.model = "rgb", this.color = [
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
    ], this.valpha = 1;
  else {
    this.valpha = 1;
    const i = Object.keys(e);
    "alpha" in e && (i.splice(i.indexOf("alpha"), 1), this.valpha = typeof e.alpha == "number" ? e.alpha : 0);
    const c = i.sort().join("");
    if (!(c in Pr))
      throw new Error("Unable to parse color from object: " + JSON.stringify(e));
    this.model = Pr[c];
    const { labels: a } = xe[this.model], l = [];
    for (r = 0; r < a.length; r++)
      l.push(e[a[r]]);
    this.color = qr(l);
  }
  if (ht[this.model])
    for (u = xe[this.model].channels, r = 0; r < u; r++) {
      const i = ht[this.model][r];
      i && (this.color[r] = i(this.color[r]));
    }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
te.prototype = {
  toString() {
    return this.string();
  },
  toJSON() {
    return this[this.model]();
  },
  string(e) {
    let t = this.model in ve.to ? this : this.rgb();
    t = t.round(typeof e == "number" ? e : 1);
    const r = t.valpha === 1 ? t.color : [...t.color, this.valpha];
    return ve.to[t.model](...r);
  },
  percentString(e) {
    const t = this.rgb().round(typeof e == "number" ? e : 1), r = t.valpha === 1 ? t.color : [...t.color, this.valpha];
    return ve.to.rgb.percent(...r);
  },
  array() {
    return this.valpha === 1 ? [...this.color] : [...this.color, this.valpha];
  },
  object() {
    const e = {}, { channels: t } = xe[this.model], { labels: r } = xe[this.model];
    for (let u = 0; u < t; u++)
      e[r[u]] = this.color[u];
    return this.valpha !== 1 && (e.alpha = this.valpha), e;
  },
  unitArray() {
    const e = this.rgb().color;
    return e[0] /= 255, e[1] /= 255, e[2] /= 255, this.valpha !== 1 && e.push(this.valpha), e;
  },
  unitObject() {
    const e = this.rgb().object();
    return e.r /= 255, e.g /= 255, e.b /= 255, this.valpha !== 1 && (e.alpha = this.valpha), e;
  },
  round(e) {
    return e = Math.max(e || 0, 0), new te([...this.color.map(Va(e)), this.valpha], this.model);
  },
  alpha(e) {
    return e !== void 0 ? new te([...this.color, Math.max(0, Math.min(1, e))], this.model) : this.valpha;
  },
  // Rgb
  red: pe("rgb", 0, ye(255)),
  green: pe("rgb", 1, ye(255)),
  blue: pe("rgb", 2, ye(255)),
  hue: pe(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, (e) => (e % 360 + 360) % 360),
  saturationl: pe("hsl", 1, ye(100)),
  lightness: pe("hsl", 2, ye(100)),
  saturationv: pe("hsv", 1, ye(100)),
  value: pe("hsv", 2, ye(100)),
  chroma: pe("hcg", 1, ye(100)),
  gray: pe("hcg", 2, ye(100)),
  white: pe("hwb", 1, ye(100)),
  wblack: pe("hwb", 2, ye(100)),
  cyan: pe("cmyk", 0, ye(100)),
  magenta: pe("cmyk", 1, ye(100)),
  yellow: pe("cmyk", 2, ye(100)),
  black: pe("cmyk", 3, ye(100)),
  x: pe("xyz", 0, ye(95.047)),
  y: pe("xyz", 1, ye(100)),
  z: pe("xyz", 2, ye(108.833)),
  l: pe("lab", 0, ye(100)),
  a: pe("lab", 1),
  b: pe("lab", 2),
  keyword(e) {
    return e !== void 0 ? new te(e) : xe[this.model].keyword(this.color);
  },
  hex(e) {
    return e !== void 0 ? new te(e) : ve.to.hex(...this.rgb().round().color);
  },
  hexa(e) {
    if (e !== void 0)
      return new te(e);
    const t = this.rgb().round().color;
    let r = Math.round(this.valpha * 255).toString(16).toUpperCase();
    return r.length === 1 && (r = "0" + r), ve.to.hex(...t) + r;
  },
  rgbNumber() {
    const e = this.rgb().color;
    return (e[0] & 255) << 16 | (e[1] & 255) << 8 | e[2] & 255;
  },
  luminosity() {
    const e = this.rgb().color, t = [];
    for (const [r, u] of e.entries()) {
      const i = u / 255;
      t[r] = i <= 0.04045 ? i / 12.92 : ((i + 0.055) / 1.055) ** 2.4;
    }
    return 0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2];
  },
  contrast(e) {
    const t = this.luminosity(), r = e.luminosity();
    return t > r ? (t + 0.05) / (r + 0.05) : (r + 0.05) / (t + 0.05);
  },
  level(e) {
    const t = this.contrast(e);
    return t >= 7 ? "AAA" : t >= 4.5 ? "AA" : "";
  },
  isDark() {
    const e = this.rgb().color;
    return (e[0] * 2126 + e[1] * 7152 + e[2] * 722) / 1e4 < 128;
  },
  isLight() {
    return !this.isDark();
  },
  negate() {
    const e = this.rgb();
    for (let t = 0; t < 3; t++)
      e.color[t] = 255 - e.color[t];
    return e;
  },
  lighten(e) {
    const t = this.hsl();
    return t.color[2] += t.color[2] * e, t;
  },
  darken(e) {
    const t = this.hsl();
    return t.color[2] -= t.color[2] * e, t;
  },
  saturate(e) {
    const t = this.hsl();
    return t.color[1] += t.color[1] * e, t;
  },
  desaturate(e) {
    const t = this.hsl();
    return t.color[1] -= t.color[1] * e, t;
  },
  whiten(e) {
    const t = this.hwb();
    return t.color[1] += t.color[1] * e, t;
  },
  blacken(e) {
    const t = this.hwb();
    return t.color[2] += t.color[2] * e, t;
  },
  grayscale() {
    const e = this.rgb().color, t = e[0] * 0.3 + e[1] * 0.59 + e[2] * 0.11;
    return te.rgb(t, t, t);
  },
  fade(e) {
    return this.alpha(this.valpha - this.valpha * e);
  },
  opaquer(e) {
    return this.alpha(this.valpha + this.valpha * e);
  },
  rotate(e) {
    const t = this.hsl();
    let r = t.color[0];
    return r = (r + e) % 360, r = r < 0 ? 360 + r : r, t.color[0] = r, t;
  },
  mix(e, t) {
    if (!e || !e.rgb)
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof e);
    const r = e.rgb(), u = this.rgb(), i = t === void 0 ? 0.5 : t, c = 2 * i - 1, a = r.alpha() - u.alpha(), l = ((c * a === -1 ? c : (c + a) / (1 + c * a)) + 1) / 2, d = 1 - l;
    return te.rgb(
      l * r.red() + d * u.red(),
      l * r.green() + d * u.green(),
      l * r.blue() + d * u.blue(),
      r.alpha() * i + u.alpha() * (1 - i)
    );
  }
};
for (const e of Object.keys(xe)) {
  if (Bn.includes(e))
    continue;
  const { channels: t } = xe[e];
  te.prototype[e] = function(...r) {
    return this.model === e ? new te(this) : r.length > 0 ? new te(r, e) : new te([...Ga(xe[this.model][e].raw(this.color)), this.valpha], e);
  }, te[e] = function(...r) {
    let u = r[0];
    return typeof u == "number" && (u = qr(r, t)), new te(u, e);
  };
}
function Ya(e, t) {
  return Number(e.toFixed(t));
}
function Va(e) {
  return function(t) {
    return Ya(t, e);
  };
}
function pe(e, t, r) {
  e = Array.isArray(e) ? e : [e];
  for (const u of e)
    (ht[u] || (ht[u] = []))[t] = r;
  return e = e[0], function(u) {
    let i;
    return u !== void 0 ? (r && (u = r(u)), i = this[e](), i.color[t] = u, i) : (i = this[e]().color[t], r && (i = r(i)), i);
  };
}
function ye(e) {
  return function(t) {
    return Math.max(0, Math.min(e, t));
  };
}
function Ga(e) {
  return Array.isArray(e) ? e : [e];
}
function qr(e, t) {
  for (let r = 0; r < t; r++)
    typeof e[r] != "number" && (e[r] = 0);
  return e;
}
const We = (e) => {
  try {
    return te(e).hex();
  } catch (t) {
    return console.warn("[useTokenColors] Invalid primaryColor:", e.value, t), "#000000";
  }
}, Yn = (e = { value: "#13802D" }) => {
  const t = Q(() => ({
    "builder-gray-white": "#ffffff",
    "builder-gray-100": "#F2F2F7",
    "builder-gray-200": "#E5E5EA",
    "builder-gray-300": "#D1D1D6",
    "builder-gray-400": "#C7C7CC",
    "builder-gray-500": "#8E8E93",
    "builder-gray-600": "#636366",
    "builder-gray-700": "#48484A",
    "builder-gray-800": "#3A3A3C",
    "builder-gray-900": "#1C1C1E",
    "builder-gray-black": "#000000",
    "builder-primary-100": te(We(e.value)).mix(te("#fff"), 0.88).hex(),
    "builder-primary-200": te(We(e.value)).mix(te("#fff"), 0.66).hex(),
    "builder-primary-300": te(We(e.value)).mix(te("#fff"), 0.44).hex(),
    "builder-primary-400": te(We(e.value)).mix(te("#fff"), 0.22).hex(),
    "builder-primary-500": te(We(e.value)).hex(),
    "builder-primary-600": te(We(e.value)).mix(te("#000"), 0.22).hex(),
    "builder-primary-700": te(We(e.value)).mix(te("#000"), 0.44).hex(),
    "builder-primary-800": te(We(e.value)).mix(te("#000"), 0.66).hex(),
    "builder-primary-900": te(We(e.value)).mix(te("#000"), 0.88).hex()
  }));
  return Q(() => ({
    "fg-default": {
      light: t.value["builder-gray-black"],
      lightGray: t.value["builder-gray-black"],
      dark: t.value["builder-gray-white"],
      darkGray: t.value["builder-gray-white"],
      accent: t.value["builder-gray-white"],
      lightAccent: t.value["builder-primary-900"]
    },
    "fg-muted": {
      light: t.value["builder-gray-700"],
      lightGray: t.value["builder-gray-800"],
      dark: t.value["builder-gray-300"],
      darkGray: t.value["builder-gray-200"],
      accent: t.value["builder-primary-100"],
      lightAccent: t.value["builder-primary-800"]
    },
    "fg-subtle": {
      light: t.value["builder-gray-600"],
      lightGray: t.value["builder-gray-700"],
      dark: t.value["builder-gray-400"],
      darkGray: t.value["builder-gray-300"],
      accent: t.value["builder-primary-200"],
      lightAccent: t.value["builder-gray-700"]
    },
    "fg-onemphasis": {
      light: t.value["builder-gray-white"],
      lightGray: t.value["builder-gray-white"],
      dark: t.value["builder-gray-white"],
      darkGray: t.value["builder-gray-white"],
      accent: t.value["builder-primary-500"],
      lightAccent: t.value["builder-gray-white"]
    },
    "fg-accent": {
      light: t.value["builder-primary-500"],
      lightGray: t.value["builder-primary-600"],
      dark: t.value["builder-primary-400"],
      darkGray: t.value["builder-primary-400"],
      accent: t.value["builder-gray-white"],
      lightAccent: t.value["builder-primary-600"]
    },
    "bg-default": {
      light: t.value["builder-gray-white"],
      lightGray: t.value["builder-gray-100"],
      dark: t.value["builder-gray-900"],
      darkGray: t.value["builder-gray-800"],
      accent: t.value["builder-primary-500"],
      lightAccent: t.value["builder-primary-100"]
    },
    "bg-subtle": {
      light: t.value["builder-gray-100"],
      lightGray: t.value["builder-gray-200"],
      dark: t.value["builder-gray-800"],
      darkGray: t.value["builder-gray-700"],
      accent: t.value["builder-primary-400"],
      lightAccent: t.value["builder-primary-200"]
    },
    "bg-emphasis": {
      light: t.value["builder-primary-500"],
      lightGray: t.value["builder-primary-500"],
      dark: t.value["builder-primary-500"],
      darkGray: t.value["builder-primary-500"],
      accent: t.value["builder-gray-white"],
      lightAccent: t.value["builder-primary-500"]
    },
    "bg-emphasis-muted": {
      light: t.value["builder-primary-100"],
      lightGray: t.value["builder-primary-200"],
      dark: t.value["builder-primary-800"],
      darkGray: t.value["builder-primary-700"],
      accent: t.value["builder-primary-400"],
      lightAccent: t.value["builder-primary-200"]
    },
    "border-default": {
      light: t.value["builder-gray-300"],
      lightGray: t.value["builder-gray-400"],
      dark: t.value["builder-gray-700"],
      darkGray: t.value["builder-gray-600"],
      accent: t.value["builder-primary-300"],
      lightAccent: t.value["builder-primary-400"]
    },
    "border-muted": {
      light: t.value["builder-gray-200"],
      lightGray: t.value["builder-gray-300"],
      dark: t.value["builder-gray-800"],
      darkGray: t.value["builder-gray-700"],
      accent: t.value["builder-primary-400"],
      lightAccent: t.value["builder-primary-200"]
    },
    "canvas-email": {
      light: t.value["builder-gray-100"],
      lightGray: t.value["builder-gray-100"],
      dark: t.value["builder-gray-black"],
      darkGray: t.value["builder-gray-black"],
      accent: t.value["builder-gray-white"],
      lightAccent: t.value["builder-gray-white"]
    }
  }));
}, Wa = ["lang"], Qa = ["content"], Za = ["lang"], Ja = {
  style: { "max-width": "640px", margin: "0 auto" },
  class: "email-container"
}, Ka = {
  align: "center",
  cellspacing: "0",
  cellpadding: "0",
  border: "0",
  width: "100%",
  style: { margin: "auto" }
}, Xa = { key: 0 }, es = { key: 1 }, ts = { style: { "padding-top": "20px", "padding-bottom": "10px", "text-align": "center" } }, rs = ["innerHTML"], us = ["href"], ns = { style: { padding: "20px", "text-align": "center" } }, is = ["href"], as = `<!--[if mso | IE]>
        </td>
      </tr>
    </table>
  <![endif]-->`, ss = `<!--[if mso]>
        </td>
      </tr>
    </table>
  <![endif]-->`, os = {
  __name: "EmailContainer",
  props: {
    params: {
      type: Object,
      default: () => ({
        customCss: "",
        primaryColor: "#0000FF",
        appearance: "light",
        font: null,
        backgroundImage: null
      })
    },
    lang: {
      type: String,
      default: ""
    },
    headCss: {
      type: String,
      default: ""
    },
    unbounded: {
      type: Boolean,
      default: !1
    },
    workspace: {
      type: Object,
      default: () => ({})
    },
    event: {
      type: Object,
      default: () => ({})
    },
    config: {
      type: Object,
      default: () => ({
        imagekit: "",
        origin: ""
      })
    },
    metaViewport: {
      type: String,
      default: "width=device-width"
    }
  },
  setup(e) {
    var x, _, y, w, S, k, $, D, T, A, P, L, E, C, R, q;
    const t = e, r = {
      cs: "Online pozvánky a vstupenky zajištuje",
      en: "Online invitations and tickets provided by",
      sk: "Online pozvánky a vstupenky poskytuje",
      pl: "Zaproszenia i bilety online są dostarczane przez",
      hu: "Az online meghívókat és jegyeket a",
      de: "Online-Einladungen und Tickets werden bereitgestellt von",
      es: "Las invitaciones y boletos en línea son proporcionados por",
      fr: "Les invitations et les billets en ligne sont fournis par"
    }, u = {
      cs: "Odhlásit odběr",
      en: "Unsubscribe",
      sk: "Odhlásiť sa z odberu",
      pl: "Wypisać się",
      hu: "Leiratkozás",
      de: "Abbestellen",
      es: "Darse de baja",
      fr: "Se désinscrire"
    }, i = {
      cs: `Odhlášení odběru u všech událostí: ${(x = t.workspace) == null ? void 0 : x.name}`,
      en: `Unsubscribe from all events: ${(_ = t.workspace) == null ? void 0 : _.name}`,
      sk: `Odhlásenie odberu zo všetkých udalostí: ${(y = t.workspace) == null ? void 0 : y.name}`,
      pl: `Zrezygnuj z subskrypcji wszystkich wydarzeń: ${(w = t.workspace) == null ? void 0 : w.name}`,
      hu: `Leiratkozás minden eseményről: ${(S = t.workspace) == null ? void 0 : S.name}`,
      de: `Abmeldung für alle Veranstaltungen: ${(k = t.workspace) == null ? void 0 : k.name}`,
      es: `Darse de baja para todos los eventos: ${($ = t.workspace) == null ? void 0 : $.name}`,
      fr: `Se désabonner pour tous les événements: ${(D = t.workspace) == null ? void 0 : D.name}`
    }, c = {
      cs: `Chci odhlásit svůj odběr emailů pro všechny akce pořádané společností ${(T = t.workspace) == null ? void 0 : T.name}.`,
      en: `I want to unsubscribe from emails for all events organized by the company ${(A = t.workspace) == null ? void 0 : A.name}.`,
      sk: `Chcem sa odhlásiť z odberu e-mailov na všetky podujatia organizované spoločnosťou ${(P = t.workspace) == null ? void 0 : P.name}.`,
      pl: `Chcę zrezygnować z subskrypcji wiadomości e-mail dotyczących wszystkich wydarzeń organizowanych przez ${(L = t.workspace) == null ? void 0 : L.name}.`,
      hu: `Szeretnék leiratkozni az ${(E = t.workspace) == null ? void 0 : E.name} által szervezett összes eseményre vonatkozó e-mailekről.`,
      de: `Ich möchte mich von den E-Mails für alle von ${(C = t.workspace) == null ? void 0 : C.name} organisierten Veranstaltungen abmelden.`,
      es: `Quiero darme de baja de los correos electrónicos de todos los eventos organizados por ${(R = t.workspace) == null ? void 0 : R.name}.`,
      fr: `Je souhaite me désinscrire des courriels pour tous les événements organisés par ${(q = t.workspace) == null ? void 0 : q.name}.`
    }, a = Yn(Q(() => {
      var F;
      return (F = t == null ? void 0 : t.params) == null ? void 0 : F.primaryColor;
    })), l = Q(() => {
      var F;
      return Na(((F = t.params) == null ? void 0 : F.customCss) || "", ".email-wrapper");
    }), d = Q(() => {
      var F;
      return (F = t.lang) == null ? void 0 : F.replace("_", "");
    }), o = Q(() => t.params.backgroundImage ? `${t.config.imagekit}${t.config.imagekit ? "/tr:w-1920,c-at_max_enlarge,f-png/" : ""}${t.params.backgroundImage}?format=.png` : ""), f = Q(() => o.value ? (
      /* css */
      `
      .email-wrapper {
        background-image: url(${o.value}) !important;
        background-size: cover !important;
        background-position: center !important;
      }

      @media screen and (max-width: 640px) {
        .email-wrapper {
          background-image: none !important;
        }
      }
    `
    ) : ""), p = Q(() => o.value ? `<!--[if mso | IE]>
      <v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
        <v:fill type="tile" src="${o.value}"/>
      </v:background>
      <![endif]-->` : ""), n = Q(() => (
      /* js */
      `<!--[if gte mso 9]>
    <xml>
      <o:OfficeDocumentSettings>
        <o:AllowPNG/>
        <o:PixelsPerInch>96</o:PixelsPerInch>
      </o:OfficeDocumentSettings>
    </xml>
  <![endif]-->`
    )), s = Q(() => (
      /* js */
      `<!--[if mso]>
    <style>
      * {
        font-family: Arial, sans-serif !important;
      }
    </style>
  <![endif]-->`
    )), m = Q(() => `<!--[if mso | IE]>
    <table border="0" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td>
  <![endif]-->`), b = Q(() => `<!--[if mso]>
    <table align="center" cellspacing="0" cellpadding="0" border="0" width="640">
      <tr>
        <td>
  <![endif]-->`), g = Q(() => ["light", "lightGray", "dark", "darkGray", "accent", "lightAccent"].map((z) => (
      /* css */
      `
      .email-container .appearance-${z} a {
        color: ${v("fg-muted", z)} !important;
      }
    `
    )).join("")), h = Q(() => t.params.font ? (
      /* css */
      `
      @font-face {
        font-family: 'CustomEmailFont';
        font-style: normal;
        font-weight: 400;
        src: url('${t.params.font.regular}') format('woff');
      }
      @font-face {
        font-family: 'CustomEmailFont';
        font-style: normal;
        font-weight: 500;
        src: url('${t.params.font.medium}') format('woff');
      }
      @font-face {
        font-family: 'CustomEmailFont';
        font-style: normal;
        font-weight: 600;
        src: url('${t.params.font.bold}') format('woff');
      }
    `
    ) : (
      /* css */
      `/* cyrillic-ext */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
      }
      /* cyrillic */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
      }
      /* greek-ext */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+1F00-1FFF;
      }
      /* greek */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0370-03FF;
      }
      /* vietnamese */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
      }
      /* latin-ext */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
      }
      /* latin */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }
      /* cyrillic-ext */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
      }
      /* cyrillic */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
      }
      /* greek-ext */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+1F00-1FFF;
      }
      /* greek */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0370-03FF;
      }
      /* vietnamese */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
      }
      /* latin-ext */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
      }
      /* latin */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }
      /* cyrillic-ext */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
      }
      /* cyrillic */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
      }
      /* greek-ext */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+1F00-1FFF;
      }
      /* greek */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0370-03FF;
      }
      /* vietnamese */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
      }
      /* latin-ext */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2) format('woff2');
        unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
      }
      /* latin */
      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }
    `
    )), v = (F, z) => {
      var O, N;
      return (N = a.value[F]) == null ? void 0 : N[z || ((O = t == null ? void 0 : t.params) == null ? void 0 : O.appearance)];
    };
    return Zt("lang", Q(() => `_${t.lang}`)), Zt("config", Q(() => t.config)), Zt("event", Q(() => t.event)), (F, z) => {
      var U, V, W, ne, se, de, be, oe, I, B, j, G, ce, le, Ie, Ne, X, ee, Fe;
      const O = Ft("EmailComment"), N = Ft("EmailStyleTag");
      return ue(), re(Bt, null, [
        ge("DOCTYPE html"),
        H("html", Qn({
          lang: M(d),
          xmlns: "http://www.w3.org/1999/xhtml",
          "xmlns:v": "urn:schemas-microsoft-com:vml",
          "xmlns:o": "urn:schemas-microsoft-com:office:office",
          class: "email"
        }, F.$attrs), [
          H("head", null, [
            z[0] || (z[0] = H("meta", { charset: "utf-8" }, null, -1)),
            t.metaViewport ? (ue(), re("meta", {
              key: 0,
              name: "viewport",
              content: t.metaViewport
            }, null, 8, Qa)) : ge("", !0),
            z[1] || (z[1] = H("meta", {
              "http-equiv": "X-UA-Compatible",
              content: "IE=edge"
            }, null, -1)),
            z[2] || (z[2] = H("meta", { name: "x-apple-disable-message-reformatting" }, null, -1)),
            z[3] || (z[3] = H("meta", {
              name: "format-detection",
              content: "telephone=no,address=no,email=no,date=no,url=no"
            }, null, -1)),
            z[4] || (z[4] = H("meta", {
              name: "color-scheme",
              content: "only"
            }, null, -1)),
            H("title", null, Qe(((W = (V = (U = t.params) == null ? void 0 : U.headers) == null ? void 0 : V[M(d)]) == null ? void 0 : W.subject) || "Attendu"), 1),
            me(O, { content: M(n) }, null, 8, ["content"]),
            me(O, { content: M(s) }, null, 8, ["content"]),
            me(N, { content: e.headCss }, null, 8, ["content"]),
            me(N, { content: M(l) }, null, 8, ["content"]),
            me(N, { content: M(h) }, null, 8, ["content"]),
            me(N, { content: M(g) }, null, 8, ["content"]),
            me(N, { content: M(f) }, null, 8, ["content"])
          ]),
          H("body", {
            width: "100%",
            style: Z([
              "margin: 0; padding: 0 !important; mso-line-height-rule: exactly;",
              `background-color: ${v("canvas-email")};`
            ])
          }, [
            H("center", {
              class: "email-wrapper",
              "aria-roledescription": "email",
              lang: M(d),
              style: Z([
                "width: 100%;",
                `background-color: ${v("canvas-email")};`
              ])
            }, [
              me(O, { content: M(p) }, null, 8, ["content"]),
              me(O, { content: M(m) }, null, 8, ["content"]),
              H("div", Ja, [
                me(O, { content: M(b) }, null, 8, ["content"]),
                H("table", Ka, [
                  e.unbounded ? ge("", !0) : (ue(), re("tr", Xa, z[5] || (z[5] = [
                    H("td", { style: { padding: "20px 0", "text-align": "center" } }, null, -1)
                  ]))),
                  Zn(F.$slots, "default"),
                  !e.unbounded && !((ne = t.params) != null && ne.isUnsubscribeDisplayed) && !((se = t.params) != null && se.isWatermarkDisplayed) && !((de = t.params) != null && de.isCustomFooterDisplayed) ? (ue(), re("tr", es, z[6] || (z[6] = [
                    H("td", { style: { padding: "20px 0", "text-align": "center" } }, null, -1)
                  ]))) : ge("", !0)
                ]),
                !e.unbounded && ((be = t.params) != null && be.isUnsubscribeDisplayed || (oe = t.params) != null && oe.isCustomFooterDisplayed) ? (ue(), re("table", {
                  key: 0,
                  align: "center",
                  cellspacing: "0",
                  cellpadding: "0",
                  border: "0",
                  width: "100%",
                  style: Z([
                    t.params.font ? "font-family: 'CustomEmailFont', Arial, sans-serif;" : "font-family: 'Inter', Arial, sans-serif;",
                    "margin: auto;"
                  ])
                }, [
                  H("tbody", null, [
                    H("tr", null, [
                      H("td", ts, [
                        (I = t.params) != null && I.isCustomFooterDisplayed ? (ue(), re("div", {
                          key: 0,
                          class: "unsubscribe-prefix",
                          style: Z([
                            `color: ${v("fg-subtle")};`,
                            "padding-bottom: 4px; padding-left: 8px; padding-right: 8px;"
                          ]),
                          innerHTML: ("sanitize" in F ? F.sanitize : M(Le))((G = (j = (B = t.params) == null ? void 0 : B.customFooter) == null ? void 0 : j[`_${t.lang}`]) == null ? void 0 : G.text)
                        }, null, 12, rs)) : ge("", !0),
                        (ce = t.params) != null && ce.isUnsubscribeDisplayed ? (ue(), re("p", {
                          key: 1,
                          style: Z([
                            `color: ${v("fg-subtle")} !important;`,
                            "font-size:14px"
                          ])
                        }, [
                          H("a", {
                            href: `mailto:${(Ie = (le = e.event) == null ? void 0 : le.general) == null ? void 0 : Ie.contactEmail}?body=${c[M(d)]}&subject=${i[M(d)]}`,
                            style: Z([
                              "text-decoration: none;",
                              `color: ${v("fg-subtle")} !important;`
                            ])
                          }, Qe(u[M(d)]), 13, us)
                        ], 4)) : ge("", !0)
                      ])
                    ])
                  ])
                ], 4)) : ge("", !0),
                !e.unbounded && ((Ne = t.params) != null && Ne.isWatermarkDisplayed) ? (ue(), re("table", {
                  key: 1,
                  align: "center",
                  cellspacing: "0",
                  cellpadding: "0",
                  border: "0",
                  width: "100%",
                  style: Z([
                    t.params.font ? "font-family: 'CustomEmailFont', Arial, sans-serif;" : "font-family: 'Inter', Arial, sans-serif;",
                    "margin: auto;"
                  ])
                }, [
                  H("tbody", null, [
                    H("tr", null, [
                      H("td", ns, [
                        H("p", {
                          style: Z([
                            `color: ${v("fg-subtle")};`
                          ])
                        }, [
                          Jn(Qe(r[M(d)]) + " ", 1),
                          H("a", {
                            href: t.config.websiteUrl || "https://www.attendu.com",
                            style: Z([
                              "text-decoration: none;",
                              `color: ${((X = t == null ? void 0 : t.params) == null ? void 0 : X.appearance) === "accent" ? (Fe = (ee = M(a)) == null ? void 0 : ee["fg-subtle"]) == null ? void 0 : Fe.lightAccent : v("fg-default")} !important;`
                            ])
                          }, Qe(t.config.appName || "Attendu"), 13, is)
                        ], 4)
                      ])
                    ])
                  ])
                ], 4)) : ge("", !0),
                me(O, { content: ss })
              ]),
              me(O, { content: as })
            ], 12, Za)
          ], 4)
        ], 16, Wa)
      ], 64);
    };
  }
}, Ce = (e) => {
  const t = tt("config"), r = Yn(Q(() => {
    var u;
    return (u = e.data) == null ? void 0 : u.primaryColor;
  }));
  return {
    getHex: (u) => {
      var i, c;
      return (c = r.value[u]) == null ? void 0 : c[(i = e.data) == null ? void 0 : i.appearance];
    },
    styles: {
      fontFamily: Q(() => "font-family: CustomEmailFont, Inter, sans-serif;"),
      spacerTop: Q(() => {
        var i;
        return {
          small: "spacer-top--small",
          medium: "spacer-top--medium",
          large: "spacer-top--large"
        }[(i = e.data) == null ? void 0 : i.spacerTop] || "";
      }),
      spacerTopInline: Q(() => {
        var i;
        return {
          small: "padding-top:16px;",
          medium: "padding-top:32px;",
          large: "padding-top:48px;"
        }[(i = e.data) == null ? void 0 : i.spacerTop] || "";
      }),
      spacerBottom: Q(() => {
        var i;
        return {
          small: "spacer-bottom--small",
          medium: "spacer-bottom--medium",
          large: "spacer-bottom--large"
        }[(i = e.data) == null ? void 0 : i.spacerBottom] || "";
      }),
      spacerBottomInline: Q(() => {
        var i;
        return {
          small: "padding-bottom:16px;",
          medium: "padding-bottom:32px;",
          large: "padding-bottom:48px;"
        }[(i = e.data) == null ? void 0 : i.spacerBottom] || "";
      }),
      textAlignment: Q(() => {
        var i;
        return {
          left: "text-align:left;",
          center: "text-align:center;",
          right: "text-align:right;"
        }[(i = e.data) == null ? void 0 : i.alignment] || "";
      }),
      imageSize: Q(() => {
        var i;
        return {
          small: "max-width:180px;width:180px;",
          medium: "max-width:540px;width:540px;margin:auto;",
          large: "width: 640px; max-width: 100%;"
        }[(i = e.data) == null ? void 0 : i.size] || "";
      }),
      imagePlainSize: Q(() => {
        var i;
        return {
          small: "180",
          medium: "540",
          large: "640"
        }[(i = e.data) == null ? void 0 : i.size] || "";
      }),
      sectionAlignment: Q(() => {
        var i;
        return {
          left: "margin-left:0;margin-right:auto;",
          center: "margin-left:auto;margin-right:auto;",
          right: "margin-left:auto;margin-right:0;"
        }[(i = e.data) == null ? void 0 : i.alignment] || "";
      }),
      buttonColor: Q(() => {
        var u, i, c, a, l;
        return ((u = e.data) == null ? void 0 : u.type) === "primary" ? (c = r.value["fg-onemphasis"]) == null ? void 0 : c[(i = e.data) == null ? void 0 : i.appearance] : (l = r.value["fg-default"]) == null ? void 0 : l[(a = e.data) == null ? void 0 : a.appearance];
      }),
      buttonBackgroundColor: Q(() => {
        var u, i, c;
        return ((u = e.data) == null ? void 0 : u.type) === "primary" ? (c = r.value["bg-emphasis"]) == null ? void 0 : c[(i = e.data) == null ? void 0 : i.appearance] : "none";
      }),
      buttonBorderColor: Q(() => {
        var u, i, c, a, l;
        return ((u = e.data) == null ? void 0 : u.type) === "primary" ? (c = r.value["bg-default"]) == null ? void 0 : c[(i = e.data) == null ? void 0 : i.appearance] : (l = r.value["border-default"]) == null ? void 0 : l[(a = e.data) == null ? void 0 : a.appearance];
      })
    },
    getLinkByLinkType: ({ linkType: u, event: i, guest: c, customUrl: a, activePage: l }) => {
      var d, o;
      return u === "activePage" ? `${t.value.origin}/event/${c == null ? void 0 : c.event}?g=${c == null ? void 0 : c._id}` : u === "denialPage" ? `${t.value.origin}/event/${c == null ? void 0 : c.event}?g=${c == null ? void 0 : c._id}&d=true` : u === "registrationPage" ? `${t.value.origin}/event/${c == null ? void 0 : c.event}?p=${l}&lang=${((d = c == null ? void 0 : c.properties) == null ? void 0 : d.lang) || ""}` : u === "registrationPagePublicId" ? `${t.value.origin}/${i == null ? void 0 : i.publicId}?lang=${((o = c == null ? void 0 : c.properties) == null ? void 0 : o.lang) || ""}` : u === "guestAppAccess" ? `${t.value.origin}/app/${c == null ? void 0 : c.event}` : u === "addToCalendar" ? `${t.value.origin}/event/${c == null ? void 0 : c.event}?g=${c == null ? void 0 : c._id}&cal=true` : u === "customUrl" && a ? a : "";
    },
    getImageUrl: ({ url: u, transformations: i }) => {
      if (!u) return "";
      let c = t.value.imagekit;
      const l = u.toLowerCase().endsWith(".gif") ? "gif" : "png";
      return t.value.imagekit && (c += `/${i},f-${l}/`), c += `${u}?format=.${l}`, c;
    },
    lang: tt("lang"),
    data: Q(() => e == null ? void 0 : e.data)
  };
}, cs = ["bgcolor"], ls = ["bgcolor"], fs = ["innerHTML"], ds = {
  __name: "EmailTextBasic",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const r = Ce(e);
    return (u, i) => {
      var c, a, l, d, o;
      return ue(), re("table", {
        border: "0",
        cellpadding: "0",
        cellspacing: "0",
        width: "100%",
        valign: "top",
        align: "center",
        style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
        bgcolor: M(r).getHex("bg-default"),
        class: fe(`appearance-${(a = (c = M(r).data) == null ? void 0 : c.value) == null ? void 0 : a.appearance}`)
      }, [
        H("tbody", null, [
          H("tr", null, [
            H("td", {
              class: fe([
                "section",
                M(r).styles.spacerTop.value,
                M(r).styles.spacerBottom.value
              ]),
              style: Z([
                M(r).styles.textAlignment.value,
                `color: ${M(r).getHex("fg-muted")};`,
                `background-color: ${M(r).getHex("bg-default")};`,
                "padding-left:50px;padding-right:50px;width:100%;",
                M(r).styles.spacerTopInline.value,
                M(r).styles.spacerBottomInline.value
              ]),
              bgcolor: M(r).getHex("bg-default")
            }, [
              H("div", {
                innerHTML: ("sanitize" in u ? u.sanitize : M(Le))((o = (d = (l = M(r).data) == null ? void 0 : l.value) == null ? void 0 : d[M(r).lang.value]) == null ? void 0 : o.content)
              }, null, 8, fs)
            ], 14, ls)
          ])
        ])
      ], 10, cs);
    };
  }
}, hs = ["bgcolor"], ps = ["align", "bgcolor"], ms = { style: { "max-width": "100%", overflow: "hidden" } }, bs = ["src", "width"], gs = {
  __name: "EmailImageBasic",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e, r = Ce(t), u = (i, c) => {
      const a = i == null ? void 0 : i.toLowerCase().endsWith(".gif");
      let l = 640;
      return c === "small" && (l = a ? 180 : 360), c === "medium" && (l = a ? 540 : 1080), c === "large" && (l = a ? 640 : 1280), `tr:w-${l},c-at_max_enlarge`;
    };
    return (i, c) => {
      var a, l, d, o, f, p, n, s, m, b, g, h, v, x, _, y, w, S;
      return ue(), re("table", {
        border: "0",
        cellpadding: "0",
        cellspacing: "0",
        width: "100%",
        valign: "top",
        align: "center",
        style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
        bgcolor: M(r).getHex("bg-default"),
        class: fe(`appearance-${(l = (a = M(r).data) == null ? void 0 : a.value) == null ? void 0 : l.appearance}`)
      }, [
        H("tbody", null, [
          H("tr", null, [
            H("td", {
              align: ((d = t.data) == null ? void 0 : d.size) === "small" ? (o = t.data) == null ? void 0 : o.alignment : "center",
              class: fe([
                M(r).styles.spacerTop.value,
                M(r).styles.spacerBottom.value,
                ((f = t.data) == null ? void 0 : f.size) === "small" ? "section" : ""
              ]),
              style: Z([
                `color: ${M(r).getHex("fg-default")};`,
                `background-color: ${M(r).getHex("bg-default")};`,
                M(r).styles.spacerTopInline.value,
                M(r).styles.spacerBottomInline.value,
                ((p = t.data) == null ? void 0 : p.size) === "small" ? "padding-left:50px;padding-right:50px;width:100%;" : "width:100%;"
              ]),
              bgcolor: M(r).getHex("bg-default")
            }, [
              H("div", ms, [
                ge(" div is fix for apple mail - tap to download images "),
                (m = (s = (n = M(r).data) == null ? void 0 : n.value) == null ? void 0 : s[M(r).lang.value]) != null && m.source ? (ue(), re("img", {
                  key: 0,
                  src: M(r).getImageUrl({
                    url: (h = (g = (b = M(r).data) == null ? void 0 : b.value) == null ? void 0 : g[M(r).lang.value]) == null ? void 0 : h.source,
                    transformations: u((_ = (x = (v = M(r).data) == null ? void 0 : v.value) == null ? void 0 : x[M(r).lang.value]) == null ? void 0 : _.source, (y = t.data) == null ? void 0 : y.size)
                  }),
                  width: M(r).styles.imagePlainSize.value,
                  alt: "image",
                  style: Z([
                    ((w = t.data) == null ? void 0 : w.size) === "small" ? M(r).styles.sectionAlignment.value : "",
                    M(r).styles.imageSize.value,
                    "display:block;"
                  ]),
                  class: fe(((S = t.data) == null ? void 0 : S.size) !== "small" ? "image" : "")
                }, null, 14, bs)) : ge("", !0)
              ])
            ], 14, ps)
          ])
        ])
      ], 10, hs);
    };
  }
}, ys = ["bgcolor"], vs = ["bgcolor"], xs = {
  __name: "EmailDividerBasic",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const r = Ce(e);
    return (u, i) => {
      var c, a;
      return ue(), re("table", {
        border: "0",
        cellpadding: "0",
        cellspacing: "0",
        width: "100%",
        valign: "top",
        align: "center",
        style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
        bgcolor: M(r).getHex("bg-default"),
        class: fe(`appearance-${(a = (c = M(r).data) == null ? void 0 : c.value) == null ? void 0 : a.appearance}`)
      }, [
        H("tbody", null, [
          H("tr", null, [
            H("td", {
              class: fe([
                "section",
                M(r).styles.spacerTop.value,
                M(r).styles.spacerBottom.value
              ]),
              style: Z([
                `background-color: ${M(r).getHex("bg-default")};`,
                "padding-left:50px;padding-right:50px;width:100%;",
                M(r).styles.spacerTopInline.value,
                M(r).styles.spacerBottomInline.value
              ]),
              bgcolor: M(r).getHex("bg-default")
            }, [
              H("hr", {
                height: "1",
                style: Z([{ height: "1px", border: "0 none" }, [
                  `color: ${M(r).getHex("border-muted")};`,
                  `background-color: ${M(r).getHex("border-muted")};`
                ]])
              }, null, 4)
            ], 14, vs)
          ])
        ])
      ], 10, ys);
    };
  }
}, ws = ["bgcolor"], _s = ["bgcolor"], Ss = { class: "section" }, Ms = ["href"], ks = {
  __name: "EmailButtonBasic",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    guest: {
      type: Object,
      default: () => ({})
    },
    activePage: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e, r = Ce(t), u = tt("event"), i = Q(() => {
      var l, d, o, f, p;
      return r.getLinkByLinkType({
        linkType: (l = t.data) == null ? void 0 : l.linkType,
        customUrl: (f = (o = (d = r.data) == null ? void 0 : d.value) == null ? void 0 : o[r.lang.value]) == null ? void 0 : f.customUrl,
        guest: t.guest,
        event: u.value,
        activePage: (p = t.activePage) == null ? void 0 : p._id
      });
    }), c = Q(() => {
      var l, d, o, f, p;
      return (
        /* js */
        `<!--[if gte mso 17]>
    <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" rel="noopener" target="_blank" href="${i.value}" style="height:50px;v-text-anchor:middle;width:260px;" arcsize="${(l = t.data) != null && l.hasRoundedCorners ? "100%" : "0"}" strokecolor="${r.styles.buttonBorderColor.value}" stroke="${((d = t.data) == null ? void 0 : d.type) === "primary" ? "f" : r.getHex("border-default")}" fillcolor="${r.styles.buttonBackgroundColor.value}">
      <w:anchorlock/>
      <center style="color:${r.styles.buttonColor.value};font-size:16px;${r.styles.fontFamily.value}">${(p = (f = (o = r.data) == null ? void 0 : o.value) == null ? void 0 : f[r.lang.value]) == null ? void 0 : p.text}</center>
    </v:roundrect>
  <![endif]-->`
      );
    }), a = Q(() => {
      var l, d, o, f, p;
      return (
        /* js */
        `<!--[if lte mso 16]>
    <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" rel="noopener" target="_blank" href="${i.value}" style="height:50px;v-text-anchor:middle;width:260px;" arcsize="${(l = t.data) != null && l.hasRoundedCorners ? "100%" : "0"}" strokecolor="${r.styles.buttonBorderColor.value}" stroke="${((d = t.data) == null ? void 0 : d.type) === "primary" ? "f" : r.getHex("border-default")}" fillcolor="${r.styles.buttonBackgroundColor.value}">
      <w:anchorlock/>
      <center style="color:${r.styles.buttonColor.value};font-size:16px;font-family: Arial, sans-serif;">${(p = (f = (o = r.data) == null ? void 0 : o.value) == null ? void 0 : f[r.lang.value]) == null ? void 0 : p.text}</center>
    </v:roundrect>
  <![endif]-->`
      );
    });
    return (l, d) => {
      var f, p, n, s, m, b, g;
      const o = Ft("EmailComment");
      return ue(), re("table", {
        border: "0",
        cellpadding: "0",
        cellspacing: "0",
        width: "100%",
        valign: "top",
        align: "center",
        style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
        bgcolor: M(r).getHex("bg-default"),
        class: fe(`appearance-${(p = (f = M(r).data) == null ? void 0 : f.value) == null ? void 0 : p.appearance}`)
      }, [
        H("tbody", null, [
          H("tr", null, [
            H("td", {
              class: fe([
                "container-center",
                M(r).styles.spacerTop.value,
                M(r).styles.spacerBottom.value
              ]),
              style: Z([
                M(r).styles.spacerTopInline.value,
                M(r).styles.spacerBottomInline.value,
                `color: ${M(r).styles.buttonColor.value};`,
                `background-color: ${M(r).getHex("bg-default")};`,
                "padding-left:50px;padding-right:50px;width:100%;",
                M(r).styles.textAlignment.value
              ]),
              bgcolor: M(r).getHex("bg-default")
            }, [
              H("div", Ss, [
                me(o, { content: M(c) }, null, 8, ["content"]),
                me(o, { content: M(a) }, null, 8, ["content"]),
                H("a", {
                  rel: "noopener",
                  target: "_blank",
                  href: M(i),
                  style: Z([
                    `border: solid 1px ${M(r).styles.buttonBorderColor.value};`,
                    ((n = t.data) == null ? void 0 : n.type) === "primary" ? "" : `border: solid 1px ${M(r).getHex("border-default")};`,
                    "display:inline-block;font-size: 16px;line-height:50px;text-align:center;text-decoration:none;width:260px;-webkit-text-size-adjust:none;mso-hide:all;",
                    `background: ${M(r).styles.buttonBackgroundColor.value};`,
                    `color: ${M(r).styles.buttonColor.value} !important;`,
                    (s = t.data) != null && s.hasRoundedCorners ? "border-radius:40px;" : "",
                    "font-weight:600"
                  ]),
                  class: "mobile-w-full"
                }, Qe(((g = (b = (m = M(r).data) == null ? void 0 : m.value) == null ? void 0 : b[M(r).lang.value]) == null ? void 0 : g.text) || "Button"), 13, Ms)
              ])
            ], 14, _s)
          ])
        ])
      ], 10, ws);
    };
  }
}, Ts = ["bgcolor"], Es = ["bgcolor"], As = ["bgcolor"], $s = { key: 0 }, Ds = ["width", "bgcolor"], Os = ["href"], Ls = ["width", "bgcolor"], Cs = ["href"], Is = { key: 1 }, Ns = ["width", "bgcolor"], Ps = { class: "section" }, qs = ["href"], Us = { key: 2 }, Hs = ["width", "bgcolor"], Rs = { class: "section" }, js = ["href"], Fs = {
  __name: "EmailButtonGroup",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    guest: {
      type: Object,
      default: () => ({})
    },
    activePage: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e, r = Ce(t), u = tt("event"), i = Q(() => {
      var s, m, b, g, h, v, x, _;
      return r.getLinkByLinkType({
        linkType: (b = (m = (s = r.data) == null ? void 0 : s.value) == null ? void 0 : m.buttonPrimary) == null ? void 0 : b.linkType,
        customUrl: (x = (v = (h = (g = r.data) == null ? void 0 : g.value) == null ? void 0 : h.buttonPrimary) == null ? void 0 : v[r.lang.value]) == null ? void 0 : x.customUrl,
        guest: t.guest,
        event: u.value,
        activePage: (_ = t.activePage) == null ? void 0 : _._id
      });
    }), c = Q(() => {
      var s, m, b, g, h, v, x, _;
      return r.getLinkByLinkType({
        linkType: (b = (m = (s = r.data) == null ? void 0 : s.value) == null ? void 0 : m.buttonSecondary) == null ? void 0 : b.linkType,
        customUrl: (x = (v = (h = (g = r.data) == null ? void 0 : g.value) == null ? void 0 : h.buttonSecondary) == null ? void 0 : v[r.lang.value]) == null ? void 0 : x.customUrl,
        event: u.value,
        guest: t.guest,
        activePage: (_ = t.activePage) == null ? void 0 : _._id
      });
    }), a = Q(() => {
      var s, m, b, g, h, v;
      return (
        /* js */
        `<!--[if gte mso 17]>
    <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" rel="noopener" target="_blank" href="${i.value}" style="height:50px;v-text-anchor:middle;${((s = t.data) == null ? void 0 : s.layoutDirection) === "row" ? "width:260px;" : "width:540px;"}" arcsize="${(m = t.data) != null && m.hasRoundedCorners ? "100%" : "0"}" strokecolor="${r.getHex("bg-default")}" stroke="f" fillcolor="${r.getHex("bg-emphasis")}">
      <w:anchorlock/>
      <center style="color:${r.getHex("fg-onemphasis")};font-size:16px;${r.styles.fontFamily.value}">${(v = (h = (g = (b = r.data) == null ? void 0 : b.value) == null ? void 0 : g.buttonPrimary) == null ? void 0 : h[r.lang.value]) == null ? void 0 : v.text}</center>
    </v:roundrect>
  <![endif]-->`
      );
    }), l = Q(() => {
      var s, m, b, g, h, v;
      return (
        /* js */
        `<!--[if lte mso 16]>
    <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" rel="noopener" target="_blank" href="${i.value}" style="height:50px;v-text-anchor:middle;${((s = t.data) == null ? void 0 : s.layoutDirection) === "row" ? "width:260px;" : "width:540px;"}" arcsize="${(m = t.data) != null && m.hasRoundedCorners ? "100%" : "0"}" strokecolor="${r.getHex("bg-default")}" stroke="f" fillcolor="${r.getHex("bg-emphasis")}">
      <w:anchorlock/>
      <center style="color:${r.getHex("fg-onemphasis")};font-size:16px;font-family: Arial, sans-serif;">${(v = (h = (g = (b = r.data) == null ? void 0 : b.value) == null ? void 0 : g.buttonPrimary) == null ? void 0 : h[r.lang.value]) == null ? void 0 : v.text}</center>
    </v:roundrect>
  <![endif]-->`
      );
    }), d = Q(() => {
      var s, m, b, g, h, v;
      return (
        /* js */
        `<!--[if gte mso 17]>
    <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" rel="noopener" target="_blank" href="${c.value}" style="height:50px;v-text-anchor:middle;${((s = t.data) == null ? void 0 : s.layoutDirection) === "row" ? "width:260px;" : "width:540px;"}" arcsize="${(m = t.data) != null && m.hasRoundedCorners ? "100%" : "0"}" strokecolor="${r.styles.buttonBorderColor.value}" stroke="${r.getHex("border-default")}" fillcolor="none">
      <w:anchorlock/>
      <center style="color:${r.getHex("fg-default")};font-size:16px;${r.styles.fontFamily.value}">${(v = (h = (g = (b = r.data) == null ? void 0 : b.value) == null ? void 0 : g.buttonSecondary) == null ? void 0 : h[r.lang.value]) == null ? void 0 : v.text}</center>
    </v:roundrect>
  <![endif]-->`
      );
    }), o = Q(() => {
      var s, m, b, g, h, v;
      return (
        /* js */
        `<!--[if lte mso 16]>
    <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" rel="noopener" target="_blank" href="${c.value}" style="height:50px;v-text-anchor:middle;${((s = t.data) == null ? void 0 : s.layoutDirection) === "row" ? "width:260px;" : "width:540px;"}" arcsize="${(m = t.data) != null && m.hasRoundedCorners ? "100%" : "0"}" strokecolor="${r.styles.buttonBorderColor.value}" stroke="${r.getHex("border-default")}" fillcolor="none">
      <w:anchorlock/>
      <center style="color:${r.getHex("fg-default")};font-size:16px;font-family: Arial, sans-serif;">${(v = (h = (g = (b = r.data) == null ? void 0 : b.value) == null ? void 0 : g.buttonSecondary) == null ? void 0 : h[r.lang.value]) == null ? void 0 : v.text}</center>
    </v:roundrect>
  <![endif]-->`
      );
    }), f = Q(() => {
      var s, m;
      return [
        "display:inline-block;font-size: 16px;line-height:50px;text-align:center;text-decoration:none;-webkit-text-size-adjust:none;mso-hide:all;",
        ((s = t.data) == null ? void 0 : s.layoutDirection) === "row" ? "width:260px;" : "width:100%;",
        (m = t.data) != null && m.hasRoundedCorners ? "border-radius:40px;" : "",
        "font-weight:600;"
      ];
    }), p = Q(() => [
      `border: solid 1px ${r.getHex("bg-default")};`,
      `background-color: ${r.getHex("bg-emphasis")};`,
      `color: ${r.getHex("fg-onemphasis")} !important;`
    ]), n = Q(() => [
      `border: solid 1px ${r.getHex("border-default")};`,
      "background: none;",
      `color: ${r.getHex("fg-default")} !important;`
    ]);
    return (s, m) => {
      var g, h, v, x, _, y, w, S, k, $, D, T, A, P, L, E, C, R, q, F, z, O, N, U, V, W, ne, se, de;
      const b = Ft("EmailComment");
      return ue(), re("table", {
        border: "0",
        cellpadding: "0",
        cellspacing: "0",
        width: "100%",
        valign: "top",
        align: "center",
        style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
        bgcolor: M(r).getHex("bg-default"),
        class: fe(`appearance-${(h = (g = M(r).data) == null ? void 0 : g.value) == null ? void 0 : h.appearance}`)
      }, [
        H("tr", null, [
          H("td", {
            class: fe([
              "section",
              M(r).styles.spacerTop.value,
              M(r).styles.spacerBottom.value
            ]),
            style: Z([
              M(r).styles.spacerTopInline.value,
              M(r).styles.spacerBottomInline.value,
              `background-color: ${M(r).getHex("bg-default")};`,
              `color: ${M(r).getHex("fg-default")};`
            ]),
            bgcolor: M(r).getHex("bg-default")
          }, [
            H("table", {
              border: "0",
              cellpadding: "0",
              cellspacing: "0",
              width: "100%",
              valign: "top",
              align: "center",
              style: Z([
                "min-width: 100%;border-collapse: collapse;mso-table-lspace: 0;mso-table-rspace: 0;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;"
              ]),
              bgcolor: M(r).getHex("bg-default")
            }, [
              H("tbody", null, [
                ((v = t.data) == null ? void 0 : v.layoutDirection) === "row" ? (ue(), re("tr", $s, [
                  H("td", {
                    valign: "top",
                    width: ((x = t.data) == null ? void 0 : x.layoutDirection) === "row" ? "50%" : "100%",
                    class: "container-center",
                    style: Z([
                      `color: ${M(r).getHex("fg-onemphasis")};`,
                      `background-color: ${M(r).getHex("bg-default")};`,
                      ((_ = t.data) == null ? void 0 : _.layoutDirection) === "row" ? "padding-left:50px;padding-right:10px;width:100%;padding-bottom:15px;" : "display:block;text-align:center;width:100%;"
                    ]),
                    bgcolor: M(r).getHex("bg-default")
                  }, [
                    H("div", null, [
                      me(b, { content: M(a) }, null, 8, ["content"]),
                      me(b, { content: M(l) }, null, 8, ["content"]),
                      H("a", {
                        rel: "noopener",
                        target: "_blank",
                        href: M(i),
                        style: Z([...M(f), ...M(p)]),
                        class: "mobile-w-full"
                      }, Qe(((k = (S = (w = (y = M(r).data) == null ? void 0 : y.value) == null ? void 0 : w.buttonPrimary) == null ? void 0 : S[M(r).lang.value]) == null ? void 0 : k.text) || "Button"), 13, Os)
                    ])
                  ], 12, Ds),
                  H("td", {
                    valign: "top",
                    width: (($ = t.data) == null ? void 0 : $.layoutDirection) === "row" ? "50%" : "100%",
                    class: "container-center",
                    style: Z([
                      `color: ${M(r).getHex("fg-default")};`,
                      `background-color: ${M(r).getHex("bg-default")};`,
                      ((D = t.data) == null ? void 0 : D.layoutDirection) === "row" ? "padding-left:10px;padding-right:50px;width:100%;padding-bottom:15px;" : "display:block;text-align:center;"
                    ]),
                    bgcolor: M(r).getHex("bg-default")
                  }, [
                    H("div", null, [
                      me(b, { content: M(d) }, null, 8, ["content"]),
                      me(b, { content: M(o) }, null, 8, ["content"]),
                      H("a", {
                        rel: "noopener",
                        target: "_blank",
                        href: M(c),
                        style: Z([...M(f), ...M(n)]),
                        class: "mobile-w-full"
                      }, Qe(((L = (P = (A = (T = M(r).data) == null ? void 0 : T.value) == null ? void 0 : A.buttonSecondary) == null ? void 0 : P[M(r).lang.value]) == null ? void 0 : L.text) || "Button"), 13, Cs)
                    ])
                  ], 12, Ls)
                ])) : ge("", !0),
                ((E = t.data) == null ? void 0 : E.layoutDirection) === "column" ? (ue(), re("tr", Is, [
                  H("td", {
                    valign: "top",
                    width: ((C = t.data) == null ? void 0 : C.layoutDirection) === "row" ? "50%" : "100%",
                    class: "container-center",
                    style: Z([
                      `color: ${M(r).getHex("fg-default")};`,
                      `background-color: ${M(r).getHex("bg-default")};`,
                      ((R = t.data) == null ? void 0 : R.layoutDirection) === "row" ? "padding-left:50px;padding-right:10px;width:100%;" : "text-align:center;padding-bottom:15px;width:100%;padding-left:50px;padding-right:50px;"
                    ]),
                    bgcolor: M(r).getHex("bg-default")
                  }, [
                    H("div", Ps, [
                      me(b, { content: M(a) }, null, 8, ["content"]),
                      me(b, { content: M(l) }, null, 8, ["content"]),
                      H("a", {
                        rel: "noopener",
                        target: "_blank",
                        href: M(i),
                        style: Z([...M(f), ...M(p)]),
                        class: "mobile-w-full"
                      }, Qe(((O = (z = (F = (q = M(r).data) == null ? void 0 : q.value) == null ? void 0 : F.buttonPrimary) == null ? void 0 : z[M(r).lang.value]) == null ? void 0 : O.text) || "Button"), 13, qs)
                    ])
                  ], 12, Ns)
                ])) : ge("", !0),
                ((N = t.data) == null ? void 0 : N.layoutDirection) === "column" ? (ue(), re("tr", Us, [
                  H("td", {
                    valign: "top",
                    width: ((U = t.data) == null ? void 0 : U.layoutDirection) === "row" ? "50%" : "100%",
                    class: "container-center",
                    style: Z([
                      `color: ${M(r).getHex("fg-default")};`,
                      `background-color: ${M(r).getHex("bg-default")};`,
                      ((V = t.data) == null ? void 0 : V.layoutDirection) === "row" ? "padding-left:10px;padding-right:50px;width:100%;" : "text-align:center;width:100%;padding-left:50px;padding-right:50px;"
                    ]),
                    bgcolor: M(r).getHex("bg-default")
                  }, [
                    H("div", Rs, [
                      me(b, { content: M(d) }, null, 8, ["content"]),
                      me(b, { content: M(o) }, null, 8, ["content"]),
                      H("a", {
                        rel: "noopener",
                        target: "_blank",
                        href: M(c),
                        style: Z([...M(f), ...M(n)]),
                        class: "mobile-w-full"
                      }, Qe(((de = (se = (ne = (W = M(r).data) == null ? void 0 : W.value) == null ? void 0 : ne.buttonSecondary) == null ? void 0 : se[M(r).lang.value]) == null ? void 0 : de.text) || "Button"), 13, js)
                    ])
                  ], 12, Hs)
                ])) : ge("", !0)
              ])
            ], 8, As)
          ], 14, Es)
        ])
      ], 10, Ts);
    };
  }
}, zs = ["bgcolor"], Bs = ["bgcolor"], Ys = ["bgcolor"], Vs = ["bgcolor"], Gs = ["src"], Ws = ["bgcolor"], Qs = { class: "zero-padding" }, Zs = ["innerHTML"], Js = ["innerHTML"], Ks = {
  __name: "EmailListWithImage",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const r = Ce(e);
    return (u, i) => {
      var c, a, l, d;
      return ue(), re("table", {
        border: "0",
        cellpadding: "0",
        cellspacing: "0",
        width: "100%",
        valign: "top",
        align: "center",
        style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
        bgcolor: M(r).getHex("bg-default"),
        class: fe(`appearance-${(a = (c = M(r).data) == null ? void 0 : c.value) == null ? void 0 : a.appearance}`)
      }, [
        H("tbody", null, [
          H("tr", null, [
            H("td", {
              class: fe([
                M(r).styles.spacerTop.value,
                M(r).styles.spacerBottom.value,
                "section"
              ]),
              style: Z([
                M(r).styles.spacerTopInline.value,
                M(r).styles.spacerBottomInline.value,
                `background-color: ${M(r).getHex("bg-default")};`,
                `color: ${M(r).getHex("fg-muted")};`,
                "padding-left:50px;padding-right:50px;"
              ]),
              bgcolor: M(r).getHex("bg-default")
            }, [
              H("table", {
                border: "0",
                cellpadding: "0",
                cellspacing: "0",
                width: "100%",
                valign: "top",
                align: "center",
                style: Z([
                  "min-width: 100%;border-collapse: collapse;mso-table-lspace: 0;mso-table-rspace: 0;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;"
                ]),
                bgcolor: M(r).getHex("bg-default")
              }, [
                H("tbody", null, [
                  (ue(!0), re(Bt, null, Ur((d = (l = M(r).data) == null ? void 0 : l.value) == null ? void 0 : d.items, (o, f) => {
                    var p, n;
                    return ue(), re("tr", { key: o }, [
                      H("td", {
                        valign: "top",
                        width: "33%",
                        class: fe(["container-left", f !== 0 ? "mobile-spacer-top--medium" : ""]),
                        style: Z([
                          `color: ${M(r).getHex("fg-muted")};`,
                          `background-color: ${M(r).getHex("bg-default")};`,
                          "padding-bottom:15px;width:180px;"
                        ]),
                        bgcolor: M(r).getHex("bg-default")
                      }, [
                        o.image ? (ue(), re("img", {
                          key: 0,
                          src: M(r).getImageUrl({
                            url: o.image,
                            transformations: "tr:w-640,c-at_max_enlarge"
                          }),
                          width: "180",
                          alt: "image",
                          style: { width: "180px", display: "block" }
                        }, null, 8, Gs)) : ge("", !0)
                      ], 14, Vs),
                      H("td", {
                        valign: "top",
                        width: "67%",
                        class: "container-left",
                        style: Z([
                          `color: ${M(r).getHex("fg-muted")};`,
                          `background-color: ${M(r).getHex("bg-default")};`,
                          "padding-left:20px;padding-bottom:15px;width:345px;vertical-align:middle;"
                        ]),
                        bgcolor: M(r).getHex("bg-default")
                      }, [
                        H("div", Qs, [
                          H("p", {
                            style: { "font-weight": "600" },
                            innerHTML: ("sanitize" in u ? u.sanitize : M(Le))((p = o[M(r).lang.value]) == null ? void 0 : p.title)
                          }, null, 8, Zs)
                        ]),
                        H("div", {
                          class: "zero-padding",
                          style: { "font-weight": "100" },
                          innerHTML: ("sanitize" in u ? u.sanitize : M(Le))((n = o[M(r).lang.value]) == null ? void 0 : n.description)
                        }, null, 8, Js)
                      ], 12, Ws)
                    ]);
                  }), 128))
                ])
              ], 8, Ys)
            ], 14, Bs)
          ])
        ])
      ], 10, zs);
    };
  }
}, Xs = ["bgcolor"], eo = ["bgcolor"], to = ["bgcolor"], ro = ["bgcolor"], uo = {
  border: "0",
  cellpadding: "0",
  cellspacing: "0",
  width: "40",
  height: "40",
  valign: "top",
  align: "center",
  style: /* @__PURE__ */ Z([
    "border-collapse: collapse;mso-table-lspace: 0;mso-table-rspace: 0;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;display: table-row;"
  ])
}, no = ["bgcolor"], io = ["innerHTML"], ao = ["src"], so = ["bgcolor"], oo = { class: "zero-padding" }, co = ["innerHTML"], lo = ["innerHTML"], fo = {
  __name: "EmailListBasic",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const r = Ce(e), u = tt("config");
    return (i, c) => {
      var a, l, d, o;
      return ue(), re("table", {
        border: "0",
        cellpadding: "0",
        cellspacing: "0",
        width: "100%",
        valign: "top",
        align: "center",
        style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
        bgcolor: M(r).getHex("bg-default"),
        class: fe(`appearance-${(l = (a = M(r).data) == null ? void 0 : a.value) == null ? void 0 : l.appearance}`)
      }, [
        H("tbody", null, [
          H("tr", null, [
            H("td", {
              class: fe([
                M(r).styles.spacerTop.value,
                M(r).styles.spacerBottom.value,
                "section"
              ]),
              style: Z([
                M(r).styles.spacerTopInline.value,
                M(r).styles.spacerBottomInline.value,
                `background-color: ${M(r).getHex("bg-default")};`,
                `color: ${M(r).getHex("fg-muted")};`,
                "padding-left:50px;padding-right:50px;"
              ]),
              bgcolor: M(r).getHex("bg-default")
            }, [
              H("table", {
                border: "0",
                cellpadding: "0",
                cellspacing: "0",
                width: "100%",
                valign: "top",
                align: "left",
                style: Z([
                  "min-width: 100%;border-collapse: collapse;mso-table-lspace: 0;mso-table-rspace: 0;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;"
                ]),
                bgcolor: M(r).getHex("bg-default")
              }, [
                H("tbody", null, [
                  (ue(!0), re(Bt, null, Ur((o = (d = M(r).data) == null ? void 0 : d.value) == null ? void 0 : o.items, (f, p) => {
                    var n, s, m, b, g, h, v, x, _, y, w;
                    return ue(), re("tr", { key: f }, [
                      H("td", {
                        valign: "top",
                        class: "container-left",
                        style: Z([
                          `color: ${M(r).getHex("fg-muted")};`,
                          `background-color: ${M(r).getHex("bg-default")};`,
                          "width:100%;width:40px;height:40px;"
                        ]),
                        bgcolor: M(r).getHex("bg-default")
                      }, [
                        H("table", uo, [
                          H("tbody", null, [
                            H("tr", null, [
                              H("td", {
                                width: "40",
                                height: "40",
                                style: Z([
                                  `background-color: ${M(r).getHex("bg-emphasis-muted")};`,
                                  "width:40px;height:40px;vertical-align: middle;display: table-cell;"
                                ]),
                                bgcolor: M(r).getHex("bg-default"),
                                align: "center"
                              }, [
                                ((s = (n = M(r).data) == null ? void 0 : n.value) == null ? void 0 : s.itemDecoration) === "number" ? (ue(), re("p", {
                                  key: 0,
                                  style: Z([
                                    `color: ${M(r).getHex("fg-accent")};`,
                                    "text-align:center;font-weight:600;margin:0 auto;"
                                  ]),
                                  innerHTML: ("sanitize" in i ? i.sanitize : M(Le))(p + 1)
                                }, null, 12, io)) : ge("", !0),
                                ((b = (m = M(r).data) == null ? void 0 : m.value) == null ? void 0 : b.itemDecoration) === "icon" && f.icon ? (ue(), re("img", {
                                  key: 1,
                                  src: `${M(u).imagekit}${M(u).imagekit ? "/" : ""}${(g = M(u).origin) == null ? void 0 : g.replace("localhost:3000", M(u).devDomain)}/api/public/icons/${encodeURIComponent(M(r).getHex("fg-accent"))}/${f.icon}.png`,
                                  width: "20",
                                  height: "20",
                                  style: { "font-weight": "600", margin: "0 auto", width: "20px", height: "20px", "max-width": "20px", "max-height": "20px", display: "block" },
                                  class: "pt-0",
                                  alt: "icon"
                                }, null, 8, ao)) : ge("", !0)
                              ], 12, no)
                            ])
                          ])
                        ])
                      ], 12, ro),
                      H("td", {
                        valign: "top",
                        width: "485",
                        class: "container-left",
                        style: Z([
                          `color: ${M(r).getHex("fg-muted")};`,
                          `background-color: ${M(r).getHex("bg-default")};`,
                          "padding-left:20px;width:485px;vertical-align: middle;",
                          !((h = f[M(r).lang.value]) != null && h.title) || !((v = f[M(r).lang.value]) != null && v.description) ? "padding-top: 8px;padding-bottom: 15px" : "padding-bottom:15px"
                        ]),
                        bgcolor: M(r).getHex("bg-default")
                      }, [
                        H("div", oo, [
                          H("p", {
                            style: Z([
                              "font-weight:600;",
                              (!((x = f[M(r).lang.value]) != null && x.description) || ((_ = f[M(r).lang.value]) == null ? void 0 : _.description) === "<p></p>", "")
                            ]),
                            innerHTML: ("sanitize" in i ? i.sanitize : M(Le))((y = f[M(r).lang.value]) == null ? void 0 : y.title)
                          }, null, 12, co)
                        ]),
                        H("div", {
                          class: "zero-padding",
                          style: { "font-weight": "100" },
                          innerHTML: ("sanitize" in i ? i.sanitize : M(Le))((w = f[M(r).lang.value]) == null ? void 0 : w.description)
                        }, null, 8, lo)
                      ], 12, so)
                    ]);
                  }), 128))
                ])
              ], 8, to)
            ], 14, eo)
          ])
        ])
      ], 10, Xs);
    };
  }
}, ho = ["bgcolor"], po = ["bgcolor"], mo = ["href"], bo = ["src"], go = {
  __name: "EmailMapBasic",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    apiKey: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, r = Ce(t), u = tt("config"), i = Q(() => {
      var d, o;
      return ((o = (d = r.data) == null ? void 0 : d.value) == null ? void 0 : o.markerPlace) || "Madison Square Garden";
    }), c = Q(() => encodeURIComponent(`https://maps.googleapis.com/maps/api/staticmap?center=${l(i.value)}&size=640x320&scale=2&key=${t.apiKey}&markers=color:red|size:large|${l(i.value)}.png`)), a = Q(() => `https://www.google.com/maps/search/?api=1&query=${l(i.value)}`), l = (d) => encodeURIComponent(d).replace(/[!'()*]/g, (o) => `%${o.charCodeAt(0).toString(16)}`);
    return (d, o) => {
      var f, p;
      return ue(), re("table", {
        border: "0",
        cellpadding: "0",
        cellspacing: "0",
        width: "100%",
        valign: "top",
        align: "center",
        style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
        bgcolor: M(r).getHex("bg-default"),
        class: fe(`appearance-${(p = (f = M(r).data) == null ? void 0 : f.value) == null ? void 0 : p.appearance}`)
      }, [
        H("tbody", null, [
          H("tr", null, [
            H("td", {
              class: fe([
                M(r).styles.spacerTop.value,
                M(r).styles.spacerBottom.value
              ]),
              style: Z([
                `background-color: ${M(r).getHex("bg-default")};`,
                M(r).styles.spacerTopInline.value,
                M(r).styles.spacerBottomInline.value
              ]),
              bgcolor: M(r).getHex("bg-default"),
              align: "center"
            }, [
              H("a", {
                href: M(a),
                target: "_blank"
              }, [
                M(c) ? (ue(), re("img", {
                  key: 0,
                  src: `${M(u).imagekit}${M(u).imagekit ? "/tr:w-1280,c-at_max/" : ""}${M(c)}`,
                  width: "640",
                  alt: "map",
                  style: { width: "640px", "max-width": "100%", display: "block" }
                }, null, 8, bo)) : ge("", !0)
              ], 8, mo)
            ], 14, po)
          ])
        ])
      ], 10, ho);
    };
  }
}, yo = ["bgcolor"], vo = ["bgcolor"], xo = ["bgcolor"], wo = ["bgcolor"], _o = ["innerHTML"], So = {
  __name: "EmailGuestDetailsAppAccess",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    guest: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e, r = Ce(t), u = Q(() => {
      var c, a;
      const i = String(((a = (c = t.guest) == null ? void 0 : c.guestAppData) == null ? void 0 : a.accessCode) || "");
      return i.length !== 6 && console.warn("Invalid access code", i), `${i.slice(0, 3)} ${i.slice(3)}`;
    });
    return (i, c) => {
      var a, l;
      return ue(), re("table", {
        border: "0",
        cellpadding: "0",
        cellspacing: "0",
        width: "100%",
        valign: "top",
        align: "center",
        style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
        bgcolor: M(r).getHex("bg-default"),
        class: fe(`appearance-${(l = (a = M(r).data) == null ? void 0 : a.value) == null ? void 0 : l.appearance}`)
      }, [
        H("tbody", null, [
          H("tr", null, [
            H("td", {
              class: fe([
                "section",
                M(r).styles.spacerTop.value,
                M(r).styles.spacerBottom.value
              ]),
              style: Z([
                `background-color: ${M(r).getHex("bg-default")};`,
                M(r).styles.spacerTopInline.value,
                M(r).styles.spacerBottomInline.value,
                `color: ${M(r).getHex("fg-muted")};`,
                "padding-left:50px;padding-right:50px;width:100%;text-align:center;"
              ]),
              bgcolor: M(r).getHex("bg-default")
            }, [
              H("table", {
                border: "0",
                cellpadding: "0",
                cellspacing: "0",
                width: "100%",
                valign: "top",
                align: "center",
                style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
                bgcolor: M(r).getHex("bg-default")
              }, [
                H("tbody", null, [
                  H("tr", null, [
                    H("td", {
                      style: Z([
                        `background-color: ${M(r).getHex("bg-subtle")};`,
                        `color: ${M(r).getHex("fg-muted")};`,
                        "padding-top:10px;padding-bottom:10px;width:100%;text-align:center;"
                      ]),
                      bgcolor: M(r).getHex("bg-default")
                    }, [
                      H("h2", {
                        innerHTML: ("sanitize" in i ? i.sanitize : M(Le))(M(u))
                      }, null, 8, _o)
                    ], 12, wo)
                  ])
                ])
              ], 8, xo)
            ], 14, vo)
          ])
        ])
      ], 10, yo);
    };
  }
}, Mo = ["bgcolor"], ko = ["bgcolor"], To = ["innerHTML"], Eo = {
  __name: "EmailSalutationBasic",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    salutation: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e, r = Ce(t), u = Q(() => {
      var a, l, d, o, f, p, n, s;
      const i = ((o = (l = (a = r.data) == null ? void 0 : a.value) == null ? void 0 : l[r.lang.value]) == null ? void 0 : o[((d = t.salutation) == null ? void 0 : d.gender) === "male" ? "malePrefix" : "femalePrefix"]) || "", c = ((s = t.salutation) == null ? void 0 : s[(n = (p = (f = r.data) == null ? void 0 : f.value) == null ? void 0 : p[r.lang.value]) == null ? void 0 : n.variableProperty]) || "";
      return `${i}${c ? " " : ""}${c},`;
    });
    return (i, c) => {
      var a, l;
      return ue(), re("table", {
        border: "0",
        cellpadding: "0",
        cellspacing: "0",
        width: "100%",
        valign: "top",
        align: "center",
        style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
        bgcolor: M(r).getHex("bg-default"),
        class: fe(`appearance-${(l = (a = M(r).data) == null ? void 0 : a.value) == null ? void 0 : l.appearance}`)
      }, [
        H("tbody", null, [
          H("tr", null, [
            H("td", {
              class: fe([
                "section",
                M(r).styles.spacerTop.value,
                M(r).styles.spacerBottom.value
              ]),
              style: Z([
                M(r).styles.textAlignment.value,
                `color: ${M(r).getHex("fg-muted")};`,
                `background-color: ${M(r).getHex("bg-default")};`,
                "padding-left:50px;padding-right:50px;width:100%;",
                M(r).styles.spacerTopInline.value,
                M(r).styles.spacerBottomInline.value
              ]),
              bgcolor: M(r).getHex("bg-default")
            }, [
              H("p", {
                innerHTML: ("sanitize" in i ? i.sanitize : M(Le))(M(u))
              }, null, 8, To)
            ], 14, ko)
          ])
        ])
      ], 10, Mo);
    };
  }
}, Ao = ["bgcolor"], $o = ["bgcolor"], Do = ["bgcolor"], Oo = ["bgcolor"], Lo = ["src"], Co = ["bgcolor"], Io = ["bgcolor"], No = ["innerHTML"], Po = ["bgcolor"], qo = ["innerHTML"], Uo = {
  __name: "EmailGuestDetailsBasic",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    activePage: {
      type: Object,
      default: () => ({})
    },
    guest: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e, r = Ce(t), u = tt("config"), i = tt("event"), c = {
      cs: "Celé jméno",
      en: "Name",
      sk: "Celé meno",
      pl: "Imię i nazwisko",
      hu: "Teljes név",
      de: "Vollständiger Name",
      es: "Nombre y apellidos",
      fr: "Nom complet"
    }, a = {
      cs: "E-mail",
      en: "Email",
      sk: "Email",
      pl: "Email",
      hu: "Email",
      de: "E-Mail",
      es: "Correo electrónico",
      fr: "Email"
    }, l = {
      cs: "Spolubydlící",
      en: "Roommates",
      sk: "Spolubývajúci",
      pl: "Współlokatorzy",
      hu: "Szobatársak",
      de: "Mitbewohner",
      es: "Compañeros de habitación",
      fr: "Colocataires"
    }, d = Q(() => {
      var n, s, m, b, g, h, v, x, _, y, w, S, k, $, D, T, A, P, L, E, C, R, q, F, z, O, N, U, V, W, ne, se, de, be, oe, I, B, j, G, ce, le, Ie, Ne, X, ee, Fe, ie, ae, Pe, Me;
      const o = ((s = (n = t.guest) == null ? void 0 : n.status) == null ? void 0 : s.confirmation) > 1 ? ` +${((b = (m = t.guest) == null ? void 0 : m.status) == null ? void 0 : b.confirmation) - 1}` : "", f = [];
      ((v = (h = (g = r.data) == null ? void 0 : g.value) == null ? void 0 : h.shownElements) == null ? void 0 : v.fullName) === !0 && f.push({
        key: c[(_ = (x = t.guest) == null ? void 0 : x.properties) == null ? void 0 : _.lang],
        value: `${((w = (y = t.guest) == null ? void 0 : y.properties) == null ? void 0 : w.firstName) || ""} ${((k = (S = t.guest) == null ? void 0 : S.properties) == null ? void 0 : k.lastName) || ""}${o}`,
        position: -2
      }), ((T = (D = ($ = r.data) == null ? void 0 : $.value) == null ? void 0 : D.shownElements) == null ? void 0 : T.email) === !0 && f.push({
        key: a[(P = (A = t.guest) == null ? void 0 : A.properties) == null ? void 0 : P.lang],
        value: ((E = (L = t.guest) == null ? void 0 : L.properties) == null ? void 0 : E.email) || "",
        position: -1
      });
      let p = 0;
      for (const [he, qe] of Object.entries(((C = t.guest) == null ? void 0 : C.properties) || {})) {
        const Te = (F = (q = (R = i.value) == null ? void 0 : R.guestlist) == null ? void 0 : q.properties) == null ? void 0 : F.find((_e) => _e.id === he);
        if (Te) {
          const _e = (U = (N = (O = (z = t.activePage) == null ? void 0 : z.sections) == null ? void 0 : O.find((Se) => Se.type === "formBasic")) == null ? void 0 : N.data) == null ? void 0 : U.fields, ze = _e == null ? void 0 : _e.find((Se) => Se.propertyId === he), Vn = (ze == null ? void 0 : ze.visibility) === "visible" || (ze == null ? void 0 : ze.visibility) === "condition" && ((V = ze == null ? void 0 : ze.visibleOnlyTo) == null ? void 0 : V.some((Se) => {
            var ut, Ue, nt, ft, dt;
            return (dt = (nt = (ut = t.guest) == null ? void 0 : ut.properties) == null ? void 0 : nt[(Ue = Se.split("/")) == null ? void 0 : Ue[0]]) == null ? void 0 : dt.includes((ft = Se.split("/")) == null ? void 0 : ft[1]);
          })), Gn = (se = (ne = (W = r.data) == null ? void 0 : W.value) == null ? void 0 : ne.selectedProperties) == null ? void 0 : se.includes(he);
          if (((be = (de = r.data) == null ? void 0 : de.value) == null ? void 0 : be.propertySource) === "shownInForm" && Vn || ((I = (oe = r.data) == null ? void 0 : oe.value) == null ? void 0 : I.propertySource) === "customSelection" && Gn) {
            let Se = qe;
            if ((Te.type === "select" || Te.type === "multiSelect") && (Se = (Array.isArray(Se) ? qe : [qe]).filter(Boolean).map((Ue) => {
              var ft, dt, Wr, Qr;
              return (Qr = ((ft = Te.options) == null ? void 0 : ft.find((Wn) => Wn.id === Ue))[`_${(Wr = (dt = t.guest) == null ? void 0 : dt.properties) == null ? void 0 : Wr.lang}`]) == null ? void 0 : Qr.value;
            }).join(", ")), Se != null && Se.length) {
              let ut = p;
              if (((j = (B = r.data) == null ? void 0 : B.value) == null ? void 0 : j.propertySource) === "shownInForm") {
                const Ue = _e == null ? void 0 : _e.findIndex((nt) => nt.propertyId === he);
                ut = Ue !== -1 ? Ue : p;
              }
              if (((ce = (G = r.data) == null ? void 0 : G.value) == null ? void 0 : ce.propertySource) === "customSelection") {
                const Ue = (Ne = (Ie = (le = r.data) == null ? void 0 : le.value) == null ? void 0 : Ie.selectedProperties) == null ? void 0 : Ne.findIndex((nt) => nt === he);
                ut = Ue !== -1 ? Ue : p;
              }
              f.push({
                key: (Fe = Te[`_${(ee = (X = t.guest) == null ? void 0 : X.properties) == null ? void 0 : ee.lang}`]) == null ? void 0 : Fe.name,
                value: Se,
                position: ut
              });
            }
          }
        }
        p++;
      }
      if ((ae = (ie = t.guest) == null ? void 0 : ie.extras) != null && ae.roommates && Array.isArray(t.guest.extras.roommates) && t.guest.extras.roommates.length > 0) {
        const he = t.guest.extras.roommates.map((qe) => {
          var Te, _e;
          return `${((Te = qe.properties) == null ? void 0 : Te.firstName) || ""} ${((_e = qe.properties) == null ? void 0 : _e.lastName) || ""}`.trim();
        }).filter(Boolean).join(", ");
        he && f.push({
          key: l[(Me = (Pe = t.guest) == null ? void 0 : Pe.properties) == null ? void 0 : Me.lang],
          value: he,
          position: 1e3
        });
      }
      return f.sort((he, qe) => he.position - qe.position);
    });
    return (o, f) => {
      var p, n, s, m, b, g, h, v;
      return ue(), re("table", {
        border: "0",
        cellpadding: "0",
        cellspacing: "0",
        width: "100%",
        valign: "top",
        align: "center",
        style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%" },
        bgcolor: M(r).getHex("bg-default"),
        class: fe(`appearance-${(n = (p = M(r).data) == null ? void 0 : p.value) == null ? void 0 : n.appearance}`)
      }, [
        H("tbody", null, [
          H("tr", null, [
            H("td", {
              class: fe([
                "section",
                M(r).styles.spacerTop.value,
                M(r).styles.spacerBottom.value
              ]),
              style: Z([
                `background-color: ${M(r).getHex("bg-default")};`,
                "padding-left:50px;padding-right:50px;width:100%;",
                M(r).styles.spacerTopInline.value,
                M(r).styles.spacerBottomInline.value
              ]),
              bgcolor: M(r).getHex("bg-default")
            }, [
              ((b = (m = (s = M(r).data) == null ? void 0 : s.value) == null ? void 0 : m.shownElements) == null ? void 0 : b.qrCode) === !0 ? (ue(), re("table", {
                key: 0,
                border: "0",
                cellpadding: "0",
                cellspacing: "0",
                width: "100%",
                valign: "top",
                align: "center",
                style: { "min-width": "100%", "border-collapse": "collapse", "mso-table-lspace": "0", "mso-table-rspace": "0", "-ms-text-size-adjust": "100%", "-webkit-text-size-adjust": "100%", "margin-bottom": "16px !important" },
                bgcolor: M(r).getHex("bg-default")
              }, [
                H("tr", null, [
                  H("td", {
                    style: Z([
                      `border: solid 1px ${M(r).getHex("border-muted")};`,
                      "background-color:white;padding-bottom:16px;padding-top:16px;"
                    ]),
                    bgcolor: M(r).getHex("bg-default"),
                    align: "center"
                  }, [
                    (g = t.guest) != null && g._id ? (ue(), re("img", {
                      key: 0,
                      src: `${M(u).imagekit}${M(u).imagekit ? "/tr:w-270/" : ""}${(h = M(u).origin) == null ? void 0 : h.replace("localhost:3000", M(u).devDomain)}/api/public/guests/${(v = t.guest) == null ? void 0 : v._id}/qrcode.png`,
                      alt: "qr",
                      width: "180",
                      height: "180",
                      style: { margin: "0 auto", width: "180px", height: "180px", "max-width": "180px", "max-height": "180px", display: "block" }
                    }, null, 8, Lo)) : ge("", !0)
                  ], 12, Oo)
                ])
              ], 8, Do)) : ge("", !0),
              H("table", {
                border: "0",
                cellpadding: "0",
                cellspacing: "0",
                width: "100%",
                valign: "top",
                align: "center",
                style: Z([
                  "min-width: 100%;border-collapse: collapse;mso-table-lspace: 0;mso-table-rspace: 0;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;"
                ]),
                bgcolor: M(r).getHex("bg-default")
              }, [
                (ue(!0), re(Bt, null, Ur(M(d), (x) => (ue(), re("tr", {
                  key: x.key
                }, [
                  H("td", {
                    valign: "top",
                    width: "33%",
                    class: "container-left guest-details-basic-key",
                    style: Z([
                      `color: ${M(r).getHex("fg-subtle")};`,
                      `background-color: ${M(r).getHex("bg-default")};`,
                      "text-align:left;width:180px;text-transform:uppercase;padding-top:6px;padding-bottom:6px;"
                    ]),
                    bgcolor: M(r).getHex("bg-default")
                  }, [
                    H("h4", {
                      class: "",
                      style: { "font-size": "14px", "font-weight": "600", "padding-right": "15px" },
                      innerHTML: ("sanitize" in o ? o.sanitize : M(Le))(x.key)
                    }, null, 8, No)
                  ], 12, Io),
                  H("td", {
                    valign: "top",
                    width: "67%",
                    class: "container-left guest-details-basic-value",
                    style: Z([
                      `color: ${M(r).getHex("fg-muted")};`,
                      `background-color: ${M(r).getHex("bg-default")};`,
                      "text-align:left;width:360px;padding-top:6px;padding-bottom:6px;"
                    ]),
                    bgcolor: M(r).getHex("bg-default")
                  }, [
                    H("h4", {
                      class: "",
                      style: { "font-size": "14px" },
                      innerHTML: ("sanitize" in o ? o.sanitize : M(Le))(x.value)
                    }, null, 8, qo)
                  ], 12, Po)
                ]))), 128))
              ], 8, Co)
            ], 14, $o)
          ])
        ])
      ], 10, Ao);
    };
  }
}, Ho = {
  props: {
    content: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return () => ge((e.content || "").replaceAll("<!--", "").replaceAll("-->", ""));
  }
}, Ro = {
  props: {
    content: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return () => e.content ? Kn("style", { innerHTML: (e.content || "").replaceAll("<style>", "").replaceAll("</style>", "") }) : ge("");
  }
}, Fo = function(e) {
  e.component("EmailContainer", os), e.component("EmailTextBasic", ds), e.component("EmailComment", Ho), e.component("EmailStyleTag", Ro), e.component("EmailImageBasic", gs), e.component("EmailDividerBasic", xs), e.component("EmailButtonBasic", ks), e.component("EmailButtonGroup", Fs), e.component("EmailListWithImage", Ks), e.component("EmailListBasic", fo), e.component("EmailMapBasic", go), e.component("EmailGuestDetailsAppAccess", So), e.component("EmailSalutationBasic", Eo), e.component("EmailGuestDetailsBasic", Uo);
};
export {
  Fo as install
};
